import React, {Component} from 'react'
import styled  from 'styled-components'
import Autosuggest from 'react-autosuggest';
import LoadingProgress from 'react-js-loading-progress-bar';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { renderIntoDocument } from 'react-dom/test-utils';
import fire from '../../../database/firebase';
import ClipLoader from "react-spinners/ClipLoader";
import shortid from 'shortid';
import Members from '../Members/Members'
import Campaigns from '../Campaigns/Campaigns'
import Popup from '../../../Components/Business-Side/Popups/Popup'
import PopupRewards from '../../../Components/Business-Side/Popups/PopupRewards';
import { FOCUSABLE_SELECTOR } from '@testing-library/user-event/dist/utils';
import { add, max } from 'date-fns';
import { roundToNearestMinutesWithOptions } from 'date-fns/fp';
import Analytics from '../Analytics/Analytics';
import SearchBox from "react-search-box";

const animatedComponents = makeAnimated();

const Styles = styled.div  `

    // - - - - - SEARCH BOX - - - - - //

.search-box {
    padding: 5%;
}

    // - SEARCH BAR OPTIONS - //

.searchBarOptions button {
    margin-top: 0.90%;
    margin-left: 1%;
    background-color: #fff;
    color: #0930cb;
    font-family: sora;
    border-radius: 8px;
    font-size: 75%;
    padding: 0.75%;
    padding-left: 1.25%;
    padding-right: 1.25%;
    border: 1.5px solid #0930cb;
    font-weight: bold;
}

    // - - - - - HEADER - - - - - //

header:after {
    display: table;
    content: "";
    clear: both;
}

.headerCol1 {
    text-align: center;
    float: left;
    width: 22%;
    background-color: #F0F0F0;
    height: 100vh;
    position: relative;
}

.headerCol1 h1 {
    font-size: 45px;
}

.headerCol2 {
    text-align: center;
    float: left;
    width: 78%;
    height: 100vh;
    overflow-y: scroll;  
    // background-image: url('./assets/planeHomeBg.png');
    // background-size: cover;
    // background-position: center; 
}

.topBanner {
    margin-top: 1.5%;
    margin-left: 3%;
}

.topBanner:after {
    display: table;
    clear: both;
    content: "";
}

.topLeftCol {
    float: left;
    text-align: center;
    width: 60%;
}

.topRightCol {
    float: left;
    text-align: left;
    width: 40%;
}

.topRightCol button {
    margin-top: 3.25%;
    // height: 30px;
    padding: 3.5%;
    width: 50%;
    background-color: #0930CB;
    color: white;
    border-radius: 6px;
    border: 2px solid transparent;
    font-family: Arvo;
    cursor: pointer;
    font-size: 15.5px;
    font-weight: bold;
}

    // - - SIDEBAR CATEGORIES - - //

.sidebarCategories {
    margin: auto;
    // width: 60%;
    margin-top: 10%;
    padding-left: 25%;
}

.sidebarCategories:after {
    content: "";
    display: table;
    clear: both;
}

.sideBarLogo {
    text-align: right;
    width: 27.5%;
    float: left;
    margin-bottom: 8.5%;
}

.sideBarLabel {
    text-align: left;
    width: 72.5%;
    float: left;
    margin-bottom: 8.5%;
}

.sidebarInvisibleContainer {
    margin-top: 38.5%;
}

.sidebarInvisibleContainer2 {
    margin-top: 5.5%;
}

.sideBarLogo img {
    width: 37.5%;
    // margin-top: 5%;
}

.sideBarLabel h3 {
    font-family: arvo;
    margin-top: 3.5%;
    margin-left: 14.5%;
    font-size: 20.5px;
}

.sideBarLabel h3:hover {
    text-decoration: underline;
    cursor: pointer;
}

.sidepaneFooter {
    position: absolute;
    bottom: 0;
    left: 0;
    margin-left: 60px;
    margin-bottom: 15px;
    font-weight: bold;
}

.sidepaneFooter p {
    font-family: arvo;
    font-size: 16.5px;
}

    // - - - - - SEARCH BOX - - - - - //

.react-autosuggest__container {
    position: relative;
    text-align: left;
    width: 80%;
}

.react-autosuggest__input {
    margin-top: 3%;
    width: 100%;
    height: 30px;
    padding: 10px 20px;
    font-family: Helvetica, sans-serif;
    font-weight: 300;
    font-size: 16px;
    border: 1px solid #aaa;
    border-radius: 10px;
    margin-right: 0px;
}

.react-autosuggest__input--focused {
    outline: none;
    border-radius: 10px;
}

.react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.react-autosuggest__suggestions-container {
    display: none;
}

.react-autosuggest__suggestions-container--open {
    display: block;
    position: absolute;
    margin-top: 5%;
    margin-left: 0%;
    top: 51px;
    width: 80%;
    border: 1px solid #aaa;
    background-color: #fff;
    font-family: Helvetica, sans-serif;
    font-weight: 300;
    font-size: 16px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    z-index: 2;
    border-radius: 10px;
    padding: 0.5%;
}

.react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
}

.react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
    border-radius: 8px;
}

    // - - - - - CONTENT CONTAINER - - - - - //


.allPostsContainer {
    margin-left: 3%;
    text-align: left;
}

.allPostsContainer h1 {
    font-family: Arvo;
    text-align: left;
    font-weight: bold;
    margin-top: 1.5%;
    margin-bottom: 0px;
    color: #0930CB;
}

    // - - TOP DASHBOARD - - //

.topDashboard {
    margin-bottom: 11%;
    margin-top: 1%;
    padding-bottom: 4%;
}

.topDashboards:after {
    display: table;
    content: "";
    clear: both;
}

.topDashCol {
    float: left;
    text-align: center;
    width: 33.3%;
}

.topDashCard {
    width: 80%;
    height: 20vh;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
    border-radius: 8px;
}

.topDashCard:after {
    content: "";
    clear: both;
    display: table;
}

.dashImg {
    float: left;
    text-align: center;
    width: 40%;
    height: 50%;
}

.dashLabel {
    float: left;
    text-align: left;
    width: 60%;
    height: 50%;
    margin-bottom: 7.5%;
}

    // - - TOP DASHBOARD IMG - - //

.imgContainer {
    margin-left: 20%;
    margin-top: 15%;
    width: 57.5%;
    height: 80%;
    background-color: #0930CB;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
}

.imgContainer img {
    width: 50%;
}

    // - - TOP DASHBOARD LABEL - - //

.dashLabel h2 {
    font-family: Arvo;
    color: #0930CB;
    margin-bottom: 0px;
}

.dashLabel p {
    margin-top: 0px;
    font-family: Arvo;
    font-size: 13px;
    text-decoration: underline;
    color: #0930CB;
}

.dashLabel button {
    all: unset;
}

.activeMemberStyle {
    font-size: 20px;
    margin-bottom: 1.5%;
}

.selectMenu {
    width: 100%;
    // height: 10px;
}

.selectMenu2 {
    width: 90%;
    // height: 10px;
}

.selectMenu3 {
    width: 95%;
    // height: 10px;
    text-align: left;
    padding-top: 1%;
    margin-right: 5%;
}

.selectMenu4 {
    margin-left: 5%;
    width: 65%;
    margin-bottom: 1.5%;
}

.selectMenu5 {
    width: 85%;
}

    // - - DASHBOARD FIGURE - - //

.dashboardFigure {

}

.dashboardFigure h1 {
    padding-top: 10%;
    margin-left: 8%;
    padding-top: 5%;
    font-size: 30px;
}

    // - - VIEW MORE DATA POINTS - - //

.moreDataPoints {
    padding-top: 1%;
    margin-bottom: 0.75%;
}
.moreDataPoints p {
    // margin-top: 10.5%;
    margin-bottom: 0px;
    font-family: arvo;
    font-size: 15.5px;
    color: #0930CB;
    margin-left: 0.5%;
}

.moreDataPoints p:hover {
    
}

.moreDataPoints label:hover {
    text-decoration: underline;
    cursor: pointer;
}
        // - - MIDDLE SECTION - - //

.middleHomepage:after {
    content: "";
    display: table;
    clear: both;
}

.middleHomepageLeft {
    text-align: left;
    width: 50%;
    float: left;
}

.middleHomepageRight {
    text-align: center;
    width: 50%;
    float: left;
}

    // - - EXPLORE PLANS BTNS - - //

.explorePlansBtn {
    text-align: left;
    width: 100%;
}

.explorePlansBtn button {
    margin-top: 3.5%;
    font-size: 40px;
    background-color: white;
    font-family: Arvo;
    padding: 4%;
    border: 2px solid transparent;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
    border-radius: 8.5px;
    cursor: pointer;
}

.explorePlansBtn button:hover {
    background-color: #0930CB;
    color: white;
    font-weight: bold;
    border: 2px solid transparent;
}

    // - - HOME QUICK BUTTONS - - //

.homeQuickBtnsContainer:after {
    content: "";
    display: table;
    clear: both;
}

.homeQuickBtn {
    float: left;
    text-align: center;
    width: 33%;
    margin-top: 3.5%;
}

.quickBtn {
    height: 17.5vh;
    width: 85%;
    position: relative;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
    border: 2px solid transparent;
    border-radius: 7.5px;
    background-color: white;
}


.quickBtn:hover {
    background-color: #0930CB;
    color: white;
    cursor: pointer;
}

.quickBtn h1 {
    margin-left: 5px;
    padding-top: 1%;
}

.quickBtn h3 {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 10px;
    text-align: right;
    font-family: arvo; 
    
}

.middleHomepageRight {

}

.recentActivityHomepage {
    width: 95%;
    background-color: #0930cb;
    height: 48.5vh;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.20), 0 6px 20px 0 rgba(0, 0, 0, 0.20);

}

.recentActivityHomepageContainer:after {
    content: "";
    display: table;
    clear: both;
}

.recentActivityHeading {
    text-align: center;
    width: 50%;
    float: left;
}

.recentActivityOptions {
    text-align: center;
    width: 50%;
    float: left;
}

.recentActivityData {
    position: relative;
    overflow-y: scroll;
    margin: auto;
    width: 95%;
    background-color: white;
    height: 86.5%;
    border-radius: 7.5px;
    border: 1px solid #0930cb;
}

.newNotificationsLabel {
    position: absolute;
    top: 3%;
    left: 50%;
    font-size: 85%;
    color: white;
    font-family: gabarito;
    transform: translateX(-50%);
    background-color: #0930cb;
    border-radius: 20px;
    border: 1px solid #0930cb;
    padding: 5px 10px;
    z-index: 1; /* Ensure it's above the recent activity data */
}

.recentActivityCell {
    width: 100%;
    padding-bottom: 1%;
    border-bottom: 0.5px solid black;
    height: 13%;
}

.recentActivityCell:after {
    content: "";
    display: table;
    clear: both;
}

.recentActivityCellImg {
    text-align: right;
    width: 10%;
    float: left;
}

.recentActivityCellLabel {
    text-align: left;
    width: 70%;
    float: left;
}

.recentActivityCellTimestamp {
    text-align: center;
    width: 20%;
    float: left;
}

.recentActivityCellImg img {
    margin-top: 27.5%;
    width: 60%;
}

.recentActivityCellLabel h3 {
    margin-top: 5.75%;
    margin-left: 3.5%;
    font-family: gabarito;
    color: #0930cb;
    font-size: 15px;
}

.recentActivityCellTimestamp p {
    margin-top: 23.75%;
    font-size: 12px;
    font-family: arvo;
    color: #0930CB;
}

.recentActivityHomepage h2 { 
    text-align: left;
    padding-left: 2.5%;
    padding-top: 0%;
    font-family: arvo;
    color: #0930CB;
    font-size: 15px;
    font-weight: bold;
}

    // - - LOADING SCREEN (RIGHT PANEL) - - //

.loadingScreenRightPanel {
    margin-top: 22.5%;
}

    // - - REWARDS BUTTONS - - //

.rewardsBtnContainer {
    margin-top: 2%;
    margin-left: 3%;
    text-align: left;
}

.rewardsBtnContainer h1 {
    font-family: Arvo;
    text-align: left;
    font-weight: bold;
    // padding-top: 10%;
    margin-bottom: 0%;
    color: #0930CB;
}

.rewardsHeader button {
    all: unset;
    background-color: white;
    border: 2px solid #0930CB;
    padding: 1%;
    margin-top: 1%;
    height: 55%;
    border-radius: 7px;
    font-family: Arvo;
    font-size: 16px;
    cursor: pointer;
    width: 2.5%;
    text-align: center;
}

.rewardsHeader button:hover {
    background-color: #0930CB;
    color: white;
    font-weight: bold;
}

.rewardsInnerContainer {
    margin-top: 2%;
}

.rewardsBtn button {
    width: 60%;
    padding: 2.5%;
    cursor: pointer;
    margin-bottom: 2%;
    border-radius: 8px;
    border: 2px solid transparent;
    font-size: 27.5px;
    font-family: Arvo;
    font-weight: bold;
}

.rewardsBtn button:hover {
    background-color: #0930CB;
    color: white;
}

.rewardsBtn button:hover .rewardsBtnInnerTag {
    color: white;
}

.rewardsBtn label {
    font-size: 15px;
    font-family: gabarito;
    color: #0930cb;
}

    // - - POINTS CONTAINER BUTTONS - - //

.pointsComponentOptions {
    margin-top: 1%;
    margin-bottom: 2%;
}

.pointsComponentOptions:after {
    content: "";
    display: table;
    clear: both;
}

.pointsComponentOptionsBtn {
    float: left;
    text-align: left;
    width: 20%;
}

.pointsComponentBtnContainer {
    width: 80%;
    background-color: white;
    border: 2px solid #0930cb;
    border-radius: 8px;
    display: flex;
    align-items: center;
}

.pointsComponentBtnContainer:after {
    content: "";
    display: table;
    clear: both;
}

.pointsComponentBtnImg {
    float: left;
    width: 30%;
    text-align: right;
}

.pointsComponentBtnLabel {
    float: left;
    width: 70%;
    text-align: left;
}

.pointsComponentBtnImg img {
    width: 70%;
    // margin-left: 100%;
}

.pointsComponentBtnLabel p {
    font-family: Arvo;
    // color: #0930cb;
    font-weight: bold;
    padding-top: 0.5%;
    padding-bottom: 0.5%;
    padding-left: 7.5%;
    font-size: 18.5px;
}

    // - - POINTS CONTAINER - - //

.pointsContainer {
    height: 100%;
    margin-left: 3%;
    text-align: left;
    margin-right: 3%;
    padding-bottom: 3%;
}

.pointsHeader {
    width: 80%;
}

.pointsHeader:after {
    clear: both;
    content: "";
    display: table;
}

.pointsHeaderCol1 {
    float: left;
    text-align: right;
    width: 10%;
}

.pointsHeaderCol2 {
    float: left;
    text-align: left;
    width: 90%;
    margin-top: 0px;
}

.pointsHeader img {
    width: 50%;
    padding-top: 2.5%;
}

.pointsHeader label {
    bottom: 0;
    font-size: 27.5px;
    font-family: Arvo;
    color: #0930CB;
    // padding-bottom: 5%;
    font-weight: bold;
    margin-left: 1%;
    margin-bottom: 0px;
}

    // - POINTS CONTENT - //

.pointsContent {
    width: 100%;
    height: 100%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
    margin-top: 0px;
    border-radius: 8.5px;
    padding-bottom: 3%;
}

.pointsSectionLoading {
    padding-top: 7.5%;
    padding-bottom: 4%;
    text-align: center;
}

.pointsSectionLoading2 {
    padding-top: 12%;
    padding-bottom: 10%;
    text-align: center;
}

.pointsSectionLoading3 {
    padding-top: 14%;
    padding-bottom: 12%;
    margin: auto;
    text-align: center;
    border-bottom: 1px solid #0930cb;
}

.pointsSectionLoading4 {
    float: left;
    width: 90%;
    padding-top: 1%;
    padding-bottom: 1%;
    // margin: auto;
    text-align: center;
    // margin-top: 1%;
    // border-bottom: 1px solid #0930cb;
}

.pointsSectionLoading4:after {
    content: "";
    text-align: center;
    display: table;
}

.pointsSectionLoading5 {
    padding-top: 2%;
    padding-bottom: 2%;
    width: 100%;
    height: 100%; /* Ensure full height */
    display: flex;
    align-items: center;
    justify-content: center;
}

.pointsContent h3 {
    padding-top: 2%;
    margin-left: 2.5%;
    font-family: Arvo;
    color: #0930CB;
    font-size: 18px;
    margin-bottom: 1%;
}

.pointsSystem h4 {
    margin-top: 1.5%;
}

.pointsSystem2 {
    height: 35vh
}

.noCustomizationBlankSpace {
    margin-top: 2%;
    margin-bottom: 2%;
}

.pointsSystem2:after {
    clear: both;
    content: "";
    display: table;
}

.pointsSystem3 {
    height: 45.5vh;
}

.pointsSystem4 {
    height: 25vh;
}

// .pointsSystem3:after {
//     content: "";
//     display: table;
//     clear: both;
// }

.pointsSystem:after {
    clear: both;
    content: "";
    display: table;
}

.pointsSystemCol {
    float: left;
    text-align: left;
    width: 50%;
}

.pointsSystemCol2 {
    height: 100%;
    float: left;
    text-align: left;
    width: 50%;
}

.pointsInput {
    width: 80%;
    margin-left: 5%;
    height: 55px;
    border: 2px solid #ECECEC;
    position: relative;
    border-radius: 7px;
}

.pointsInput h3 {
    color: black;
    font-family: Arvo;
    margin-left: 1.5%;
}

.pointsInput h5 {
    margin-top: 0px;
    margin-bottom: 1.5%;
    font-family: Arvo;
}

.pointsInput label {
    margin-top: 0px;
    color: red;
    // margin-left: 1.5%;
    font-weight: bold;
}

.pointsSystemCol p {
    font-size: 12px;
    margin-top: 0px;
    position: absolute;
    top: 0;
    padding-top: 1%;
    padding-left: 1.5%;
    font-family: Arvo;
}

.pointsSystemCol input {
    width: 90%;
    position: absolute;
    bottom: 0;
    height: 40%;
    font-size: 20px;
    border: none;
    outline: none;
    padding: 1.5%;
    border-bottom-left-radius: 7px;
    font-family: Arial;
}


.pointsSystemCol h4 {
    margin-left: 5%;
    margin-top: 0px;
    font-family: Arvo;
    margin-bottom: 4.1%;
}

.referralLimitSystemCol input {
    width: 90%;
    position: absolute;
    bottom: 0;
    height: 40%;
    font-size: 20px;
    border: none;
    outline: none;
    padding: 1.5%;
    border-bottom-left-radius: 7px;
    font-family: Arial;
}

.referralLimitSystemCol p {
    font-size: 12px;
    margin-top: 0px;
    position: absolute;
    top: 0;
    padding-top: 1%;
    padding-left: 1.5%;
    font-family: Arvo;
}

.referralLimitSystemCol h4 {
    margin-left: 5%;
    margin-top: 3.25%;
    font-family: Arvo;
    margin-bottom: 3.25%;
}

.timeDurationHeader h3 {
    all: unset;
}

.pointsSystemCol2 h4 {
    margin-left: 5%;
    margin-top: 0px;
    margin-bottom: 3.25%;
    font-family: Arvo;
}

.pointsSystemCol2 p {
    font-size: 12px;
    margin-top: 0px;
    position: absolute;
    top: 0;
    padding-top: 1%;
    padding-left: 1.5%;
    font-family: Arvo;
}

.pointsSystemCol2 input {
    width: 90%;
    position: absolute;
    bottom: 0;
    height: 40%;
    font-size: 20px;
    border: none;
    outline: none;
    padding: 1.5%;
    border-bottom-left-radius: 7px;
    font-family: Arial;
}


    // - - BASELINE VALUE - - //

.earningValueFirstScreen {
    margin-top: 1.25%;
    margin-left: 2.5%;
    margin-bottom: 0px;
}

.earningValueFirstScreen h2 {
    margin-top; 0px;
    margin-bottom: 1.5%;
    font-family: arvo;
    color: #0930cb;
}

.earningValueFirstScreen button {
    // margin-top: 1.5%;
    padding: 0.5%;
    background-color: #C0CDFF;
    color: #0930cb;
    border: 2px solid #C0CDFF;
    border-radius: 5px;
    font-family: arvo;
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 0px;
}

.customerBaselineValues {
    width: 100%;
}

.customerBaselineValues:after {
    content: "";
    clear: both;
    display: table;
}

.customerBaselineValues button {
    padding: 2.75%;
}

.baselineValueCol1 {
    float: left;
    width: 25.5%;
    text-align: left;
}

.baselineValueCol2 {
    float: left;
    width: 22.5%;
    text-align: left;
    border-left: 1px solid black;
    padding-left: 3.5%;
}

.baselineValueCol1 label {
    margin-left: 2.5%;
}

.baselineValueCol2 button {
    background-color: #0930cb;
    color: white;
    border: 2px solid #0930cb;
}

.baselineValueAlert:after {
    content: "";
    display: table;
    clear: both;
}

.baselineValueAlert {
    background-color: white;
    // height: 20px;
    // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.10), 0 6px 20px 0 rgba(0, 0, 0, 0.10);
    width: 50%;
    margin-top: 1.5%;
    margin-bottom: 2.5%;
    border-radius: 8px;
    border: 1.5px solid #0930cb;
}

.baselineValueMsg {
    float: left;
    width: 90%;
    text-align: left;
}

.baselineValueClose {
    float: left;
    width: 10%;
    text-align: right;
}

.baselineValueMsg p {
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 1%;
    padding: 2.25%;
    font-family: gabarito;
    font-weight: bold;
    color: #0930cb;
}

.baselineValueMsg label {
    font-weight: bold;
}

.baselineValueClose button {
    all: unset;
    padding-right: 15%;
    padding-top: 10%;
    font-family: gabarito;
    font-size: 20px;
}

.baselineValueClose button:hover {
    
}

.baselineValueClose img {
    width: 30%;
    padding: 8.5%;
    border-radius: 50%;
}

.baselineValueClose img:hover {
    background-color: #E7E7E7;
    cursor: pointer;
}

        // - MORE OPTIONS (BTN & OPTIONS) - //

.moreOptionsPointsSystem p {
    font-family: arvo;
    color: #0930CB;
}

.moreOptionsPointsSystem p:hover {
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
}

.moreOptionsPointsEdit h3 {
    padding-top: 0px;
}

.moreOptionsPointsEdit h4 {
    font-family: arvo;
    margin-left: 2.5%;
    margin-top: 0px;
    margin-bottom: 1%;
}

.moreOptionsPointsEdit p {
    margin-left: 2.5%;
}

.moreOptionsPointsEdit button {
    margin-left: 2.5%;
}

    // - - EXIT CUSTOMER ACTION BUTTON - - //

.exitCustomerActionBtn {
    // all: unset;
    float: right;
}

.exitCustomerActionBtn button {
    all: unset;
    background-color: white;
    border: 1px solid transparent;
    // width: 10%;
    text-align: right;
}

.exitCustomerActionBtn img {
    width: 5%;
    padding: 2%;
    border-radius: 50%; 
}

.exitCustomerActionBtn img:hover {
    background-color: #E7E7E7;
    cursor: pointer;
}

    // - - FILTER SELECTED DISPLAY - - //

.filter1SelectedDisplay {
    margin-left: 5%;
}

.filter1SelectedDisplay label {
    margin-left: 5%;
}

.filter2SelectedDisplay {
    margin-left: 5%;
}

.filter2SelectedDisplay label {
    margin-left: 5%;
}

.filter3SelectedDisplay {
    margin-left: 5%;
}

.filter3SelectedDisplay label {
    margin-left: 5%;
}

.filter1SelectedDisplay button {
    width: 20%;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    border: 2px solid transparent;
    color: #0930cb;
    font-family: arvo;
    padding: 1%;
    margin-bottom: 3.5%;
    font-weight: bold;
}

.filter2SelectedDisplay button {
    width: 20%;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    border: 2px solid transparent;
    color: #0930cb;
    font-family: arvo;
    padding: 1%;
    margin-bottom: 3.5%;
    font-weight: bold;
}

.filter3SelectedDisplay button {
    width: 20%;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    border: 2px solid transparent;
    color: #0930cb;
    font-family: arvo;
    padding: 1%;
    font-weight: bold;
    margin-bottom: 3.5%;
}

.filterOptions {
    width: 95%;
    margin-left: 2.5%;
}

.filterOptions:after {
    content: "";
    display: table;
    clear: both;
}

.filterOptionsCol1 {
    float: left;
    width: 30%;
    text-align: center;
}

.filterOptionsCol2 {
    float: left;
    width: 30%;
    text-align: center;
}

.filterOptionsCol3 {
    float: left;
    width: 30%;
    text-align: center;
}

.filterOptionsCol1 h5 {
    margin-top: 2%;
    margin-bottom: 1.5%;
    color: #0930cb;
    font-family: Arvo;
    margin-left: 7.5%;
}

.filterOptions button {
    margin-left: 5%;
    margin-bottom: 0px;
    padding: 4%;
    padding-top: 8%;
    padding-bottom: 8%;
    width: 90%;
    background-color: #0930cb;
    color: white;
    font-family: arvo;
    border: 2px solid #0930cb;
    border-radius: 9px;
    font-weight: bold;
    cursor: pointer;
    font-size: 14.5px;
} 

.filterOptionsContinueBtn button {
    margin-top: 7.5%;
    margin-left: 2.5%;
    background-color: white;
    color: #0930cb;
    padding: 2.5%;
    width: 35%;
    font-family: Arvo;
    font-size: 15.5px;
    font-weight: bold;
    border: 2px solid #0930cb;
    border-radius: 7px;
    cursor: pointer;
    margin-bottom: 3.5%;
}

.filterOptionsContinueBtn2 button {
    margin-top: 7.5%;
    margin-left: 5%;
    background-color: white;
    color: #0930cb;
    padding: 2.5%;
    width: 35%;
    font-family: Arvo;
    font-size: 15.5px;
    font-weight: bold;
    border: 2px solid #0930cb;
    border-radius: 7px;
    cursor: pointer;
    margin-bottom: 3.5%;
}

.applyFilterErrMsg h4 {
    // padding-top: 7.5%;
    margin-left: 2.5%;
    font-family: arvo;
    color: red;
    margin-bottom: 0px;
}

.applyFilterErrMsg label {
    margin-right: 0.85%;
}

.applyFilterOptionsBtn {
    padding-top: 4%;
    margin-top: 6%;
}

.appliedFilterMsg {
    margin-bottom: 2%;
    margin-top: 0px;
    margin-left: 2.5%;
    font-family: arvo;
    color: #0930cb;
}

.appliedFilterMse h4 {
    margin-bottom: 0px;
}

.appliedFilterSpan {
    height: 100%;
}

.appliedFilterSpan span {
    text-align: center;
    // width: 15%;
    background-color: #0930cb;
    color: white;
    padding: 0.5%;
    border: 2px solid #0930cb;
    border-radius: 7px;
    margin-bottom: 1.5%;
}

.appliedFilterSpan label {
    margint-top: 0px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
}

.appliedFilterResult p {
    font-family: Helvetica Neue;
    color: #0930cb;
    font-weight: bold;
    margin-left: 2%;
    font-size: 14.5px;
}

.appliedFilterResult2 p {
    font-family: gabarito;
    color: #0930cb;
    font-weight: bold;
    // margin-left: 2%;
    font-size: 15.35px;
    padding-top: 2%;
}

.andOrFilterBtns {
    margin-bottom: 2.5%;
}

.andOrFilterBtns button {
    width: 10%;
    font-weight: bold;
    margin-left: 7.5%;
    margin-right: 2.5%;
    padding: 0.75%;
    background-color: #fff;
    color: #0930cb;
    font-family: arvo;
    border: 2px solid #0930cb;
    border-radius: 4px;
    cursor: pointer;
    font-size: 15.5px;
}

.earningPolicyPercentage {
    margin-left: 5%;
}

.earningPolicyPercentageContainer {
    width: 15%;
    border-radius: 15px;
    padding: 1.5%;
    background-color: #E9E9E9;
    margin-top: 3.5%;
}

.earningPolicyPercentageContainer h3 {
    padding-top: 0px;
    margin-top: 0px;
    color: #249721;
    text-align: center;
}

    // - - PRICE & MEAL DISPLAY - - //

.mealOrderDetails {
    margin-top: 4.25%;
    width: 85%;
    margin-left: 5%;
    border: 1.5px solid #0930cb;
    padding: 1%;
    border-radius: 6px;
    margin-bottom: 2.5%;
}

.mealOrderDetails:after {
    content: "";
    clear: both;
    display: table;
}

.mealOrderDetails h5 {
    font-family: gabarito;
    margin-top: 0px;
    margin-bottom: 0px;
    color: #0930cb;
}

.mealOrderDetailsCol1 {
    float: left;
    width: 90%;
    text-align: left;
}

.mealOrderDetailsCol2 {
    float: left;
    width: 10%;
    text-align: right;
}

    // - - COL 1 (MEAL ORDER DETAILS - COL 1) - - //

.mealOrderDetailsCol1 span {
    margin-right: 1%;
    // border: 1px solid #0930cb;
}

.mealOrderDetailsCol1 p {
    font-family: gabarito;
    color: #0930cb;
    // font-weight: bold;
    margin-top: 0px;
}

    // - - COL 2 (MEAL ORDER DETAILS - COL 2) - - //

.mealOrderDetailsCol2 button {
    background-color: #C0CDFF;
    color: #0930cb;
    border: 2px solid #C0CDFF;
    border-radius: 5.5px;
    font-family: gabarito;
    font-weight: bold;
    cursor: pointer;
}

    // - - REFERRAL INFORMATION - - //

.referralRegistrationLimitDisplay {
    margin-left: 2.5%;
}

.referralRegistrationLimitDisplay h2 {
    margin-top: 1.5%;
    margin-bottom: 1.5%;
    font-family: arvo;
}

.referralRegistrationLimitDisplay label {
    color: #0930cb;
}

.referralSaveFinalBtn {
    margin-left: 5%;
    margin-top: 8%;
}

.referralSaveFinalBtn button {
    background-color: #0930CB;
    color: white;
    padding: 2.5%;
    width: 45%;
    font-family: Arvo;
    font-size: 15.5px;
    font-weight: bold;
    border: 2px solid transparent;
    border-radius: 7px;
    cursor: pointer;
}

    // - - ALL EARNING POLICIES - - //

.allEarningPolicies {
    margin-top: 0px;
}

.allEarningPolicies h2 {
    margin-top: 2%;
    margin-left: 2.5%;
    text-align: 5%;
    font-family: gabarito;
    color: #0930cb;
    margin-bottom: 1%;
}

.allEarningPoliciesNotice {
    width: 40%;
    margin-left: 0.5%;
}

.allEarningPoliciesNotice:after {
    content: "";
    display: table;
    clear: both;
}

.earningPolicyNoticeCol1 {
    float: left;
    width: 10%;
    text-align: right;
}

.earningPolicyNoticeCol2 {
    float: left;
    width: 90%;
    text-align: left;
}

.earningPolicyNoticeCol1 img {
    width: 50%;
}

.earningPolicyNoticeCol2 p {
    margin-top: 0px;
    color: #0930cb;
    font-family: gabarito;
    margin-left: 2%;
}

.moreEarningPolicyNotes {
    margin-bottom: 3.5%;
}

.moreEarningPolicyNotes p {
    margin-top: 0px;
    color: #0930cb;
    font-family: gabarito;
    margin-left: 2.75%;
    margin-right: 2.75%;
}

.allEarningsBtn p {
    margin-left: 2.5%;
    margin-top: 2.5%;
    font-family: arvo;
    color: #0930cb;
}

.allEarningsBtn label:hover {
    text-decoration: underline;
    font-weight: bold;
    cursor: pointer;
}

    // - - EARNING POLICY HEADER - - //

.earningPolicyHeader {
    width: 100%;
    padding-bottom: 0.75%;
    padding-top: 0.75%;
    border-top: 1px solid #0930cb;
    border-bottom: 1px solid #0930cb;
    background-color: #E7ECFE;
}

.earningPolicyHeader:after {
    content: "";
    display: table;
    clear: both;
}

.EPHeaderCol1 {
    float: left;
    width: 8%;
    text-align: center;
}

.EPHeaderCol2 {
    float: left;
    width: 12.4%;
    text-align: left;
}

.EPHeaderCol3 {
    float: left;
    width: 25.4%;
    text-align: left;
}

.EPHeaderCol3_5 {
    float: left;
    width: 9.4%;
    text-align: left;
}

.EPHeaderCol4 {
    float: left;
    width: 22.4%;
    text-align: left;
}

.EPHeaderCol5 {
    float: left;
    width: 12.4%;
    text-align: left;
}

.EPHeaderCol6 {
    float: left;
    width: 10%;
    text-align: center;
}

    // - - (COL 1) - - //

.EPHeaderCol1 button {
    background-color: transparent;
    border: 1px solid transparent;
    // margin-bottom: 2.5%;
}

.EPHeaderCol1 img {
    width: 40%;
    cursor: pointer;
    margin-bottom: 1.5%;
    background-color: transparent;
}

.EPHeaderCol1 img:hover {
    width: 40%;
    // background-color: ;
}

    // - - (COL 2 - EARNING FILTER) - - //

.EPHeaderCol2 h4 { 
    padding-top: 0.5%;
    margin-top: 0px;
    margin-left: 6.5%;
    color: #0930cb;
    font-family: arvo;
    margin-top: 3%;
    margin-bottom: 0px;
}

    // - - (COL 3 - EARNING POLICY) - - //

.EPHeaderCol3 h4 {
    margin-top: 0px;
    color: #0930cb;
    font-family: arvo;
    margin-top: 2.5%;
    margin-bottom: 0px;
    padding-bottom: 0.5%;
}

    // - - (COL 3.5 - MULITIPLIER VALIDITY PERIOD) - - //

.EPHeaderCol3_5 h4 {
    padding-top: 4.5%;
    margin-top: 0px;
    color: #0930cb;
    font-family: arvo;
    margin-top: 2.5%;
    margin-bottom: 0px;
}

    // - - (COL 4 - EARNING VALUE) - - //
.EPHeaderCol4 h4 {
    padding-top: 1.25%;
    margin-top: 0px;
    margin-left: 5%;
    color: #0930cb;
    font-family: arvo;
    margin-top: 2.5%;
    margin-bottom: 0px;
}
    // - - (COL 5 - DATE CREATED) - - //

.EPHeaderCol5 h4 {
    padding-top: 3%;
    margin-top: 0px;
    color: #0930cb;
    font-family: arvo;
    margin-top: 2.5%;
    margin-bottom: 0px;

}

// - - (COL 6 - ACTIVE / INACTIVE) - - //

.EPHeaderCol6 h4 {
    padding-top: 5%;
    margin-top: 0px;
    color: #0930cb;
    font-family: arvo;
    margin-top: 2.5%;
    margin-bottom: 0px;

}

    // - - EARNING POLICY PLACEHOLDER - - //

.earningPolicyPlaceholder {
    text-align: center;
}

.earningPolicyPlaceholder img {
    padding-top: 12.5%;
    padding-bottom: 1.5%;
    width: 10%;
}

.earningPolicyPlaceholder h3 {
    margin-top: 2% !important;
    padding-bottom: 6%;
}

    // - - EARNING POLICY CELL - - //

.earningPolicyCell {
    width: 100%;
    padding-bottom: 0.75%;
    padding-top: 0.75%;
    // border-top: 1px solid #0930cb;
    border-bottom: 1px solid #0930cb;
}

.earningPolicyCell:after {
    content: "";
    display: table;
    clear: both;
}

.EPCellCol1 {
    float: left;
    width: 8%;
    text-align: center;
}

.EPCellCol2 {
    float: left;
    width: 12.4%;
    text-align: left;
}

.EPCellCol3 {
    float: left;
    width: 25.4%;
    text-align: left;
}

.EPCellCol3_5 {
    float: left;
    width: 9.4%;
    text-align: left;
}

.EPCellCol4 {
    float: left;
    width: 22.4%;
    text-align: left;
}

.EPCellCol5 {
    float: left;
    width: 12.4%;
    text-align: left;
}

.EPCellCol6 {
    float: left;
    width: 10%;
    text-align: center;
}

    // - - COL 1 (CHECKMARK) - - //

.EPCellCol1 button {
    background-color: transparent;
    border: 1px solid transparent;
    // margin-bottom: 2.5%;
}

.EPCellCol1 img {
    width: 40%;
    cursor: pointer;
    margin-bottom: 1.5%;
}

.EPCellCol1 img:hover {
    width: 42.5%;
    // background-color: ;
}

    // - - COL 2 (FILTER LABEL) - - //

.EPCellCol2Containers {
    margin-left: 6.5%;
}

.EPCellCol2 button {
    margin-top: 3%;
    margin-right: 5%;
    background-color: #C0CDFF;
    border-radius: 6.5px;
    border: 1px solid #C0CDFF;
    padding: 1.25%;
    padding-left: 4%;
    padding-right: 4%;
    color: #0930cb;
    font-family: gabarito;
    font-weight: bold;
    // margin-left: 10%;
}

    // - - COL 3 (EARNING POLICY) - - //

.EPCellCol3 p {
    margin-left: 0.5%;
    margin-top: 2%;
    margin-bottom: 0px;
    font-size: 14.5px;
    font-family: gabarito;
    color: #0930cb;
    font-weight: bold;
}

// - - COL 3.5 (MULTIPLIER VALIDITY PERIOD) - - //

.EPCellCol3_5 span {
    background-color: white;
    padding: 0.5%;
}

.EPCellCol3_5 p {
    margin-left: 0.5%;
    margin-top: 2%;
    margin-bottom: 0px;
    font-size: 15.35px;
    font-family: gabarito;
    color: #0930cb;
    font-weight: bold;
    // padding-top: 2%;
}

    // - - COL 4 (EARNING VALUE) - - //

.EPCellCol4 p {
    margin-left: 5%;
    padding-top: 2.85%;
}

.EPCellCol4 span {
    margin-left: 5%;
    font-family: Helvetica Neue;
    color: #249721;
    background-color: #EEEEEE;
    padding: 1.5%;
    border-radius: 7.5px;
    padding-left: 2%;
    padding-right: 2%;
    // font-weight: normal;
    cursor: pointer;
    font-size: 14px;
}

    // - - COL 5 (DATE CREATED) - - //

.EPCellCol5 p {
    color: #0930cb;
    font-family: Helvetica Neue;
    font-size: 15.35px;
    font-weight: bold;
    padding-top: 4.75%;
}

    // - - COL 6 (ACTIVE / INACTIVE) - - //

.EPCellCol6 button {
    background-color: transparent;
    border: 1px solid transparent;
    // margin-bottom: 2.5%;

}

.EPCellCol6 img {
    margin-top: 5%;
    width: 30%;
    cursor: pointer;
    margin-right: 2%;
    // margin-bottom: 1.5%;
    padding-top: 10%;
}

.EPCellCol6 img:hover {
    width: 32.5%;
    // background-color: ;
}

    // - - ALL EARNING POLICIES (FOOTER) - - //

.allEarningPoliciesFooter {
    text-align: center;
    // background-color: green;
    width: 95%;
    margin-left: 2.5%;
}

.allEarningPoliciesFooter:after {
    content: "";
    display: table;
    clear: both;
}

.EPFooterCol1 {
    float: left;
    width: 15%;
    text-align: left;
}

.EPFooterCol2 {
    float: left;
    width: 70%;
    text-align: center;
}

.EPFooterCol3 {
    float: left;
    width: 15%;
    text-align: right;
}

    // - - (EPFooter Col 1) - - //

.EPFooterCol1 p {
    margin-top: 15%;
    color: #0930cb;
    font-family: arvo;
}

.EPFooterCol1 label:hover {
    text-decoration: underline;
    font-weight: bold;
    cursor: pointer;
}

    // - - (EPFooter Col 2) - - //

.pageJumper { 
    margin: auto;
    text-align: center;
    width: 22.5%;
}

.pageJumper:after {
    content: "";
    display: table;
    clear: both;
}

.pageJumperCol1 {
    float: left;
    width: 33.3%;
    text-align: left;
}

.pageJumperCol1 input {
    text-align: center;
    margin-top: 35%;
    padding: 9.5%;
    width: 49.5%;
    border-radius: 5px;
    border: 2px solid #0930cb;
}

.pageJumperCol2 {
    float: left;
    width: 33.3%;
    text-align: center;
}

.pageJumperCol2 p {
    margin-left: 32.5%;
    margin-top: 45%;
    color: #0930cb;
    font-family: gabarito;
    font-weight: bold;
}

.pageJumperCol3 {
    float: left;
    width: 33.3%;
    text-align: right;
}

.pageJumperCol3 p {
    margin-top: 45%;
    color: #0930cb;
    font-family: gabarito;
    font-weight: bold;
}

    // - - (EPFooter Col 3) - - //

.EPFooterCol3 p {
    margin-top: 15%;
    color: #0930cb;
    font-family: arvo;
}

.EPFooterCol3 label:hover {
    text-decoration: underline;
    font-weight: bold;
    cursor: pointer;
}

    //! - - END OF FILTER POINTS EARNING - - //


.pointsSaveBtn button {
    margin-top: 2%;
    margin-left: 2.5%;
    background-color: #0930CB;
    color: white;
    padding: 1%;
    width: 15%;
    font-family: Arvo;
    font-size: 15.5px;
    font-weight: bold;
    border: 2px solid transparent;
    border-radius: 7px;
    cursor: pointer;
}

.pointsSaveBtn2 button {
    margin-top: 2%;
    margin-bottom: 4%;
    background-color: #0930CB;
    color: white;
    padding: 2.5%;
    width: 50%;
    font-family: Arvo;
    font-size: 15.5px;
    font-weight: bold;
    border: 2px solid transparent;
    border-radius: 7px;
    cursor: pointer;
}

.pointsSaveBtn button:hover {
    background-color: #0930cb;
    color: white;
}

.pointsFormSeparator {
    text-align: center;
    border: 0.5px solid #0930CB;
    width; 100%;
    margin-top: 3.5%;
    width: 95%;
    margin-left: 2.5%;
}

.rewardsErrorMsg {
    margin-left: 2.5%;
}

.addRewardBtn {
    text-align: right;
    margin-right: 2.5%;
    margin-bottom: 2%;
}

.addRewardBtn button {
    background-color: #0930CB;
    color: white;
    padding: 1.5%;
    width: 17.5%;
    font-family: Arvo;
    font-size: 15.5px;
    font-weight: bold;
    border: 2px solid transparent;
    border-radius: 7px;
    cursor: pointer;
}

.addRewardPlaceholderImg {
    text-align: center;
}

.addRewardPlaceholderImg h1 {
    margin-top: 3%;
    margin-bottom: 2.5%;
    font-family: Arvo;
    color: #0930CB;
    font-size: 35px;
}

.addRewardPlaceholderImg img {
    width: 12.5%;
}

.rewardCategories {
    margin-top: 1.25%;
    margin-bottom: 2%;
}

.rewardCategories2 {
    margin-top: 0px;
}

.rewardCategories3 {
    margin-top: 2.5%;
    margin-left: 5%;
}

.rewardCategories h5 {
    margin-top: 0px;
    margin-bottom: 1.5%;
    font-family: Arvo;
}

.rewardCategories2 h5 {
    margin-top: 0px;
    margin-bottom: 1%;
    font-family: Arvo;
}

.rewardCategories3 h5 {
    margin-top: 0px;
    margin-bottom: 1%;
    font-family: Arvo;
}

.rewardCategories label {
    color: red;
    // margin-left: 1.5%;
    font-weight: bold;
}

.addNewRewardBtn {
    margin-left: 4.5%;
    margin-top: 5.5%;
}

.addNewRewardBtn button {
    background-color: #0930CB;
    color: white;
    padding: 2.5%;
    width: 35.5%;
    font-family: Arvo;
    font-size: 15.5px;
    font-weight: bold;
    border: 2px solid transparent;
    border-radius: 7px;
    cursor: pointer;
}

.cancelNewRewardBtn {
    margin-left: 4.5%;
    margin-top: 3.5%;
}

.cancelNewRewardBtn button {
    background-color: white;
    color: #DD0202;
    padding: 2.5%;
    width: 35.5%;
    font-family: Arvo;
    font-size: 15.5px;
    font-weight: bold;
    border: 2px solid #DD0202;
    border-radius: 7px;
    cursor: pointer;
}

.percentageOffReward {
    margin-top: 4.5%;
}

.customRewardInput {
    margin-top: 3.5%;
}

.customRewardInput textarea {
    height: 3.5em;
    margin-left: 5%;
    margin-top: 1.5%;
    width: 85%;
    border-radius: 8px;
    padding: 1.5%;
    resize: none;
    font-family: gabarito;
    font-size: 18px;
}

    // - - REWARDS TABLE HEADER - - //

.rewardsTableHeader {
    width: 100%;
    margin-top: 2.5%;
    padding-bottom: 0.75%;
    padding-top: 0.75%;
    border-top: 1px solid #0930cb;
    border-bottom: 1px solid #0930cb;
    background-color: #E7ECFE;
}

.rewardsTableHeader:after {
    content: "";
    display: table;
    clear: both;
}

.rewardsHeaderCol1 {
    float: left;
    width: 8%;
    text-align: center;
}

.rewardsHeaderCol2 {
    float: left;
    width: 15%;
    text-align: left;
}

.rewardsHeaderCol3 {
    float: left;
    width: 22%;
    text-align: left;
}

.rewardsHeaderCol4 {
    float: left;
    width: 19%;
    text-align: left;
}

.rewardsHeaderCol5 {
    float: left;
    width: 14%;
    text-align: left;
}

.rewardsHeaderCol6 {
    float: left;
    width: 12%;
    text-align: left;
}

.rewardsHeaderCol7 {
    float: left;
    width: 10%;
    text-align: center;
}

    // - - (COL 1) - - //

.rewardsHeaderCol1 button {
    background-color: transparent;
    border: 1px solid transparent;
    // margin-bottom: 2.5%;
}

.rewardsHeaderCol1 img {
    width: 40%;
    cursor: pointer;
    margin-bottom: 1.5%;
    background-color: transparent;
}

.rewardsHeaderCol1 img:hover {
    width: 40%;
    // background-color: ;
}

    // - - (COL 2 - EARNING FILTER) - - //

.rewardsHeaderCol2 h4 {
    margin-top: 0px;
    margin-left: 6.5%;
    color: #0930cb;
    font-family: arvo;
    margin-top: 3%;
    margin-bottom: 0px;
}

    // - - (COL 3 - EARNING POLICY) - - //

.rewardsHeaderCol3 h4 {
    margin-top: 0px;
    color: #0930cb;
    font-family: arvo;
    margin-top: 2.5%;
    margin-bottom: 0px;
}
    // - - (COL 4 - EARNING VALUE) - - //

.rewardsHeaderCol4 h4 {
    margin-top: 0px;
    margin-left: 7.5%;
    color: #0930cb;
    font-family: arvo;
    margin-top: 2.5%;
    margin-bottom: 0px;
}
    // - - (COL 5 - DATE CREATED) - - //

.rewardsHeaderCol5 h4 {
    margin-top: 0px;
    color: #0930cb;
    font-family: arvo;
    margin-top: 2.5%;
    margin-bottom: 0px;
}

    // - - (COL 6 - EXPIRY DATE) - - //

.rewardsHeaderCol6 h4 {
    margin-top: 0px;
    color: #0930cb;
    font-family: arvo;
    margin-top: 2.5%;
    margin-bottom: 0px;
}

    // - - (COL 7 - ACTIVE / INACTIVE) - - //

.rewardsHeaderCol7 h4 {
    margin-top: 0px;
    color: #0930cb;
    font-family: arvo;
    margin-top: 2.5%;
    margin-bottom: 0px;
}

    // - - RENDER REWARDS TABLE - - //

.rewardCell {
    width: 100%;
    padding-bottom: 0.75%;
    padding-top: 0.75%;
    border-bottom: 1px solid #0930cb;
}

.rewardCell:after {
    content: "";
    display: table;
    clear: both;
}

.rewardCellCol1 {
    float: left;
    width: 8%;
    text-align: center;
}

.rewardCellCol2 {
    float: left;
    width: 15%;
    text-align: left;
}

.rewardCellCol3 {
    float: left;
    width: 22%;
    text-align: left;
}

.rewardCellCol4 {
    float: left;
    width: 19%;
    text-align: left;
}

.rewardCellCol5 {
    float: left;
    width: 14%;
    text-align: left;
}

.rewardCellCol6 {
    float: left;
    width: 12%;
    text-align: left;
}

.rewardCellCol7 {
    float: left;
    width: 10%;
    text-align: center;
}

    // - - COL 1 (CHECKMARK) - - //

.rewardCellCol1 button {
    background-color: transparent;
    border: 1px solid transparent;
    // margin-bottom: 2.5%;
}

.rewardCellCol1 img {
    width: 40%;
    cursor: pointer;
    margin-bottom: 1.5%;
}

.rewardCellCol1 img:hover {
    width: 42.5%;
    // background-color: ;
}

    // - - COL 2 (FILTER LABEL) - - //

.rewardCellCol2 button {
    margin-top: 3%;
    margin-right: 5%;
    background-color: #C0CDFF;
    border-radius: 6.5px;
    border: 1px solid #C0CDFF;
    padding: 1.25%;
    padding-left: 4%;
    padding-right: 4%;
    color: #0930cb;
    font-family: gabarito;
    font-weight: bold;
    // margin-left: 10%;
}
    // - - COL 3 () - - //

.rewardCellCol3 p {
    margin-left: 0.5%;
    margin-top: 2%;
    margin-bottom: 0px;
    font-size: 15px;
    font-family: gabarito;
    color: #0930cb;
    font-weight: bold;
}
    // - - COL 4 () - - //

.rewardCellCol4 p {
    margin-top: 1px;
    margin-left: 7.5%;
    font-family: gabarito;
    color: #0930cb;
    font-weight: bold;
    // margin-left: 2%;
    font-size: 15px;
}

.rewardCellCol4 h4 {
    margin-left: 7.5%;
    margin-top: 0px;
    margin-bottom: 0px;
    font-family: gabarito;
    color: #0930cb;
    font-size: 15.75px;
}
    // - - COL 5 () - - //

.rewardCellCol5 p {
    padding-top: 3.5%;
    color: #0930cb;
    font-family: Helvetica Neue;
    font-size: 14.75px;
    font-weight: bold;
}

    // - - COL 6 () - - //

.rewardCellCol6 p {
    padding-top: 3.5%;
    color: #0930cb;
    font-family: Helvetica Neue;
    font-size: 14.75px;
    font-weight: bold;
}
    // - - GETTING STARTED - - //

.gettingStartedInfo {
    // width: 100%;
}

.gettingStartedInfo p {
    font-family: arvo;
    font-size: 25px;
    margin-right: 2.5%;
}

.gettingStartedInfo button {
    width: 25%;
    background-color: #0930CB;
    color: white;
    padding: 2%;
    font-family: arvo;
    font-size: 24px;
    border: 2px solid transparent;
    border-radius: 9px;
    cursor: pointer;
}

    // - - COL 7 () - - //

.rewardCellCol7 button {
    background-color: transparent;
    border: 1px solid transparent;
    // margin-bottom: 2.5%;

}

.rewardCellCol7 img {
    margin-top: 5%;
    width: 30%;
    cursor: pointer;
    margin-right: 2%;
    // margin-bottom: 1.5%;
    padding-top: 10%;
}

.rewardCellCol7 img:hover {
    width: 32.5%;
    // background-color: ;
}

    //? - - CUSTOMER SUPPORT - - ?//

.customerSupportView {
    width: 97.5%;
    background-color: #E7E7E7;
    height: 75vh;
    border-radius: 8px;
}

.customerSupportView:after {
    content: "";
    display: table;
    clear: both;
}

.customerSupportCol1 {
    float: left;
    height: 75vh;
    width: 30%;
    text-align: center;
}

.customerSupportCol2 {
    float: left;
    height: 75vh;
    width: 67.5%;
    text-align: center;
}

.customerSupportAllMessagesView {
    text-align: center;
    height: 97.5%;
    width: 100%;
    background-color: white;
    margin-left: 2.5%;
    margin-top: 2.5%;
    border-radius: 8px;
}

.allMessagesTopView:after {
    content: "";
    display: table;
    clear: both;
}

.allMessagesTopViewCol1 {
    float: left;
    width: 60%;
    text-align: left;
}

.allMessagesTopViewCol2 {
    float: left;
    width: 40%;
    text-align: center;
}

.allMessagesTopViewCol1 h2 {
    margin-top: 4.5%;
    margin-left: 2.5%;
    font-family: Arvo;
}

.allMessagesTopViewCol2 button {
    font-weight: bold;
    margin-top: 8.5%;
    width: 70%;
    padding: 2%;
    border: 2px solid transparent;
    border-radius: 20px;
    background-color: #0930CB;
    color: white;
    font-family: Arvo;
    font-size: 15.5px;
    cursor: pointer;
}

.allMessagesSelectView {

}

.allMessagesSelectMenu {
    width: 94%;
    float: right;
    margin-right: 4%;
    text-align: left;
}

.allMessagesMessageCell {
    border-top: 1px solid #C9C9C9;
}

.messageCellTopView {
    margin-top: 5%;
    border-bottom: 1px solid #C9C9C9;
    width: 100%;
    padding-bottom: 8.5%;
    cursor: pointer;
}

.messageCellTopView:after {
    content: "";
    display: table;
    clear: both;
}

.messageCellTopViewCol1 {
    float: left;
    width: 8%;
    text-align: right;
}

.messageCellTopViewCol2 {
    float: left;
    width: 55%;
    text-align: left;
}

.messageCellTopViewCol3 {
    float: left;
    width: 27%;
    text-align: right;
}

.messageCellStatusUnread img {
    width: 35%;
}

.messageCellTopViewCol2 h4 {
    margin-top: 0px;
    margin-left: 3.5%;
    font-family: Arvo;
    margin-bottom: 0px;
}

.messageCellTopViewCol2 p {
    margin-left: 3.5%;
    margin-top: 0px;
    font-family: arvo;
    font-size: 13px;
    margin-right: 0px;
}

.messageCellTopViewCol2 span {
    background-color: #C0CDFF;
    padding: 1.75%;
    border-radius: 20px;
    margin-left: 3.5%;
    font-family: arvo;
    font-size: 12.5px;
    border: 2px solid transparent;
    margin-bottom: 2%;
    padding-left: 3.5%;
    padding-right: 3.5%; 
    color: #0930cb;
    font-weight: bold;
}

.messageCellTopViewCol2 label {
    padding-bottom: 2.5%;
}

.unresolvedIssue {
    margin-left: 3% !important;
    background-color: #F16F75 !important;
    color: #660A0E !important;
    font-weight: bold;
    border: 2px solid transparent !important;
}

.messageCellTopViewCol3 p {
    font-family: arvo;
    color: #0930cb;
    font-size: 13px;
    margin-left: 3.5%;
    font-weight: normal;
    padding-top: 20.5%;
}

.chatWindowView {
    width: 100%;
    height: 81.5%;
    background-color: white;
    margin-left: 2.5%;
    margin-top: 1.5%;
    border-radius: 8px;
}

.chatWindowViewTopDetails {
    text-align: left;
    padding-top: 1.5%;
}

.chatWindowViewTopDetails h1 {
    all: unset;
    font-family: arvo;
    margin-left: 2%;
    font-size: 23.5px;
    font-weight: bold;
    margin-bottom: 0px;
}

.chatWindowViewFrom {
    margin-top: 1.25%;
}

.chatWindowViewTopDetails span {
    margin-left: 2%;
    margin-top: 0px;
    font-family: arvo;
    background-color: #C0CDFF;
    color: #0930cb;
    padding: 0.75%;
    border-radius: 20px;
    padding-left: 1.5%;
    padding-right: 1.5%;
}

.chatWindowViewTopDetails label {
    font-weight: bold;
}

.chatWindowViewTopDetails label:hover {
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
}

.chatWindowResolvedStatus {
    text-align: right;
    margin-right: 3.5%;
}

.chatWindowResolvedStatus button {
    padding: 1.25%;
    padding-left: 3.5%;
    padding-right: 3.5%;
    border: 2px solid transparent;
    border-radius: 8px;
    cursor: pointer;
}

.chatWindowTextView {
    width: 100%;
    border-top: 1.5px solid #C9C9C9;
    margin-top: 1.5%;
    width: 100%;
    height: 40%;
}

.textView {
    text-align: left;
    width: 50%;
    margin-left: 1%;
    border-radius: 8px;
    margin-top: 1%;
    background-color: #C5C5C5;
    height: 50%;
    margin-bottom: 3.5%;
}

.textView textarea {
    resize: none;
    border-radius: 8px;
    height: 93.5%;
    width: 100%;
    background-color: #EBEBEB;
    outline: none;
    padding: 1.5%;
    font-family: rubik;
    line-height: 1.2;
    border: 2px solid transparent;
}

.textView2 {
    float: right;
    text-align: right;
    width: 52%;
    margin-right: 1%;
    border-radius: 8px;
    margin-top: 0.5%;
    background-color: white;
    height: 50%;
    color: white;
    margin-bottom: 3.5%;
}

.textView2 textarea {
    resize: none;
    border-radius: 8px;
    height: 93.5%;
    width: 93%;
    background-color: #0930cb;
    outline: none;
    color: white;
    padding: 1.5%;
    font-family: rubik;
    line-height: 1.2;
    border: 2px solid transparent;
    // font-weight: bold;
}

.chatTextEditorView {
    margin-top: 2%;
    width: 100%;
    margin-left: 2.5%;
    height: 12.5%;
    border-radius: 8px;
    background-color: transparent;
    margin-bottom: 2%;
}

.chatTextEditorCol1 {
    float: left;
    width: 85%;
    height: 95%;
    text-align: left;
    border-radius: 8px;
}

.chatTextEditorCol2 {
    float: left;
    width: 15%;
    height: 100%;
    text-align: center;
}

.chatTextEditorCol1 textarea {
    height: 87.5%;
    width: 97.5%;
    border: none;
    outline: none;
    resize: none;
    padding: 7px;
    font-family: rubik;
    font-size: 15.5px;
    border-radius: 8px;
}

.chatTextEditorCol2 button {
    width: 92.5%;
    margin-top: 0%;
    height: 100%;
    border-radius: 8px;
    background-color: #0930cb;
    font-family: arvo;
    color: white;
    font-size: 14.5px;
    cursor: pointer;
    border: 2px solid #0930cb;
    margin-left: 5%;
}

// .postContainer {
//     width: 90%;
//     box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
//     height: 50vh;
//     border-radius: 8px;
// }

// .postContainerTopBanner {
//     height: 7vh;
//     display: flex;
//     align-items: center;
//     background-color: #F0F0F0;
// }

// .postContainerTopBanner p {
//     margin-left: 25px;
//     font-family: Helvetica, sans-serif;
//     font-style: italic;
//     font-size: 17.5px;
// }

// .postContainerContentArea {
//     width: 100%;
//     height: 100%;
// }

// .postContainerContentArea textarea {
//     padding: 1%;
//     width: 97%;
//     height: 80%;
//     outline: none;
//     border: 0px solid transparent;
//     font-size: 17.5px;
//     font-family: Arial, Helvetica, sans-serif;
//     resize: none;
//     line-height: 1.5;
//     font-style: italic;
// }

`

const languages = [
        //* - - REWARDS - - *//
    {name: 'Edit brand loyalty points name (Rewards)'},
    {name: 'C'},
];

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    return inputLength === 0 ? [] : languages.filter(lang =>
      lang.name.toLowerCase().slice(0, inputLength) === inputValue
    );
};
  
  // When suggestion is clicked, Autosuggest needs to populate the input
  // based on the clicked suggestion. Teach Autosuggest how to calculate the
  // input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.name;
  
  // Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
    <div>
      {suggestion.name}
    </div>
);

export default class LandingPg extends Component {
    constructor(props) {
        super(props)
        this.state = {

            // - - SEARCH BAR - - //

            showHomepageSearchBar: true,
            showMembersSearchBar: false,
            showSearchRewards: true,
            showSearchAnalytics: true,
            showSearchCampaigns: true,
            showSearchMembers: true,

            // - - QUICK INSIGHTS - - //

            showActiveMembersFigure: true,
            showTotalRevenueFigure: true,
            totalMembers: 0,
            activeMembers: 0,
            totalRevenue: 0,
            currentMonthRevenueTotal: null,

            storedIDs: [],

            isPopupVisible: false,
            isPopup2Visible: false,
            showTopDashboards: true,
            showExplorePlansBtn: true,
            showAllPlans: false,
            showRewardsBtns: false,
            showLoader: false,
            showAddRewardsPlaceholder: false,
            showRewardsTable: false,
            showGettingStarted: false,

                // - - SIDEPANE - - //

            trialModeSidepaneColor: "black",
            rewardsSidepaneColor: "black",
            analyticsSidepaneColor: "black",
            campaignsSidepaneColor: "black",
            membersSidepaneColor: "black",
            customerSupportSidepaneColor: "black",

                // - - QUICK BUTTONS - - //

            quickBtn1BgColor: "white",
            quickBtn1TxtColor: "#0930CB",
            quickBtn2BgColor: "white",
            quickBtn2TxtColor: "#0930CB",
            quickBtn3BgColor: "white",
            quickBtn3TxtColor: "#0930CB",

                // - - POINTS PAGE - - //

            pointsBtn1UnselectedBgColor: "white",
            pointsBtn1UnselectedTxtColor: "#0930cb",
            pointsBtn1UnselectedBorderColor: "#0930cb",
            pointsBtn2UnselectedBgColor: "white",
            pointsBtn2UnselectedTxtColor: "#0930cb",
            pointsBtn2UnselectedBorderColor: "#0930cb",
            pointsBtn3UnselectedBgColor: "white",
            pointsBtn3UnselectedTxtColor: "#0930cb",
            pointsBtn3UnselectedBorderColor: "#0930cb",

            pointsBtn1SelectedBgColor: "white",
            pointsBtn1SelectedTxtColor: "#0930cb",
            pointsBtn1SelectedBorderColor: "#0930cb",
            pointsBtn2SelectedBgColor: "white",
            pointsBtn2SelectedTxtColor: "#0930cb",
            pointsBtn2SelectedBorderColor: "#0930cb",
            pointsBtn3SelectedBgColor: "white",
            pointsBtn3SelectedTxtColor: "#0930cb",
            pointsBtn3SelectedBorderColor: "#0930cb",

            showSaveRewardBtn: true,
            showSaveRewardBtnLoading: false,
            rewardCount: 0,
            pointsSingleValue: "",
            pointsPluralValue: "",
            pointsEarnedValue: "",
            pointsEarnedPercentageValue: "",
            pointsMoneyValue: "",
            pointsExpirationValue: "",
            directPointsConversion: "",
            percentagePointsConversion: "",

                // - FILTER OPTIONS - - //
            
            filterOptionBtn1: "None",
            filterOptionBtn2: "Price",
            filterOptionBtn3: "Meal",
            currentCustomerAction: "",

            limitedReferralTxt: "Set limit",
            unlimitedReferralTxt: "Unlimited",

            baselineValueMsg: "The Baseline (earning) Poilicy is the earning rate for all customers when they first join. You can add layers of customization once this is set.",
            baselineValueMsg2: "",
            filterOptionPricing: "",
            filterOptionTimeValue: "",
            filterOptionCalendarValue: "",
            filterOptionEndDate: "",
            multiplierTimeValue: "",
            multiplierCalendarValue: "",
            applyFilterErrMessage: "",
            applyFilterErrMessage2: "",
            applyFilterErrMessage3: "",
            purchaseCount: 0,

            priceFilterSelected: false,
            mealFilterSelected: false,

            pointsRewardValue: "",
            earnMultiplier: "",
            moneyEquivalent: 0,
            percentageOffValue: "",
            moneyOffValue: "",
            rewardPoints: "",
            rewardType: "",
            rewardMenuCategory: "",
            rewardMenuCategoryRewards: "",
            rewardMenuItemRewardsTable: "",
            rewardQuantityRewardTable: "",
            rewardMenuItem: "",
            rewardQuantity: "",
            rewardSelectedType: "",
            customRewardValue: "",
            rewardExpirationValue: "",
            pointsSinglLabelBorderColor: "#E6E6E6",
            pointsSingleLabelColor: "#939393",
            pointsPluralLabelBorderColor: "#E6E6E6",
            pointsPluralLabelColor: "#939393",
            pointsEarnedValueBorderColor: "#E6E6E6",
            pointsEarnedValueLabelColor: "#939393",
            pointsEarnedPercentageValueBorderColor: "#E6E6E6",
            pointsEarnedPercentageValueLabelColor: "#939393",
            pointsMoneyValueBorderColor: "#E6E6E6",
            pointsMoneyValueLabelColor: "#939393",
            pointsExpirationBoxShadowColor: "0, 0, 0, 0",
            showEarningTableNextBtn: true,
            showEarningTablePrevBtn: true,
            prevBtnTxt: "prev",
            nextBtnTxt: "next",
            totalEarningPolicyPages: 0,
            showRewardsTableNextBtn: true,
            showRewardsTablePrevBtn: true,
            prevBtnTxtRewards: "prev",
            nextBtnTxtRewards: "next",
            totalRewardsPages: 0,
            currentRewardsPage: 1,


                // - - POINTS FILTER BUTTONS - - //

            showPriceDescriptorLabel: true,
            showMealSelectedLabel: true,
            showTimeDurationLabel: true,
            priceFilterComparative: "",
            referralRegistrationValue: "",
            referralRegistrationLimitValue: "",
            savedReferralRegistrationLimitValue: "",
            savedReferralRegistrationValue: "",
            savedReferralRegistrationPointsValue: "",
            priceFilterComparativeGoesNull: false,
            filterOptions1BgColor: "#0930CB",
            filterOptions1TxtColor: "white",
            filterOptions2BgColor: "#0930CB",
            filterOptions2TxtColor: "white",
            filterOptions3BgColor: "#0930CB",
            filterOptions3TxtColor: "white",
            filterOptions4BgColor: "#0930CB",
            filterOptions4TxtColor: "white",
            filterOptions5BgColor: "#0930CB",
            filterOptions5TxtColor: "white",
            setLimitBtnBgColor: "#0930CB",
            setLimitBtnTxtColor: "white",
            unlimitedBtnBgColor: "#0930CB",
            unlimitedBtnTxtColor: "white",
            referralRegistrationValueBorderColor: "#000",
            referralRegistrationLimitBorderColor: "#000",
            filterOptionPricingBorderColor: "#E6E6E6",
            filterOptionFrequencyBorderColor: "#E6E6E6",
            priceFilterBoxShadowColor: "0, 0, 0, 0",
            mealCategoryBoxShadowColor: "0, 0, 0, 0",
            mealSelectedBoxShadowColor: "0, 0, 0, 0",
            mealQuantityBoxShadowColor: "0, 0, 0, 0",
            andFilterBtnBgColor: "white",
            andFilterBtnTxtColor: "#0930cb",
            andFilterBtnBorderColor: "#0930cb",
            orFilterBtnBgColor: "white",
            orFilterBtnTxtColor: "#0930cb",
            orFilterBtnBorderColor: "#0930cb",

            pointsRewardValueBorderColor: "#E6E6E6",
            pointsRewardValueLabelColor: "#939393",
            percentageOffValueBorderColor: "#E6E6E6",
            percentageOffValueLabelColor: "#939393",
            moneyOffValueBorderColor: "#E6E6E6",
            moneyOffValueLabelColor: "#939393",
            customRewardBorderColor: "#E6E6E6",
            rewardExpirationValueBorderColor: "#E6E6E6",
            rewardExpirationValueLabelColor: "#939393",
            menuCategories: [],
            selectedMenuCategory: [],
            value: '',
            suggestions: [],
            rewards : [],
            currentPage: 1,
            listEarningPolicies: [],
            selectedEarningPoliciesCount: 0,
            selectedEarningPolicyIDs: [],
            selectedRewardsCount: 0,
            selectedRewardsIDs: [],

            // - - CAMPAIGNS - - //

            campaignsSecondLevel: false,
            membersSecondLevel: false,
        }

        this.childCampaignRef = React.createRef();
    }
    
    componentDidMount = () => {
        this.checkForStatusSelectedChange()
        this.checkForEPSelectedChange()
        this.checkForRewardSelectedChange()
        this.getTotalMembers()
        this.setupMidnightTimeout()
        // this.loadExistingUserIDs()
        // this.performMidnightAction()
    }

    getTotalMembers = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("email_list")
        .get().then(snapshot => {
            this.setState({
                totalMembers: snapshot.size-1
            })
        })
    }

        //* - - QUICK INSIGHTS DROPDOWN HANDLERS - - *//

    handleActiveMembersChanged = (selectedOptions) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();
        if (selectedOptions.value === '1-day') {
            this.getActiveMembers24Hours(currentYear)
        } else if (selectedOptions.value === "7-days") {
            this.getActiveMembers1Week()
        } else if (selectedOptions.value === "30-days") {
            this.getActiveMembers30Days()
        }
        this.setState({
            showActiveMembersFigure: false,
            showActiveMembersFigureLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showActiveMembersFigureLoading: false,
                    showActiveMembersFigure: true,
                })
            }, 2000)
        })
    }

    handleTotalRevenueChanged = async (selectedOptions) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();
        if (selectedOptions.value === "1-day") {
            this.getTotalRevenue24Hours(currentYear)
        } else if (selectedOptions.value === "7-days") {
            this.getTotalRevenue1Week()
        } else if (selectedOptions.value === "1-month") {
            this.getTotalRevenue1Month()
        } else if (selectedOptions.value === "3-months") {
            this.getTotalRevenue3Months()
        } else if (selectedOptions.value === "6-months") {
            this.getTotalRevenue6Months()
        } else if (selectedOptions.value === "1-year") {
            await this.getCurrentYearTotalRevenue(currentYear)
            this.setState({totalRevenue: this.state.annualRevenueTotal})
        }
        this.setState({
            showTotalRevenueFigure: false,
            showTotalRevenueFigureLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showTotalRevenueFigureLoading: false,
                    showTotalRevenueFigure: true,
                })
            }, 2000)
        })
    }

        //! - ACTIVE MEMBERS - !//

    getActiveMembers24Hours = (currentYear) => {

        const currentDate = new Date();
        const dayOfMonth = currentDate.getDate();
        const dayString = dayOfMonth.toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(currentYear)
        .collection(currentMonth)
        .doc("activity")
        .collection(dayString)
        .get().then(snapshot => {
            this.setState({
                activeMembers: snapshot.size
            })
        })

    }

    getActiveMembers1Week = () => {
        const currentDate = new Date();
        const dayOfMonth = currentDate.getDate(); 

        const sevenDaysAgo = new Date(currentDate);
        sevenDaysAgo.setDate(currentDate.getDate() - 7);
        const sevenDaysAgoDayOfMonth = sevenDaysAgo.getDate();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];
        const previousMonth = monthAbbreviations[currentDate.getMonth() - 1];

        const currentYear = currentDate.getFullYear().toString();

        const promises = []

        let updatedTotal = 0

        const updateTotal = (currentTotal) => {
            updatedTotal += currentTotal;
        };

        // Check if the current day is within the first week of the month
        let isFirstWeek = dayOfMonth <= 7;
    
        const startDay = isFirstWeek ? (sevenDaysAgoDayOfMonth > 1 ? sevenDaysAgoDayOfMonth : 1) : sevenDaysAgoDayOfMonth;

        const lastDayOfPreviousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
        
        for (let i = startDay; i <= (isFirstWeek ? Math.max(7, lastDayOfPreviousMonth) : dayOfMonth); i++) {

            const monthToQuery = isFirstWeek ? previousMonth : currentMonth;
            
            const weeklyCollectionPromise = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("transactions")
            .collection("members")
            .doc(currentYear)
            .collection(monthToQuery)
            .doc("activity")
            .collection(`${i}`)
            .get().then(snapshot => {
                const currentTotal = snapshot.size || 0;
                updateTotal(currentTotal);
            })

            if (i === lastDayOfPreviousMonth) {
                isFirstWeek = false
                i = 0
            }
            promises.push(weeklyCollectionPromise)
        }
        
        Promise.all(promises)
        .then(() =>{
            this.setState({
                activeMembers: updatedTotal
            })
        })
    }

    getActiveMembers30Days = () => {

        const currentDate = new Date();
        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        const currentYear = currentDate.getFullYear().toString();

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(currentYear)
        .collection(currentMonth)
        .get().then(snapshot => {
            this.setState({
                activeMembers: snapshot.size
            })
        })


    }

        //! - TOTAL REVENUE - !//

    getTotalRevenue24Hours = (currentYear) => {

        const currentDate = new Date();
        const dayOfMonth = currentDate.getDate();
        const dayString = dayOfMonth.toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(currentMonth)
        .doc("byItem")
        .collection(dayString)
        .doc("0total")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    totalRevenue: doc.data().total
                })
            } else {
                this.setState({
                    totalRevenue: 0
                })
            }
        })
    }

    getTotalRevenue1Week = () => {
        const currentDate = new Date()
        const dayOfMonth = currentDate.getDate();

        console.log(`DAY OF MONTH: ${dayOfMonth}`)
    
        const sevenDaysAgo = new Date(currentDate);
        sevenDaysAgo.setDate(currentDate.getDate() - 7);
        const sevenDaysAgoDayOfMonth = sevenDaysAgo.getDate();

        console.log(`SEVEN DAYS AGO: ${sevenDaysAgoDayOfMonth}`)
    
        const monthAbbreviations = [
            'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
        ];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];
        const previousMonth = monthAbbreviations[currentDate.getMonth() - 1];
    
        const currentYear = currentDate.getFullYear().toString();
    
        const promises = [];
        let updatedTotal = 0;
    
        const updateTotal = (currentTotal) => {
            updatedTotal += currentTotal;
        };
    
        // Check if the current day is within the first week of the month
        let isFirstWeek = dayOfMonth <= 7;
    
        const startDay = isFirstWeek ? (sevenDaysAgoDayOfMonth > 1 ? sevenDaysAgoDayOfMonth : 1) : sevenDaysAgoDayOfMonth;

        const lastDayOfPreviousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
        // let i = startDay
        
        for (let i = startDay; i <= (isFirstWeek ? Math.max(7, lastDayOfPreviousMonth) : dayOfMonth); i++) {

            const monthToQuery = isFirstWeek ? previousMonth : currentMonth;
    
            const weeklyCollectionRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("orders")
                .doc(currentYear)
                .collection(monthToQuery)
                .doc("byItem")
                .collection(`${i}`)
                .doc("0total");

                console.log(`LOOP ITERATIONS : ${i}`)
    
            const weeklyCollectionPromise = weeklyCollectionRef.get().then(doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    updateTotal(currentTotal);
                }
            });
            
            if (i === lastDayOfPreviousMonth) {
                isFirstWeek = false
                i = 0
            }

            promises.push(weeklyCollectionPromise);

        }
    
        Promise.all(promises)
            .then(() => {
                this.setState({
                    totalRevenue: updatedTotal
                });
            });
    }

    getTotalRevenue1Month = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(currentMonth)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    currentMonthRevenueTotal: doc.data().total,
                    totalRevenue: doc.data().total || 0,
                })
            }
        })

    }

    getTotalRevenue3Months = () => {

        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        const currentMonthIndex = currentDate.getMonth();
        // Specify how many months before the current month you want
        const monthsBefore = 3;

        // Calculate the index of the target month
        const targetMonthIndex = (currentMonthIndex - monthsBefore + 12) % 12;

        // Get the abbreviated name of the target month
        const targetMonth = monthAbbreviations[targetMonthIndex];
        const targetMonthPlus1 = monthAbbreviations[targetMonthIndex + 1];
        const targetMonthPlus2 = monthAbbreviations[targetMonthIndex + 2];

        let updatedTotal = 0

        const updateTotal = (currentTotal) => {
            updatedTotal += currentTotal;
        };

        const promises = []

        const month3AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonth)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month3AwayCollectionPromise)

        const month2AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus1)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month2AwayCollectionPromise)

        const month1AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus2)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            } 
        })

        promises.push(month1AwayCollectionPromise)

        Promise.all(promises)
        .then(async() => {
            if (this.state.currentMonthRevenueTotal !== null) {
                this.setState({
                    totalRevenue: updatedTotal+this.state.currentMonthRevenueTotal
                })
            } else {
                await fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("revenue")
                .doc(currentYear)
                .collection(currentMonth)
                .doc("total")
                .get().then(doc => {
                    let currentTotal
                    if (doc.exists) {
                        currentTotal = doc.data().total || 0;
                        this.setState({
                            totalRevenue: updatedTotal + currentTotal
                        })
                    } else {
                        this.setState({
                            totalRevenue: updatedTotal
                        })
                    }
                })
            }
        })
        
    }

    getTotalRevenue6Months = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        const currentMonthIndex = currentDate.getMonth();
        // Specify how many months before the current month you want
        const monthsBefore = 6;

        // Calculate the index of the target month
        const targetMonthIndex = (currentMonthIndex - monthsBefore + 12) % 12;

        // Get the abbreviated name of the target month
        const targetMonth = monthAbbreviations[targetMonthIndex];
        const targetMonthPlus1 = monthAbbreviations[targetMonthIndex + 1];
        const targetMonthPlus2 = monthAbbreviations[targetMonthIndex + 2];
        const targetMonthPlus3 = monthAbbreviations[targetMonthIndex + 3];
        const targetMonthPlus4 = monthAbbreviations[targetMonthIndex + 4];
        const targetMonthPlus5 = monthAbbreviations[targetMonthIndex + 5];

        let updatedTotal = 0

        const updateTotal = (currentTotal) => {
            updatedTotal += currentTotal;
        };

        const promises = []

        const month6AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonth)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month6AwayCollectionPromise)

        const month5AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus1)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month5AwayCollectionPromise)

        const month4AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus2)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month4AwayCollectionPromise)

        const month3AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus3)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month3AwayCollectionPromise)

        const month2AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus4)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month2AwayCollectionPromise)

        const month1AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus5)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month1AwayCollectionPromise)

        Promise.all(promises)
        .then(async() => {
            if (this.state.currentMonthRevenueTotal !== null) {
                this.setState({
                    totalRevenue: updatedTotal+this.state.currentMonthRevenueTotal
                })
            } else {
                await fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("revenue")
                .doc(currentYear)
                .collection(currentMonth)
                .doc("total")
                .get().then(doc => {
                    if (doc.exists) {
                        const currentTotal = doc.data().total || 0;
                        this.setState({
                            totalRevenue: updatedTotal + currentTotal
                        })
                    } else {
                        this.setState({
                            totalRevenue: updatedTotal
                        })
                    }
                })
            }
        })
    }

    getCurrentYearTotalRevenue = (year) => {
        this.setState({
            currentChartLabel: "Monthly Revenue (KES)",
            currentChartLabels: [],
            currentData: []
        })

        let revenueArray = []

        const promises = []
        
        const janRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("jan")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(janRevPromise)

        const febRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("feb")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(febRevPromise)

        const marRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("mar")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(marRevPromise)

        const aprRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("apr")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(aprRevPromise)

        const mayRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("may")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(mayRevPromise)

        const junRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("jun")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(junRevPromise)

        const julRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("jul")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(julRevPromise)

        const augRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("aug")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(augRevPromise)

        const sepRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("sep")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(sepRevPromise)

        const octRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("oct")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(octRevPromise)

        const novRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("nov")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(novRevPromise)

        const decRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("dec")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(decRevPromise)

        Promise.all(promises)
        .then(() => {
            console.log(revenueArray)
            const total = revenueArray.reduce((acc, value) => acc + value, 0)
            this.setState(() => ({
                totalRevenue: total
            }));
        })
    }

        //! - - REST OF LANDING PAGE FUNCS - - !//

    loadExistingUserIDs = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("id_list")
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data().id)
            const newData = data.slice(1);
            this.setState({
                storedIDs: newData
            })
        })
        .then(() => {
            this.performMidnightAction()
        })
    }

    setupMidnightTimeout = () => {
        const now = new Date();
        const timeUntilMidnight = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate() + 1, // Move to tomorrow
            0, // Midnight
            0, // Minutes
            0 // Seconds
        ) - now;

        // Log the time until midnight
        console.log(`Time until midnight: ${timeUntilMidnight / 1000} seconds`);

            
        // Set a timeout to execute the action at midnight
        setTimeout(() => {
        // this.performMidnightAction();
    
        // Set up the next timeout for the next day
        this.setupMidnightTimeout();
        }, timeUntilMidnight);
    }

    getFirstDayXMonthsPrior = (inputDate, months) => {
        // Create a Date object from the input date string
        const date = new Date(inputDate);
      
        // Set the date to the first day of the current month
        date.setDate(1);
      
        // Subtract two months to get the first day of the month two months prior
        date.setMonth(date.getMonth() - months);
      
        // Extract day, month, and year
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based
        const year = date.getFullYear();
      
        // Format the result as mm/dd/yyyy
        const formattedResult = `${month}-${day}-${year}`;
      
        return formattedResult;
    }

    getLastDayXMonthsPrior = (inputDate, months) => {
        // Create a Date object from the input date string
        const date = new Date(inputDate);

        // Subtract months and handle negative values
        const newMonth = date.getMonth() - months + 1;

        // Adjust the year and month for negative values
        date.setFullYear(date.getFullYear() + Math.floor(newMonth / 12));
        const finalMonth = (newMonth % 12 + 12) % 12;
        date.setMonth(finalMonth);

        // Set the date to the last day of the calculated month
        date.setDate(0);

        // Extract day, month, and year
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based
        const year = date.getFullYear();

        // Format the result as mm/dd/yyyy
        const formattedResult = `${month}-${day}-${year}`;

        return formattedResult;
    }

    performMidnightAction = () => {
        const membersCollectionRef = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("members")
        .collection("full_list");
    
        membersCollectionRef.get()
        .then(async (querySnapshot) => {
            for (const doc of querySnapshot.docs) {
                if (this.state.storedIDs.includes(doc.id)) {
                    const ordersCollectionRef = membersCollectionRef.doc(doc.id).collection("orders");

                    membersCollectionRef.doc(doc.id).collection("orders").get().then(async snapshot => {
                        if (snapshot.size > 0) {
                            let { max_X, max_X_monthStarting } = await this.findMax_X(ordersCollectionRef, 0);

                                //* - - CURRENT DATE - - *//
                            let currentDate = new Date()
                            let formattedDate = this.formatDate(currentDate)
                            formattedDate = "04-01-2024"
                            if (this.getFirstDayXMonthsPrior(formattedDate, max_X) !== max_X_monthStarting) {
                                while (max_X > 1) {
                                        // Perform move operation here
                                    //? CREATE A FUNCTION THAT TAKES ALL THE VALUES NEEDED FOR THE PREVIOUS MONTH NUMBER 
                                    const destinationMonthRef = ordersCollectionRef.doc(`month${max_X + 1}`);
                                    
                                    let documentToMove = ordersCollectionRef.doc(`month${max_X}`).get()

                                    if ((await documentToMove).exists) {
                                        await this.moveDataToNewMonth(ordersCollectionRef.doc(`month${max_X}`), destinationMonthRef, max_X);
            
                                            // Re-run findMax_X after the move operation, passing prevMax as an argument
                                        let { max_X: newMax_X, max_X_monthStarting: newMax_X_monthStarting } = await this.findMax_X(ordersCollectionRef, max_X);
            
                                            // Check that the newMax_X is not equal to max_X or max_X + 1
                                        if (newMax_X > 0 && newMax_X !== max_X && newMax_X !== max_X + 1) {
                                            console.log(`New Max 'X' value: ${newMax_X}`);
                                            console.log(`New monthStarting value: ${newMax_X_monthStarting}`);
                                        } else {
                                            console.log(`Invalid newMax_X value: ${newMax_X}`);
                                            // Handle the case where the newMax_X is not valid
                                        }
            
                                            // Update max_X and max_X_monthStarting for the next iteration
                                        max_X = newMax_X;
                                        max_X_monthStarting = newMax_X_monthStarting;
                                    }
                                }
                                // Move data from thisMonth to month1 after the while loop
                                await this.moveMonth1ToMonth2(ordersCollectionRef)
                                await this.moveThisMonthToMonth1(ordersCollectionRef);
    
                            } else {
                                console.log("same month bro");
                            }
    
                            await this.checkIfNewWeek(ordersCollectionRef)
                            this.checkIfNewDay(ordersCollectionRef)

                        }
                    })      
                }
            }
        })
        .catch((error) => {
            console.error('Error getting documents: ', error);
        });
    }

    findMax_X = async (ordersCollectionRef, prevMax) => {
        try {
            const ordersQuerySnapshot = await ordersCollectionRef.get();
            let max_X = 0;
    
            if (!ordersQuerySnapshot.empty) {
                ordersQuerySnapshot.forEach((orderDoc) => {
                    const monthNumber = parseInt(orderDoc.id.replace("month", ""), 10);
    
                    // Check if it's a valid numeric value (greater than 0 and below prevMax)
                    if (prevMax != 0) {
                        if (!isNaN(monthNumber) && monthNumber > 0 && monthNumber < prevMax) {
                            max_X = Math.max(max_X, monthNumber);
                        }
                    } else {
                        if (!isNaN(monthNumber) && monthNumber > 0) {
                            max_X = Math.max(max_X, monthNumber);
                        }
                    }
                });
    
                const max_XDocumentData = ordersQuerySnapshot.docs.find(doc => parseInt(doc.id.replace("month", ""), 10) === max_X).data();
                const max_X_monthStarting = max_XDocumentData.monthStarting;
    
                return { max_X, max_X_monthStarting };
            } else {
                // Handle the case where there are no documents in the collection
                console.log("No documents in the collection.");
                return { max_X: 0, max_X_monthStarting: null };
            }
        } catch (error) {
            // Handle any potential errors during the retrieval of documents
            console.error('Error getting documents: ', error);
            return { max_X: 0, max_X_monthStarting: null };
        }
    }
    
    moveDataToNewMonth = async (sourceMonthRef, destinationMonthRef, max_X) => {
        try {
                // Get the data from the source month
            const sourceMonthData = await sourceMonthRef.get();

                // Extract the relevant fields
            const { currentDate, monthStarting, monthEnding, total } = sourceMonthData.data();

                //* - - CURRENT DATE - - *//
            let todayDate = new Date()
            let newTodayDate = this.formatDate(todayDate)
            newTodayDate = "04-01-2024"
            let newMonthStarting = this.getFirstDayXMonthsPrior(newTodayDate, max_X+1) 
            let newMonthEnding = this.getLastDayXMonthsPrior(newTodayDate, max_X+1)
                // Copy the data to the destination month
            await destinationMonthRef.set({
                currentDate: newTodayDate,
                monthStarting: newMonthStarting,
                monthEnding: newMonthEnding,
                total,
            });

                // 1. Move data in the 'list' subcollection
            const listDocs = await sourceMonthRef.collection('list').get();
            const listPromises = listDocs.docs.map(async (listDoc) => {
                    // Create a new document in the 'list' subcollection of the destination month
                const newDocRef = destinationMonthRef.collection('list').doc(listDoc.id);
                
                    // Copy data from the source to the destination document
                await newDocRef.set(listDoc.data());
                
                    // Move data in the nested 'list' subcollection
                const nestedListDocs = await listDoc.ref.collection('list').get();
                const nestedListPromises = nestedListDocs.docs.map(async (nestedListDoc) => {
                const newNestedDocRef = newDocRef.collection('list').doc(nestedListDoc.id);
                    await newNestedDocRef.set(nestedListDoc.data());
                });
                
                    // Wait for all nested 'list' documents to be copied
                await Promise.all(nestedListPromises);
            });
          
                // Wait for all 'list' documents to be copied
            await Promise.all(listPromises);
      
                // 2. Move data in the 'monthXMeals' subcollection
            const mealsDocs = await sourceMonthRef.collection(`month${max_X}Meals`).get();
            const mealsPromises = mealsDocs.docs.map(async (mealsDoc) => {
                // Create a new document in the 'monthXMeals' subcollection of the destination month
                const newDocRef = destinationMonthRef.collection(`month${max_X+1}Meals`).doc(mealsDoc.id);
                
                // Copy data from the source to the destination document
                await newDocRef.set(mealsDoc.data());
            });
          
                // Wait for all 'monthXMeals' documents to be copied
            await Promise.all(mealsPromises);
      
                // 3. Move data in the 'monthXSpend' subcollection
            const spendDocs = await sourceMonthRef.collection(`month${max_X}Spend`).get();
            const spendPromises = spendDocs.docs.map(async (spendDoc) => {
                // Create a new document in the 'monthXSpend' subcollection of the destination month
                const newDocRef = destinationMonthRef.collection(`month${max_X+1}Spend`).doc(spendDoc.id);
                
                // Copy data from the source to the destination document
                await newDocRef.set(spendDoc.data());
            });
          
            // Wait for all 'monthXSpend' documents to be copied
            await Promise.all(spendPromises);
      
            console.log('Data moved successfully!');
            await sourceMonthRef.delete();
        } catch (error) {
            console.error('Error moving data:', error);
        }
    };

    moveMonth1ToMonth2 = async (ordersCollectionRef) => {
        try {
            const thisMonthRef = ordersCollectionRef.doc("month1");
            const month2Ref = ordersCollectionRef.doc("month2");

            // Get the data from the source (thisMonth)
            const thisMonthData = await thisMonthRef.get();

            if (thisMonthData.exists) {
                // Extract the relevant fields
                const { currentDate, monthStarting, monthEnding, total } = thisMonthData.data();
                    
                    //* - - CURRENT DATE - - *//
                let todayDate = new Date()
                let newTodayDate = this.formatDate(todayDate)
                newTodayDate = "04-01-2024"
                let newMonthStarting = this.getFirstDayXMonthsPrior(newTodayDate, 2) 
                let newMonthEnding = this.getLastDayXMonthsPrior(newTodayDate, 2)
                    // Copy the data to the destination month

                await month2Ref.set({
                    currentDate: newTodayDate,
                    monthStarting: newMonthStarting,
                    monthEnding: newMonthEnding,
                    total,
                });
        
                // Move data in the 'list' subcollection
                const listDocs = await thisMonthRef.collection('list').get();
                const listPromises = listDocs.docs.map(async (listDoc) => {
                    // Create a new document in the 'list' subcollection of 'month1'
                    const newDocRef = month2Ref.collection('list').doc(listDoc.id);
        
                    // Copy data from the source to the destination document
                    await newDocRef.set(listDoc.data());
        
                    // Move data in the nested 'list' subcollection
                    const nestedListDocs = await listDoc.ref.collection('list').get();
                    const nestedListPromises = nestedListDocs.docs.map(async (nestedListDoc) => {
                        const newNestedDocRef = newDocRef.collection('list').doc(nestedListDoc.id);
                        await newNestedDocRef.set(nestedListDoc.data());
                    });
        
                    // Wait for all nested 'list' documents to be copied
                    await Promise.all(nestedListPromises);
                });
        
                // Move data in the 'month2Meals' subcollection
                const mealsDocs = await thisMonthRef.collection('month1Meals').get();
                const mealsPromises = mealsDocs.docs.map(async (mealsDoc) => {
                    // Create a new document in the 'month1Meals' subcollection of 'month1'
                    const newDocRef = month2Ref.collection('month2Meals').doc(mealsDoc.id);
        
                    // Copy data from the source to the destination document
                    await newDocRef.set(mealsDoc.data());
                });
        
                // Move data in the 'month2Spend' subcollection
                const spendDocs = await thisMonthRef.collection('month1Spend').get();
                const spendPromises = spendDocs.docs.map(async (spendDoc) => {
                    // Create a new document in the 'month1Spend' subcollection of 'month1'
                    const newDocRef = month2Ref.collection('month2Spend').doc(spendDoc.id);
        
                    // Copy data from the source to the destination document
                    await newDocRef.set(spendDoc.data());
                });
        
                // Wait for all 'list', 'month2Meals', and 'month2Spend' documents to be copied
                await Promise.all([...listPromises, ...mealsPromises, ...spendPromises]);
        
                console.log('Data from month1 moved to month2 successfully!');
                await thisMonthRef.delete()
            }
        } catch (error) {
            console.error('Error moving data:', error);
        }
    };

    moveThisMonthToMonth1 = async (ordersCollectionRef) => {
        try {
            const thisMonthRef = ordersCollectionRef.doc("thisMonth");
            const month1Ref = ordersCollectionRef.doc("month1");
    
            
            // Get the data from the source (thisMonth)
            const thisMonthData = await thisMonthRef.get();

            if (thisMonthData.exists) {
                // Extract the relevant fields
                const { currentDate, monthStarting, monthEnding, total } = thisMonthData.data();
                                
                //* - - CURRENT DATE - - *//
                let todayDate = new Date()
                let newTodayDate = this.formatDate(todayDate)
                newTodayDate = "04-01-2024"
                let newMonthStarting = this.getFirstDayXMonthsPrior(newTodayDate, 1) 
                let newMonthEnding = this.getLastDayXMonthsPrior(newTodayDate, 1)
                // Copy the data to the destination month

                await month1Ref.set({
                currentDate: newTodayDate,
                monthStarting: newMonthStarting,
                monthEnding: newMonthEnding,
                total,
                });

                // Move data in the 'list' subcollection
                const listDocs = await thisMonthRef.collection('list').get();
                const listPromises = listDocs.docs.map(async (listDoc) => {
                // Create a new document in the 'list' subcollection of 'month1'
                const newDocRef = month1Ref.collection('list').doc(listDoc.id);

                // Copy data from the source to the destination document
                await newDocRef.set(listDoc.data());

                // Move data in the nested 'list' subcollection
                const nestedListDocs = await listDoc.ref.collection('list').get();
                const nestedListPromises = nestedListDocs.docs.map(async (nestedListDoc) => {
                    const newNestedDocRef = newDocRef.collection('list').doc(nestedListDoc.id);
                    await newNestedDocRef.set(nestedListDoc.data());
                });

                // Wait for all nested 'list' documents to be copied
                await Promise.all(nestedListPromises);
                });

                // Move data in the 'month1Meals' subcollection
                const mealsDocs = await thisMonthRef.collection('monthlyMeals').get();
                const mealsPromises = mealsDocs.docs.map(async (mealsDoc) => {
                // Create a new document in the 'month1Meals' subcollection of 'month1'
                const newDocRef = month1Ref.collection('month1Meals').doc(mealsDoc.id);

                // Copy data from the source to the destination document
                await newDocRef.set(mealsDoc.data());
                });

                // Move data in the 'month1Spend' subcollection
                const spendDocs = await thisMonthRef.collection('monthlySpend').get();
                const spendPromises = spendDocs.docs.map(async (spendDoc) => {
                // Create a new document in the 'month1Spend' subcollection of 'month1'
                const newDocRef = month1Ref.collection('month1Spend').doc(spendDoc.id);

                // Copy data from the source to the destination document
                await newDocRef.set(spendDoc.data());
                });

                // Wait for all 'list', 'month1Meals', and 'month1Spend' documents to be copied
                await Promise.all([...listPromises, ...mealsPromises, ...spendPromises]);

                console.log('Data from thisMonth moved to month1 successfully!');
                await thisMonthRef.delete()
            }
        } catch (error) {
            console.error('Error moving data:', error);
        }
    };

    checkIfNewWeek = async (ordersCollectionRef) => {
        try {
            //* - - GET DATABASE WEEK STARTING - - *//
            let thisWeekRef = ordersCollectionRef.doc("thisWeek");
            let thisWeekSnapshot = await thisWeekRef.get();
            
            if (thisWeekSnapshot.exists) {
                let databaseWeekStarting = thisWeekSnapshot.data().weekStarting;
    
                    //* - - GET CURRENT DATE WEEK STARTING - - *//
                let currentDate = new Date()
                let formattedDate = this.formatDate(currentDate)
                formattedDate = "04-01-2024"
                let currentDateWeekStarting = this.getFirstDayOfWeek(formattedDate)
    
                if (databaseWeekStarting !== currentDateWeekStarting) {
                    // Delete the document if the condition is met
                    await thisWeekRef.delete();
                } else {
                    console.log("same week bro")
                }
            }
        } catch (error) {
            console.log("Error occurred in checkIfNewWeek", error);
        }
    }  

    checkIfNewDay = async (ordersCollectionRef) => {
        let thisDayRef = ordersCollectionRef.doc("thisDay")
        let thisDaySnapshot  = await thisDayRef.get()

                //* - - GET CURRENT DATE WEEK STARTING - - *//
        let currentDate = new Date()
        let formattedDate = this.formatDate(currentDate)
        formattedDate = "04-01-2024"
        if (thisDaySnapshot.exists) {
            let databaseCurrentDay = thisDaySnapshot.data().currentDate
            if (databaseCurrentDay !== formattedDate) {
                await thisDayRef.delete()
            } else {
                console.log('same day bro')
            }
        }
    }  

    getFirstDayOfWeek = (inputDate) => {
        // Create a Date object from the input date string
        const date = new Date(inputDate);
    
        // Calculate the difference in days between the current day and Monday
        let diff = date.getDay() - 1;
    
        // If the current day is Sunday (0), set the difference to 6 (to get the previous Monday)
        if (diff === -1) {
            diff = 6;
        }
    
        // Adjust the date to get the first day (Monday) of the week
        date.setDate(date.getDate() - diff);
    
        // Extract day, month, and year
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based
        const year = date.getFullYear();
    
        // Format the result as mm/dd/yyyy
        const formattedResult = `${month}-${day}-${year}`;
    
        return formattedResult;
    }

    getLastDayOfWeek = (inputDate) => {
        // Create a Date object from the input date string
        const date = new Date(inputDate);
    
        // Check if the input date is a Sunday
        if (date.getDay() === 0) {
            // If it's a Sunday, set the date to the previous Monday
            date.setDate(date.getDate());
        } else {
            // Find the last day of the week (Sunday) following the given date
            date.setDate(date.getDate() + (6 - date.getDay()) + 1);
        }
    
        // Extract day, month, and year
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based
        const year = date.getFullYear();
    
        // Format the result as mm/dd/yyyy
        const formattedResult = `${month}-${day}-${year}`;
    
        return formattedResult;
    }
    
    onChange = (event, { newValue }) => {
        this.setState({
          value: newValue
        });
    };
      // Autosuggest will call this function every time you need to update suggestions.
      // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: getSuggestions(value)
        });
    };
    
      // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    suggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        console.log(suggestion.name)
    }

    gettingStartedClicked = () => {
        this.setState({
            showExplorePlansBtn: false,
            showTopDashboards: false,
            showLoadingRightPanel: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showLoadingRightPanel: false,
                    showGettingStarted: true
                })
            }, 2500)
        })
    }

    explorePlansClicked = () => {
        this.setState({
            rewardsSidepaneColor: "#0930CB",
            showExplorePlansBtn: false,
            showTopDashboards: false,
            showLoadingRightPanel: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showLoadingRightPanel: false,
                    showAllPlans: true,
                    showRewardsBtns: true
                })
            }, 2500)
        })
    }

    loadMenuItems = () => {
        class Menu {
            constructor(label, value) {
                this.label = label
                this.value = value
            }
            toString() {
                return this.label + ', ' +
                this.value
            }
        }
        var menuConverter = {
            toFirestore : function(menu) {
                return {
                    label: menu.label,
                    value: menu.value
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new Menu(data.label, data.value)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("menu")
        .doc("categories")
        .collection("list")
        .withConverter(menuConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            this.setState({
                menuCategories: data
            })
        })
    }

    loadSavedData = () => {
        this.getLatestRewardCount()
        this.getRewards()
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .get().then(doc => {
            if (doc.exists) {
                if (doc.data().singularPoints != "" && doc.data().pluralPoints != "") {
                    this.setState({
                        showSectionLoading: true,
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                pointsSingleValue: doc.data().singularPoints,
                                pointsPluralValue: doc.data().pluralPoints,
                                showLoyaltyEditHeader: false,
                                showEditLoyaltyPoints: false,
                                showPointsEditBtn:false,
                                showEarningValueFirstScreen: true,
                                showBaselineValueBtn: true,
                                showLoyaltyHeader: true,
                                showLoyaltyPoints: true,
                                showEarnPointsDirect: true,
                                showPointsDisplayBtn: true,
                                pointsSinglLabelBorderColor: "#000",
                                pointsSingleLabelColor: "#000",
                                pointsPluralLabelBorderColor: "#000",
                                pointsPluralLabelColor: "#000",
                                // showPointsBtn2Selected: true,
                                // showPointsBtn1Unselected: true,
                                // showPointsBtn3Unselected: true,
                                // pointsBtn2SelectedBgColor: "#0930CB",
                                // pointsBtn2SelectedTxtColor: "white",
                                // pointsBtn2SelectedBorderColor: "#0930CB",
                                showSectionLoading: false
                            })
                        }, 2500)
                    })
                } else {
                    this.setState({
                        showSectionLoading: true
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                showSectionLoading: false,
                                showEarningValueFirstScreen: true,
                                // showPointsBtn2Selected: true,
                                // showPointsBtn1Unselected: true,
                                // showPointsBtn3Unselected: true,
                                // pointsBtn2SelectedBgColor: "#0930CB",
                                // pointsBtn2SelectedTxtColor: "white",
                                // pointsBtn2SelectedBorderColor: "#0930CB",
                                showBaselineValueBtn: true,
                                showLoyaltyEditHeader: true,
                                showEditLoyaltyPoints: true,
                                showEarnPointsDirect: true,
                                showPointsEditBtn:true
                            })
                        }, 2500)
                    })
                }
                if (doc.data().expirationValue != "" && doc.data().pointsValue != "" && doc.data().moneyValue != "") {
                    this.setState({
                        showSectionLoading2: true
                    }, () => {
                        setTimeout(() => {
                            let multiplier = Number(doc.data().moneyValue) / Number(doc.data().pointsValue)
                            this.setState({
                                pointsExpirationValue: doc.data().expirationValue,
                                pointsEarnedValue: doc.data().pointsValue,
                                pointsMoneyValue: doc.data().moneyValue,
                                savedPointsValue: doc.data().pointsValue,
                                savedMoneyValue: doc.data().moneyValue,
                                earnMultiplier: multiplier,
                                showEarningValueFirstScreen: false,
                                showEarningEditHeader: true,
                                showEarningValueOptions: true,
                                showEditEarningValue: false,
                                showEditExpirationHeader: false,
                                showEarningEditBtn: false,
                                showEditExpirationLoyalty: false,
                                showEarningHeader: false,
                                showEarningValue: false,
                                showExpirationHeader: false,
                                showEarningDisplayBtn: false,
                                showExpirationLoyalty: false,
                                showBaselineValueBtn: true,
                                showShowAllEarningsHeader: true,
                                pointsEarnedValueBorderColor: "#000",
                                pointsEarnedValueLabelColor: "#000",
                                pointsEarnedPercentageValueBorderColor: "#000",
                                pointsEarnedPercentageValueLabelColor: "#000",
                                pointsMoneyValueBorderColor: "#000",
                                filterOptionPricingBorderColor: "#000",
                                filterOptionFrequencyBorderColor: "#000",
                                pointsMoneyValueLabelColor: "#000",
                                pointsExpirationBoxShadowColor: "0, 0, 0, 0",
                                priceFilterBoxShadowColor: "0, 0, 0, 0",
                                mealCategoryBoxShadowColor: "0, 0, 0, 0",
                                mealSelectedBoxShadowColor: "0, 0, 0, 0",
                                mealQuantityBoxShadowColor: "0, 0, 0, 0",
                                showSectionLoading2: false
                            })
                        }, 2500)
                    })
                } else {
                    this.setState({
                        showSectionLoading2: true,
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                showEarningEditHeader: true,
                                showEarningValueFirstScreen: true,
                                showBaselineValueBtn: true,
                                showEditEarningValue: true, 
                                showEarningEditBtn: true,
                                // showPointsBtn2Selected: true,
                                showEditExpirationHeader: true,
                                showEditExpirationLoyalty: true,
                                showSectionLoading2: false
                            })
                            if (doc.data().baselineNotification == true) {
                                this.setState({
                                    showBaselineIntroMessage: true
                                })
                            }
                        }, 2500)
                    })
                }
            }
        })
    }

    pointsClicked = () => {
        this.loadSavedData()
        this.loadMenuItems()
        this.loadSavedReferralData()
        this.fetchRewardsSelectedCountOnPageLoad()
        this.fetchSelectedRewardsIDs()
        this.firstLoadRewardTable()
        this.setState({
            showRewardsBtns: false,
            showPointsComponent: true,
            showPointsComponentOptions: true,
        })
        if (this.state.currentRewardsPage == 1) {
            this.setState({
                prevBtnTxtRewards: "",
            })
        }
    }

    loadSavedReferralData = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("earning")
        .doc("parameters")
        .collection("referral")
        .doc("referralData")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    savedReferralRegistrationPointsValue: doc.data().referralPointsEarnedValue,
                    savedReferralRegistrationValue: doc.data().referralRegistrationValue
                })
            }
        })
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("earning")
        .doc("parameters")
        .get().then(doc => {
            if (doc.exists) {
                if (doc.data().referralLimitCount == 0) {
                    this.setState({
                        savedReferralRegistrationLimitValue: "n/a"
                    })
                } else {
                    this.setState({
                        savedReferralRegistrationLimitValue: doc.data().referralLimitCount
                    })
                }
            }
        })
    }

    firstLoadRewardTable = () => {
        this.setState({
            showSectionLoading3: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showSectionLoading3: false,
                    showRewardsHeader: true,
                    showAddRewardBtn: true,
                    showRewardsTable: true,
                    showRenderRewardsTable: true
                })
            }, 2500)
        })
    }

    saveLoyaltyPoints = async () => {
        if (this.state.pointsSingleValue == "") {
            this.setState({
                pointsSinglLabelBorderColor: "red",
                pointsSingleLabelColor: "red"
            })
        }
        if (this.state.pointsPluralValue == "") {
            this.setState({
                pointsPluralLabelBorderColor: "red",
                pointsPluralLabelColor: "red"
            })
        }
        if (this.state.pointsSingleValue != "" && this.state.pointsPluralValue != "") {
            await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .update({
                singularPoints: this.state.pointsSingleValue,
                pluralPoints: this.state.pointsPluralValue
            })
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("points")
            .set({
                pointsLabelPlural: this.state.pointsPluralValue,
                pointsLabelSingular: this.state.pointsSingleValue
            })
            this.setState({
                showSectionLoading: true,
                showLoyaltyEditHeader: false,
                showEditLoyaltyPoints: false,
                showPointsEditBtn:false,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showLoyaltyHeader: true,
                        showLoyaltyPoints: true,
                        showPointsDisplayBtn: true,
                        pointsSinglLabelBorderColor: "#000",
                        pointsSingleLabelColor: "#000",
                        pointsPluralLabelBorderColor: "#000",
                        pointsPluralLabelColor: "#000",
                        showSectionLoading: false
                    })
                }, 2500)
            })
        }
    }

    saveEarningValue = () => {
        if (this.state.showEarnPointsDirect == true) {
            if (this.state.pointsEarnedValue == "") {
                this.setState({
                    pointsEarnedValueBorderColor: "red",
                    pointsEarnedValueLabelColor: "red"
                })
            }
        } 
        
        if (this.state.showEarnPointsPercentage == true) {
            if (this.state.pointsEarnedPercentageValue == "") {
                this.setState({
                    pointsEarnedPercentageValueBorderColor: "red",
                    pointsEarnedPercentageValueLabelColor: "red"
                })
            }
        }
        if (this.state.pointsMoneyValue == "") {
            this.setState({
                pointsMoneyValueBorderColor: "red",
                pointsMoneyValueLabelColor: "red"
            })
        }
        if (this.state.pointsExpirationValue == "") {
            this.setState({
                pointsExpirationBoxShadowColor: "240, 52, 52, 1"
            })
        }
        if (this.state.showEarnPointsDirect == true) {
            if (this.state.pointsEarnedValue != "" && this.state.pointsMoneyValue !="" && this.state.pointsExpirationValue != "") {
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .update({
                    expirationValue: this.state.pointsExpirationValue,
                    moneyValue: this.state.pointsMoneyValue,
                    pointsValue: this.state.pointsEarnedValue
                })
                this.setState({
                        showSectionLoading2: true,
                        showEarningEditHeader: false,
                        showBaselineValueBtn: false,
                        showEarningValueFirstScreen: false,
                        showEditEarningValue: false,
                        showEditExpirationHeader: false,
                        showEarningEditBtn: false,
                        showEditExpirationLoyalty: false,
                        showFilterOptionsInProgress: false,
                        savedMoneyValue: this.state.pointsMoneyValue,
                        savedPointsValue: this.state.pointsEarnedValue,
                        showBaselineIntroMessage: false,
                        baselineValueMsg: ""
                }, () => {
                    setTimeout(() => {
                        let multiplier = Number(this.state.pointsMoneyValue) / Number(this.state.pointsEarnedValue)
                        this.setState({
                            earnMultiplier: multiplier,
                            // showEarningHeader: true,
                            // showEarningValue: true,
                            // showExpirationHeader: true,
                            // showEarningDisplayBtn: true,
                            // showExpirationLoyalty: true,
                            showShowAllEarningsHeader: true,
                            showFilterOptionsInProgress:  false,
                            showEarningValueOptions: true,
                            showEarningEditHeader: true,
                            showEarningValueFirstScreen: true,
                            showBaselineValueBtn: true,
                            pointsEarnedValueBorderColor: "#000",
                            pointsEarnedValueLabelColor: "#000",
                            pointsEarnedPercentageValueBorderColor: "#000",
                            pointsEarnedPercentageValueLabelColor: "#000",
                            pointsMoneyValueBorderColor: "#000",
                            pointsMoneyValueLabelColor: "#000",
                            pointsExpirationBoxShadowColor: "0, 0, 0, 0",
                            showSectionLoading2: false
                        })
                    }, 2500)
                })
            }
        }
    }

    updateAllEarningPolicies = () => {
        console.log(this.state.listEarningPolicies)
    }

    editLoyaltyPoints = () => {
        this.setState({
            showLoyaltyEditHeader: true,
            showEditLoyaltyPoints: true,
            showPointsEditBtn: true,
            showLoyaltyHeader: false,
            showLoyaltyPoints: false,
            showPointsDisplayBtn: false,
        })
    }

    editEarningValue = () => {
        this.setState({
            showEarningEditHeader: true,
            showEditEarningValue: true,
            showEditExpirationHeader: true,
            showEarningEditBtn: true,
            showEditExpirationLoyalty: true,
            showMoreOptionsBtn: true,
            showEarningHeader: false,
            showEarningValue: false,
            showExpirationHeader: false,
            showEarningDisplayBtn: false,
            showExpirationLoyalty: false,
        })
    }

    handleChange = (event) => {
        this.setState({
            [event.target.id] : event.target.value,
        })
    }

    handleChangePointsValue = (event) => {
        let oldRatio = this.roundToDecimal(parseFloat(this.state.savedPointsValue), 3) / this.roundToDecimal(parseFloat(this.state.savedMoneyValue), 3)
        let newRatio = this.roundToDecimal(parseFloat(event.target.value), 3) / this.roundToDecimal(parseFloat(this.state.pointsMoneyValue), 3)
        this.setState({
            [event.target.id] : event.target.value,
            earningPolicyPercentageValue: parseInt(this.calculatePercentageChange(oldRatio, newRatio))
        })
    }

    handleChangeMoneyValue = (event) => {
        let oldRatio = this.roundToDecimal(parseFloat(this.state.savedPointsValue), 3) / this.roundToDecimal(parseFloat(this.state.savedMoneyValue), 3)
        let newRatio = this.roundToDecimal(parseFloat(this.state.pointsEarnedValue), 3) / this.roundToDecimal(parseFloat(event.target.value), 3)
        this.setState({
            [event.target.id] : event.target.value,
            earningPolicyPercentageValue: parseInt(this.calculatePercentageChange(oldRatio, newRatio))
        })
    }

    handleChange2 = (event) => {
        this.setState({
            [event.target.id] : event.target.value,
            moneyEquivalent: Number(event.target.value) * this.state.earnMultiplier
        })
    }

    handleSinglePointsClicked = () => {
        if (this.state.pointsPluralValue != "") {
            this.setState({
                pointsSinglLabelBorderColor: "#0930CB",
                pointsSingleLabelColor: "#000",
                pointsPluralLabelBorderColor: "#000",
                pointsPluralLabelColor: "#000"
            })
        } else {
            this.setState({
                pointsSinglLabelBorderColor: "#0930CB",
                pointsSingleLabelColor: "#000",
                pointsPluralLabelBorderColor: "#E6E6E6",
                pointsPluralLabelColor: "#939393"
            })
        } 
    }

    handlePluralPointsClicked = () => {
        if (this.state.pointsSingleValue != "") {
            this.setState({
                pointsPluralLabelBorderColor: "#0930CB",
                pointsPluralLabelColor: "#000",
                pointsSinglLabelBorderColor: "#000",
                pointsSingleLabelColor: "#000"
            })
        } else {
            this.setState({
                pointsPluralLabelBorderColor: "#0930CB",
                pointsPluralLabelColor: "#000",
                pointsSinglLabelBorderColor: "#E6E6E6",
                pointsSingleLabelColor: "#939393"
            })
        }
    }

    handleEarnedValueClicked = () => {
        if (this.state.pointsMoneyValue != "") {
            this.setState({
                pointsEarnedValueBorderColor: "#0930CB",
                pointsEarnedValueLabelColor: "#000",
                pointsMoneyValueBorderColor: "#000",
                pointsMoneyValueLabelColor: "#000"
            })
        } else {
            this.setState({
                pointsEarnedValueBorderColor: "#0930CB",
                pointsEarnedValueLabelColor: "#000",
                pointsMoneyValueBorderColor: "#E6E6E6",
                pointsMoneyValueLabelColor: "#939393"
            })
        }
    }

    handleEarnedPercentageValueClicked = () => {
        if (this.state.pointsMoneyValue != "") {
            this.setState({
                pointsEarnedPercentageValueBorderColor: "#0930CB",
                pointsEarnedPercentageValueLabelColor: "#000",
                pointsMoneyValueBorderColor: "#000",
                pointsMoneyValueLabelColor: "#000"
            })
        } else {
            this.setState({
                pointsEarnedPercentageValueBorderColor: "#0930CB",
                pointsEarnedPercentageValueLabelColor: "#000",
                pointsMoneyValueBorderColor: "#E6E6E6",
                pointsMoneyValueLabelColor: "#939393"
            })
        }
    }

    handleMoneyValueClicked = () => {
        if (this.state.pointsEarnedValue != "") {
            this.setState({
                pointsMoneyValueBorderColor: "#0930CB",
                pointsMoneyValueLabelColor: "#000",
                pointsEarnedValueBorderColor: "#000",
                pointsEarnedValueLabelColor: "#000"
            })
        } else {
            this.setState({
                pointsMoneyValueBorderColor: "#0930CB",
                pointsMoneyValueLabelColor: "#000",
                pointsEarnedValueBorderColor: "#E6E6E6",
                pointsEarnedValueLabelColor: "#939393"
            })
        }

        if (this.state.pointsEarnedPercentageValue != "") {
            this.setState({
                pointsMoneyValueBorderColor: "#0930CB",
                pointsMoneyValueLabelColor: "#000",
                pointsEarnedPercentageValueBorderColor: "#000",
                pointsEarnedPercentageValueLabelColor: "#000"
            })
        } else {
            this.setState({
                pointsMoneyValueBorderColor: "#0930CB",
                pointsMoneyValueLabelColor: "#000",
                pointsEarnedPercentageValueBorderColor: "#E6E6E6",
                pointsEarnedPercentageValueLabelColor: "#939393"
            })
        }
    }

    handleRewardsValueClicked = () => {
        this.setState({
            pointsRewardValueBorderColor: "#0930CB",
            pointsRewardValueLabelColor: "#000",
        })
    }

    handlePercentageOffValueClicked = () => {
        this.setState({
            percentageOffValueBorderColor: "#0930CB",
            percentageOffValueLabelColor: "#000"
        })
    }

    handleMoneyOffValueClicked = () => {
        this.setState({
            moneyOffValueBorderColor: "#0930CB",
            moneyOffValueLabelColor: "#000"
        })
    }

    handleRewardExpirationValueClicked = () => {
        this.setState({
            rewardExpirationValueBorderColor: "#0930CB",
            rewardExpirationValueLabelColor: "#000"
        })
    }

    handleReferralRegistrationsValueClicked = () => {
        this.setState({
            referralRegistrationValueBorderColor: "#0930cb",
            referralRegistrationValueLabelColor: "#000"
        })
    }

    handleReferralRegistrationLimitValueClicked = () => {
        this.setState({
            referralRegistrationLimitBorderColor: "#0930cb",
            referralRegistrationLimitLabelColor: "#000"
        })
    }

    setExpirationPoints = (selectedOptions) => {
        this.setState({
            pointsExpirationValue: selectedOptions.label
        })
    }

    handleFilterOptionPricingClicked = () => {
        if (this.state.filterOptionPricingBorderColor == "#000") {
            this.setState({
                filterOptionPricingBorderColor: "#0930CB"
            })
        }
    }

    handleFilterOptionFrequencyClicked = () => {
        if (this.state.filterOptionFrequencyBorderColor == "#000") {
            this.setState({
                filterOptionFrequencyBorderColor: "#0930CB"
            })
        }
    }

    renderRewards = () => {
        return (
        <div className='pointsSystem'>
            <div className='pointsSystemCol'>
                <h4>Loyalty customers earn ____ point(s)</h4>
                {/* <div onClick={this.handleEarnedValueClicked} style={pointsEarnedValueInput} className='pointsInput'>
                    <p style={pointsEarnedValueLabel}>Point value (enter a number)</p>
                    <input
                    id='pointsEarnedValue'
                    placeholder='1'
                    value={this.state.pointsEarnedValue}
                    onChange={this.handleChange}
                    onClick={this.handleEarnedValueClicked}
                    />
                </div> */}
            </div>
            <div className='pointsSystemCol'>
                <h4>for every KES ____ spent</h4>
                {/* <div onClick={this.handleMoneyValueClicked} style={pointsMoneyValueInput} className='pointsInput'>
                    <p style={pointsMoneyValueLabel}>Money value (enter a number)</p>
                    <input
                    id='pointsMoneyValue'
                    placeholder='100'
                    value={this.state.pointsMoneyValue}
                    onChange={this.handleChange}
                    onClick={this.handleMoneyValueClicked}
                    />
                </div> */}
            </div>
        </div>
    )
    }

    addNewRewardClicked = () => {
        if (this.state.savedPointsValue != "" && this.state.savedMoneyValue != "") {
            this.setState({
                pointsRewardValue: "",
                moneyEquivalent: 0,
                showAddRewardBtn: false,
                showRewardsTable: false,
                showSectionLoading3: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSectionLoading3: false,
                        showAddRewardDisplay: true
                })
                }, 2500)
            })
        } else {
            this.setState({
                showRewardsErrorMsg: true           
            })
        }
    }

    handleRewardClicked = (selectedOption) => { 
        if (selectedOption.value == "custom-reward") {
            this.setState({
                rewardType: selectedOption.value,
                showRewardsCategories2: false,
                showMoneyOffReward: false,
                showPercentageOffReward: false,
                showCustomReward: true,
                showExpirationRewardDate: true,
            })
        } else if (selectedOption.value == "percentage-off") {
            this.setState({
                showRewardsCategories2: true,
                rewardType: selectedOption.value,
                showMoneyOffReward: false,
                showPercentageOffReward: true,
                showCustomReward: false,
                showExpirationRewardDate: true,
            })
        } else if (selectedOption.value == "amount-off") {
            this.setState({
                showRewardsCategories2: true,
                rewardType: selectedOption.value,
                showPercentageOffReward: false,
                showMoneyOffReward: true,
                showCustomReward: false,
                showExpirationRewardDate: true,
            })
        } else {
            //* - - FREE ITEM - - *//
            this.setState({
                showRewardsCategories2: true,
                rewardType: selectedOption.value,
                showCustomReward: false,
                showMoneyOffReward: false,
                showPercentageOffReward: false,
                showExpirationRewardDate: true,
            })
        }
        
    }

    getSelectedMenuCategory = (category) => {
        class Menu {
            constructor(label, value) {
                this.label = label
                this.value = value
            }
            toString() {
                return this.label + ', ' +
                this.value
            }
        }
        var menuConverter = {
            toFirestore : function(menu) {
                return {
                    label: menu.label,
                    value: menu.value
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new Menu(data.label, data.value)
            }
        }
        fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("menu")
            .doc("list")
            .collection(category)
            .withConverter(menuConverter)
            .get().then(snapshot => {
                const data = snapshot.docs.map(doc => doc.data())
                this.setState({
                    selectedMenuCategory: data
                })
            })
    }

    handleMenuCategoryClicked = (selectedOptions) => { 
        var coffee_and_tea = "coffee_and_tea"
        var iced_coffee_and_tea = "iced_coffee_and_tea"
        var breakfast = "breakfast"
        var starters_and_sharing = "starters_and_sharing"
        var lunch_and_dinner = "lunch_and_dinner"
        var burgers = "burgers"
        var chips = "chips"
        var wings = "wings"
        var sandwiches = "sandwiches"
        var salads = "salads"
        var art_pizzas = "art_pizzas"
        var pasta = "pasta"
        var bakery = "bakery"
        var cakes_and_desserts = "cakes_and_desserts"
        var cold_press_juices = "cold_press_juices"
        var soft_drinks = "soft_drinks"
        var kids_menu = "kids_menu"
        var whole_cakes = "whole_cakes"
        var power_smoothies = "power_smoothies"
        var steaks = "steaks"
        var soup = "soup"
        var mocktails = "mocktails"
        var hot_n_boozy = "hot_n_boozy"
        var beer = "beer"
        var white_wine = "white_wine"
        var sangria = "sangria"
        var red_wine = "red_wine"
        var sparkling = "sparkling"
        var rose = "rose"
        var art_cocktails = "art_cocktails"
        var cocktails = "cocktails"
        var spirits_and_liquer = "spirits_and_liquer"
        let milkshakes = "milkshakes"
        let quiches = "quiches"

        this.setState({
            showMealOrderDetails: true,
            showMealSelectedLabel: false,
            showMealSelectedLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showMealSelectedLoading: false,
                    showMealSelectedLabel: true
                })
            }, 2500)
        })

        if (selectedOptions.value == coffee_and_tea) {
            this.getSelectedMenuCategory(coffee_and_tea)
            this.setState({
                rewardMenuCategory: coffee_and_tea,
                showCoffeeAndTea: true,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == iced_coffee_and_tea) {
            this.getSelectedMenuCategory(iced_coffee_and_tea)
            this.setState({
                rewardMenuCategory: iced_coffee_and_tea,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: true,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == breakfast) {
            this.getSelectedMenuCategory(breakfast)
            this.setState({
                rewardMenuCategory: breakfast,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: true,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == starters_and_sharing) {
            this.getSelectedMenuCategory(starters_and_sharing)
            this.setState({
                rewardMenuCategory: starters_and_sharing,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: true,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == lunch_and_dinner) {
            this.getSelectedMenuCategory(lunch_and_dinner)
            this.setState({
                rewardMenuCategory: lunch_and_dinner,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: true,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == burgers) {
            this.getSelectedMenuCategory(burgers)
            this.setState({
                rewardMenuCategory: burgers,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: true,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == chips) {
            this.getSelectedMenuCategory(chips)
            this.setState({
                rewardMenuCategory: chips,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: true,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == wings) {
            this.getSelectedMenuCategory(wings)
            this.setState({
                rewardMenuCategory: wings,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: true,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == sandwiches) {
            this.getSelectedMenuCategory(sandwiches)
            this.setState({
                rewardMenuCategory: sandwiches,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: true,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == salads) {
            this.getSelectedMenuCategory(salads)
            this.setState({
                rewardMenuCategory: salads,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: true,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == art_pizzas) {
            this.getSelectedMenuCategory(art_pizzas)
            this.setState({
                rewardMenuCategory: art_pizzas,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: true,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == pasta) {
            this.getSelectedMenuCategory(pasta)
            this.setState({
                rewardMenuCategory: pasta,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: true,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == bakery) {
            this.getSelectedMenuCategory(bakery)
            this.setState({
                rewardMenuCategory: bakery,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: true,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == cakes_and_desserts) {
            this.getSelectedMenuCategory(cakes_and_desserts)
            this.setState({
                rewardMenuCategory: cakes_and_desserts,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: true,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == cold_press_juices) {
            this.getSelectedMenuCategory(cold_press_juices)
            this.setState({
                rewardMenuCategory: cold_press_juices,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: true,
                showSoftDrinks: false,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == soft_drinks) {
            this.getSelectedMenuCategory(soft_drinks)
            this.setState({
                rewardMenuCategory: soft_drinks,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: true,
                showKidsMenu: false,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == kids_menu) {
            this.getSelectedMenuCategory(kids_menu)
            this.setState({
                rewardMenuCategory: kids_menu,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: true,
                showPowerSmoothies: false,
                showWholeCakes: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == whole_cakes) {
            this.getSelectedMenuCategory(whole_cakes)
            this.setState({
                rewardMenuCategory: whole_cakes,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: true,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == power_smoothies) {
            this.getSelectedMenuCategory(power_smoothies)
            this.setState({
                rewardMenuCategory: power_smoothies,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: true,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == steaks) {
            this.getSelectedMenuCategory(steaks)
            this.setState({
                rewardMenuCategory: steaks,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: true,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == soup) {
            this.getSelectedMenuCategory(soup)
            this.setState({
                rewardMenuCategory: soup,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: true,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == mocktails) {
            this.getSelectedMenuCategory(mocktails)
            this.setState({
                rewardMenuCategory: mocktails,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: true,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == hot_n_boozy) {
            this.getSelectedMenuCategory(hot_n_boozy)
            this.setState({
                rewardMenuCategory: hot_n_boozy,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: true,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == beer) {
            this.getSelectedMenuCategory(beer)
            this.setState({
                rewardMenuCategory: beer,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: true,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == white_wine) {
            this.getSelectedMenuCategory(white_wine)
            this.setState({
                rewardMenuCategory: white_wine,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: true,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == sangria) {
            this.getSelectedMenuCategory(sangria)
            this.setState({
                rewardMenuCategory: sangria,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: true,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == red_wine) {
            this.getSelectedMenuCategory(red_wine)
            this.setState({
                rewardMenuCategory: red_wine,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: true,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == sparkling) {
            this.getSelectedMenuCategory(sparkling)
            this.setState({
                rewardMenuCategory: sparkling,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: true,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == sparkling) {
            this.getSelectedMenuCategory(sparkling)
            this.setState({
                rewardMenuCategory: sparkling,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: true,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == rose) {
            this.getSelectedMenuCategory(rose)
            this.setState({
                rewardMenuCategory: rose,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: true,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == art_cocktails) {
            this.getSelectedMenuCategory(art_cocktails)
            this.setState({
                rewardMenuCategory: art_cocktails,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: true,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == cocktails) {
            this.getSelectedMenuCategory(cocktails)
            this.setState({
                rewardMenuCategory: cocktails,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: true,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == spirits_and_liquer) {
            this.getSelectedMenuCategory(spirits_and_liquer)
            this.setState({
                rewardMenuCategory: spirits_and_liquer,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: true,
                showMilkshakes: false,
                showQuiches: false,
            })
        } else if (selectedOptions.value == milkshakes) {
            this.getSelectedMenuCategory(milkshakes)
            this.setState({
                rewardMenuCategory: milkshakes,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: true,
                showQuiches: false,
            })
        } else if (selectedOptions.value == quiches) {
            this.getSelectedMenuCategory(quiches)
            this.setState({
                rewardMenuCategory: quiches,
                showCoffeeAndTea: false,
                showIcedCoffeeAndTea: false,
                showBreakfast: false,
                showStartersAndSharing: false,
                showLunchAndDinner: false,
                showBurgers: false,
                showChips: false,
                showWings: false,
                showSandwiches: false,
                showSalads: false,
                showArtPizzas: false,
                showPasta: false,
                showBakery: false,
                showCakesAndDesserts: false,
                showColdPressJuices: false,
                showSoftDrinks: false,
                showKidsMenu: false,
                showWholeCakes: false,
                showPowerSmoothies: false,
                showSteaks: false,
                showSoup: false,
                showMocktails: false,
                showHotNBoozy: false,
                showBeer: false,
                showWhiteWine: false,
                showSangria: false,
                showRedWine: false,
                showSparkling: false,
                showRose: false,
                showArtCocktails: false,
                showCocktails: false,
                showSpiritsAndLiquer: false,
                showMilkshakes: false,
                showQuiches: true,
            })
        }
    }

    handleMenuCategoryClickedRewards = (selectedOptions) => {
        var coffee_and_tea = "coffee_and_tea"
        var iced_coffee_and_tea = "iced_coffee_and_tea"
        var breakfast = "breakfast"
        var starters_and_sharing = "starters_and_sharing"
        var lunch_and_dinner = "lunch_and_dinner"
        var burgers = "burgers"
        var chips = "chips"
        var wings = "wings"
        var sandwiches = "sandwiches"
        var salads = "salads"
        var art_pizzas = "art_pizzas"
        var pasta = "pasta"
        var bakery = "bakery"
        var cakes_and_desserts = "cakes_and_desserts"
        var cold_press_juices = "cold_press_juices"
        var soft_drinks = "soft_drinks"
        var kids_menu = "kids_menu"
        var whole_cakes = "whole_cakes"
        var power_smoothies = "power_smoothies"
        var steaks = "steaks"
        var soup = "soup"
        var mocktails = "mocktails"
        var hot_n_boozy = "hot_n_boozy"
        var beer = "beer"
        var white_wine = "white_wine"
        var sangria = "sangria"
        var red_wine = "red_wine"
        var sparkling = "sparkling"
        var rose = "rose"
        var art_cocktails = "art_cocktails"
        var cocktails = "cocktails"
        var spirits_and_liquer = "spirits_and_liquer"
        var milkshakes = "milkshakes"
        var quiches = "quiches"

        if (selectedOptions.value == coffee_and_tea) {
            this.getSelectedMenuCategory(coffee_and_tea)
            this.setState({
                rewardMenuCategoryRewards: coffee_and_tea,
                showCoffeeAndTea2: true,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == iced_coffee_and_tea) {
            this.getSelectedMenuCategory(iced_coffee_and_tea)
            this.setState({
                rewardMenuCategoryRewards: iced_coffee_and_tea,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: true,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == breakfast) {
            this.getSelectedMenuCategory(breakfast)
            this.setState({
                rewardMenuCategoryRewards: breakfast,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: true,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == starters_and_sharing) {
            this.getSelectedMenuCategory(starters_and_sharing)
            this.setState({
                rewardMenuCategoryRewards: starters_and_sharing,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: true,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == lunch_and_dinner) {
            this.getSelectedMenuCategory(lunch_and_dinner)
            this.setState({
                rewardMenuCategoryRewards: lunch_and_dinner,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: true,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == burgers) {
            this.getSelectedMenuCategory(burgers)
            this.setState({
                rewardMenuCategoryRewards: burgers,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: true,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == chips) {
            this.getSelectedMenuCategory(chips)
            this.setState({
                rewardMenuCategoryRewards: chips,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: true,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == wings) {
            this.getSelectedMenuCategory(wings)
            this.setState({
                rewardMenuCategoryRewards: wings,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: true,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == sandwiches) {
            this.getSelectedMenuCategory(sandwiches)
            this.setState({
                rewardMenuCategoryRewards: sandwiches,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: true,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == salads) {
            this.getSelectedMenuCategory(salads)
            this.setState({
                rewardMenuCategoryRewards: salads,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: true,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == art_pizzas) {
            this.getSelectedMenuCategory(art_pizzas)
            this.setState({
                rewardMenuCategoryRewards: art_pizzas,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: true,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == pasta) {
            this.getSelectedMenuCategory(pasta)
            this.setState({
                rewardMenuCategoryRewards: pasta,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalad2: false,
                showArtPizzas2: false,
                showPasta2: true,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == bakery) {
            this.getSelectedMenuCategory(bakery)
            this.setState({
                rewardMenuCategoryRewards: bakery,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: true,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == cakes_and_desserts) {
            this.getSelectedMenuCategory(cakes_and_desserts)
            this.setState({
                rewardMenuCategoryRewards: cakes_and_desserts,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: true,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == cold_press_juices) {
            this.getSelectedMenuCategory(cold_press_juices)
            this.setState({
                rewardMenuCategoryRewards: cold_press_juices,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: true,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == soft_drinks) {
            this.getSelectedMenuCategory(soft_drinks)
            this.setState({
                rewardMenuCategoryRewards: soft_drinks,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: true,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == kids_menu) {
            this.getSelectedMenuCategory(kids_menu)
            this.setState({
                rewardMenuCategoryRewards: kids_menu,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: true,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == whole_cakes) {
            this.getSelectedMenuCategory(whole_cakes)
            this.setState({
                rewardMenuCategoryRewards: whole_cakes,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: true,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == power_smoothies) {
            this.getSelectedMenuCategory(power_smoothies)
            this.setState({
                rewardMenuCategoryRewards: power_smoothies,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: true,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == steaks) {
            this.getSelectedMenuCategory(steaks)
            this.setState({
                rewardMenuCategoryRewards: steaks,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: true,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == soup) {
            this.getSelectedMenuCategory(soup)
            this.setState({
                rewardMenuCategoryRewards: soup,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: true,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == mocktails) {
            this.getSelectedMenuCategory(mocktails)
            this.setState({
                rewardMenuCategoryRewards: mocktails,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: true,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == hot_n_boozy) {
            this.getSelectedMenuCategory(hot_n_boozy)
            this.setState({
                rewardMenuCategoryRewards: hot_n_boozy,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: true,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == beer) {
            this.getSelectedMenuCategory(beer)
            this.setState({
                rewardMenuCategoryRewards: beer,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: true,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == white_wine) {
            this.getSelectedMenuCategory(white_wine)
            this.setState({
                rewardMenuCategoryRewards: white_wine,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: true,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == sangria) {
            this.getSelectedMenuCategory(sangria)
            this.setState({
                rewardMenuCategoryRewards: sangria,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: true,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == red_wine) {
            this.getSelectedMenuCategory(red_wine)
            this.setState({
                rewardMenuCategoryRewards: red_wine,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: true,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == sparkling) {
            this.getSelectedMenuCategory(sparkling)
            this.setState({
                rewardMenuCategoryRewards: sparkling,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: true,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == sparkling) {
            this.getSelectedMenuCategory(sparkling)
            this.setState({
                rewardMenuCategoryRewards: sparkling,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: true,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == rose) {
            this.getSelectedMenuCategory(rose)
            this.setState({
                rewardMenuCategoryRewards: rose,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: true,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == art_cocktails) {
            this.getSelectedMenuCategory(art_cocktails)
            this.setState({
                rewardMenuCategoryRewards: art_cocktails,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBee2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: true,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == cocktails) {
            this.getSelectedMenuCategory(cocktails)
            this.setState({
                rewardMenuCategoryRewards: cocktails,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: true,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == spirits_and_liquer) {
            this.getSelectedMenuCategory(spirits_and_liquer)
            this.setState({
                rewardMenuCategoryRewards: spirits_and_liquer,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: true,
                showMilkshakes2: false,
                showQuiches2: false
            })
        } else if (selectedOptions.value == milkshakes) {
            this.getSelectedMenuCategory(milkshakes)
            this.setState({
                rewardMenuCategoryRewards: milkshakes,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: true,
                showQuiches2: false
            })
        } else if (selectedOptions.value == quiches) {
            this.getSelectedMenuCategory(quiches)
            this.setState({
                rewardMenuCategoryRewards: quiches,
                showCoffeeAndTea2: false,
                showIcedCoffeeAndTea2: false,
                showBreakfast2: false,
                showStartersAndSharing2: false,
                showLunchAndDinner2: false,
                showBurgers2: false,
                showChips2: false,
                showWings2: false,
                showSandwiches2: false,
                showSalads2: false,
                showArtPizzas2: false,
                showPasta2: false,
                showBakery2: false,
                showCakesAndDesserts2: false,
                showColdPressJuices2: false,
                showSoftDrinks2: false,
                showKidsMenu2: false,
                showPowerSmoothies2: false,
                showWholeCakes2: false,
                showSteaks2: false,
                showSoup2: false,
                showMocktails2: false,
                showHotNBoozy2: false,
                showBeer2: false,
                showWhiteWine2: false,
                showSangria2: false,
                showRedWine2: false,
                showSparkling2: false,
                showRose2: false,
                showArtCocktails2: false,
                showCocktails2: false,
                showSpiritsAndLiquer2: false,
                showMilkshakes2: false,
                showQuiches2: true
            })
        }
    }

    rewardMenuItemSelected = (selectedOption) => {
        this.setState({
            rewardMenuItem: selectedOption.label
        })
    }

    rewardMenuItemSelectedRewards = (selectedOption) => {
        this.setState({
            rewardMenuItemRewardsTable: selectedOption.label
        })
    }

    getLatestRewardCount = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("rewards")
        .doc("rewardsList")
        .get().then(doc => {
            this.setState({
                rewardCount: doc.data().rewardCount
            })
        })

        
    }

    isValidDateFormat = (input) => {
        // Define a regular expression for the "dd/mm/yy" format
        var dateFormatRegex = /^\d{2}\/\d{2}\/\d{2}$/;
      
        // Use the test method of the regular expression to check if the input matches the format
        if (dateFormatRegex.test(input)) {
          // Replace slashes with dashes
          var dateString = input.replace(/\//g, '-');
      
          // Parse the input date
          var inputDate = new Date(dateString);
      
          // Get the current date
          var currentDate = new Date();
      
          // Add 20 to the year if it's represented by only the last two digits
          inputDate.setFullYear(inputDate.getFullYear() + (inputDate.getFullYear() < 2000 ? 2000 : 0));
      
          // Check if the input date is not before the current date
          if (inputDate >= currentDate) {
            console.log("Valid date format and not before the current date");
            return true;
          } else {
            console.log("Valid date format but before the current date");
            return false;
          }
        } else {
          console.log("Invalid date format");
          return false;
        }
    };

    saveReward = () => {
        
        if (this.state.rewardType === "percentage-off") {
            if (this.state.pointsRewardValue !== "" && this.state.rewardType !== "" && 
                this.state.rewardMenuCategoryRewards !== "" && this.state.rewardMenuItemRewardsTable !== "" && 
                this.state.rewardQuantityRewardTable !== "" && this.state.percentageOffValue !== "" &&
                this.state.rewardExpirationValue !== "" && this.isValidDateFormat(this.state.rewardExpirationValue)) {
                this.setState({
                    showSaveRewardBtn: false,
                    showSaveRewardBtnLoading: true
                })
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("rewards")
                .doc("rewardsList")
                .collection("list")
                .doc(`reward-${this.state.rewardCount}`)
                .set({
                    id: `reward-${this.state.rewardCount}`,
                    selected: false,
                    publicReward: true,
                    freeItem: false,
                    date: `${this.formatDateToDDMMYYYY(new Date())}`,
                    percentageOffValue: this.state.percentageOffValue,
                    moneyOffValue: this.state.moneyOffValue,
                    pointsRewardValue: this.state.pointsRewardValue,
                    moneyEquivalentValue: this.state.moneyEquivalent,
                    rewardType: this.state.rewardType,
                    rewardMenuCategory: this.state.rewardMenuCategoryRewards,
                    rewardMenuItem: this.state.rewardMenuItemRewardsTable,
                    rewardQuantity: this.state.rewardQuantityRewardTable,
                    customRewardValue: this.state.customRewardValue,
                    expiryDate: this.state.rewardExpirationValue.replace(/\//g, '-'),
                    status: false
                })
                .then(() => {
                    fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("admin")
                    .doc("points")
                    .collection("rewards")
                    .doc("rewardsList")
                    .update({
                        rewardCount: this.state.rewardCount-1
                    })
                    .then(() => {
                        this.saveRewardTransition()
                        setTimeout(() => {
                            this.getRewards()
                            this.getLatestRewardCount()
                            this.setState({
                                showPercentageOffReward: false,
                                percentageOffValue: "",
                                showSaveRewardBtn: true,
                                showSaveRewardBtnLoading: false
                            })
                        }, 1500)
                    })
                })
            } else {
                if (this.state.pointsRewardValue === "") {
                    this.setState({pointsRewardValueBorderColor: "red"})
                } else {
                    this.setState({pointsRewardValueBorderColor: "#0930cb"})
                }

                if (this.state.percentageOffValue === "") {
                    this.setState({percentageOffValueBorderColor: "red"})
                } else {
                    this.setState({percentageOffValueBorderColor: "#0930cb"})
                }

                if (this.state.rewardExpirationValue === "" || !this.isValidDateFormat(this.state.rewardExpirationValue)) {
                    this.setState({rewardExpirationValueBorderColor: "red"})
                } else {
                    this.setState({rewardExpirationValueBorderColor: "#0930cb"})
                }
                alert("Some input is missing or incorrect in your reward.")
            }
        } else if (this.state.rewardType === "amount-off") {
            if (this.state.pointsRewardValue !== "" && this.state.rewardType !== "" && 
            this.state.rewardMenuCategoryRewards !== "" && this.state.rewardMenuItemRewardsTable !== "" && 
            this.state.rewardQuantityRewardTable !== "" && this.state.moneyOffValue !== "" &&
            this.state.rewardExpirationValue !== "" && this.isValidDateFormat(this.state.rewardExpirationValue)) {
                this.setState({
                    showSaveRewardBtn: false,
                    showSaveRewardBtnLoading: true
                })
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("rewards")
                .doc("rewardsList")
                .collection("list")
                .doc(`reward-${this.state.rewardCount}`)
                .set({
                    id: `reward-${this.state.rewardCount}`,
                    selected: false,
                    publicReward: true,
                    freeItem: false,
                    date: `${this.formatDateToDDMMYYYY(new Date())}`,
                    percentageOffValue: this.state.percentageOffValue,
                    moneyOffValue: this.state.moneyOffValue,
                    pointsRewardValue: this.state.pointsRewardValue,
                    moneyEquivalentValue: this.state.moneyEquivalent,
                    rewardType: this.state.rewardType,
                    rewardMenuCategory: this.state.rewardMenuCategoryRewards,
                    rewardMenuItem: this.state.rewardMenuItemRewardsTable,
                    rewardQuantity: this.state.rewardQuantityRewardTable,
                    customRewardValue: this.state.customRewardValue,
                    expiryDate: this.state.rewardExpirationValue.replace(/\//g, '-'),
                    status: false
                })
                .then(() => {
                    fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("admin")
                    .doc("points")
                    .collection("rewards")
                    .doc("rewardsList")
                    .update({
                        rewardCount: this.state.rewardCount-1
                    })
                    .then(() => {
                        this.saveRewardTransition()
                        setTimeout(() => {
                            this.getRewards()
                            this.getLatestRewardCount()
                            this.setState({
                                showMoneyOffReward: false,
                                moneyOffValue: "",
                                showSaveRewardBtn: true,
                                showSaveRewardBtnLoading: false
                            })
                        }, 1500)
                    })
                })
            } else {
                if (this.state.pointsRewardValue === "") {
                    this.setState({pointsRewardValueBorderColor: "red"})
                } else {
                    this.setState({pointsRewardValueBorderColor: "#0930cb"})
                }

                if (this.state.moneyOffValue === "") {
                    this.setState({moneyOffValueBorderColor: "red"})
                } else {
                    this.setState({moneyOffValueBorderColor: "#0930cb"})
                }

                if (this.state.rewardExpirationValue === "" || !this.isValidDateFormat(this.state.rewardExpirationValue)) {
                    this.setState({rewardExpirationValueBorderColor: "red"})
                } else {
                    this.setState({rewardExpirationValueBorderColor: "#0930cb"})
                }
                alert("Some input is missing or incorrect in your reward.")
            }
        } else if (this.state.rewardType === "free-item") {
            if (this.state.pointsRewardValue !== "" && this.state.rewardType !== "" && 
            this.state.rewardMenuCategoryRewards !== "" && this.state.rewardMenuItemRewardsTable !== "" && 
            this.state.rewardQuantityRewardTable !== "" &&
            this.state.rewardExpirationValue !== "" && this.isValidDateFormat(this.state.rewardExpirationValue)) {
                this.setState({
                    showSaveRewardBtn: false,
                    showSaveRewardBtnLoading: true
                })
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("rewards")
                .doc("rewardsList")
                .collection("list")
                .doc(`reward-${this.state.rewardCount}`)
                .set({
                    id: `reward-${this.state.rewardCount}`,
                    selected: false,
                    publicReward: true,
                    freeItem: false,
                    date: `${this.formatDateToDDMMYYYY(new Date())}`,
                    percentageOffValue: this.state.percentageOffValue,
                    moneyOffValue: this.state.moneyOffValue,
                    pointsRewardValue: this.state.pointsRewardValue,
                    moneyEquivalentValue: this.state.moneyEquivalent,
                    rewardType: this.state.rewardType,
                    rewardMenuCategory: this.state.rewardMenuCategoryRewards,
                    rewardMenuItem: this.state.rewardMenuItemRewardsTable,
                    rewardQuantity: this.state.rewardQuantityRewardTable,
                    customRewardValue: this.state.customRewardValue,
                    expiryDate: this.state.rewardExpirationValue.replace(/\//g, '-'),
                    status: false
                })
                .then(() => {
                    fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("admin")
                    .doc("points")
                    .collection("rewards")
                    .doc("rewardsList")
                    .update({
                        rewardCount: this.state.rewardCount-1
                    })
                    .then(() => {
                        this.saveRewardTransition()
                        setTimeout(() => {
                            this.getRewards()
                            this.getLatestRewardCount()
                            this.setState({
                                showSaveRewardBtn: true,
                                showSaveRewardBtnLoading: false
                            })
                        }, 1500)
                    })
                })
            } else {
                if (this.state.pointsRewardValue === "") {
                    this.setState({pointsRewardValueBorderColor: "red"})
                } else {
                    this.setState({pointsRewardValueBorderColor: "#0930cb"})
                }

                if (this.state.rewardExpirationValue === "" || !this.isValidDateFormat(this.state.rewardExpirationValue)) {
                    this.setState({rewardExpirationValueBorderColor: "red"})
                } else {
                    this.setState({rewardExpirationValueBorderColor: "#0930cb"})
                }
                alert("Some input is missing or incorrect in your reward.")
            }
        } else if (this.state.rewardType === "custom-reward") {
            if (this.state.customRewardValue !== "" && this.state.rewardType !== "" &&
            this.state.rewardExpirationValue !== "" && this.isValidDateFormat(this.state.rewardExpirationValue)) {
                this.setState({
                    showSaveRewardBtn: false,
                    showSaveRewardBtnLoading: true
                })
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("rewards")
                .doc("rewardsList")
                .collection("list")
                .doc(`reward-${this.state.rewardCount}`)
                .set({
                    id: `reward-${this.state.rewardCount}`,
                    selected: false,
                    publicReward: true,
                    freeItem: false,
                    date: `${this.formatDateToDDMMYYYY(new Date())}`,
                    percentageOffValue: this.state.percentageOffValue,
                    moneyOffValue: this.state.moneyOffValue,
                    pointsRewardValue: this.state.pointsRewardValue,
                    moneyEquivalentValue: this.state.moneyEquivalent,
                    rewardType: this.state.rewardType,
                    rewardMenuCategory: this.state.rewardMenuCategoryRewards,
                    rewardMenuItem: this.state.rewardMenuItemRewardsTable,
                    rewardQuantity: this.state.rewardQuantityRewardTable,
                    customRewardValue: this.state.customRewardValue,
                    expiryDate: this.state.rewardExpirationValue.replace(/\//g, '-'),
                    status: false
                })
                .then(() => {
                    fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("admin")
                    .doc("points")
                    .collection("rewards")
                    .doc("rewardsList")
                    .update({
                        rewardCount: this.state.rewardCount-1
                    })
                    .then(() => {
                        this.saveRewardTransition()
                        setTimeout(() => {
                            this.getRewards()
                            this.getLatestRewardCount()
                            this.setState({
                                showCustomReward: false,
                                customRewardValue: "",
                                showSaveRewardBtn: true,
                                showSaveRewardBtnLoading: false
                            })
                        }, 1500)
                    })
                })
            } else {
                if (this.state.pointsRewardValue === "") {
                    this.setState({pointsRewardValueBorderColor: "red"})
                } else {
                    this.setState({pointsRewardValueBorderColor: "#0930cb"})
                }

                if (this.state.customRewardValue === "") {
                    this.setState({customRewardBorderColor: "red"})
                } else {
                    this.setState({customRewardBorderColor: "#0930cb"})
                }

                if (this.state.rewardExpirationValue === "" || !this.isValidDateFormat(this.state.rewardExpirationValue)) {
                    this.setState({rewardExpirationValueBorderColor: "red"})
                } else {
                    this.setState({rewardExpirationValueBorderColor: "#0930cb"})
                }
                alert("Some input is missing or incorrect in your reward.")
            }
        } else {
            alert("Some input is missing or incorrect in your reward.")
        }
    }

    saveRewardTransition = () => {
        this.setState({
            showAddRewardDisplay: false,
            showAddRewardBtn: false,
            showPercentageOffReward: false,
            showMoneyOffReward: false,
            showCustomReward: false,
            showExpirationRewardDate: false,
            showRewardsCategories2: false,
            showCoffeeAndTea2: false,
            showIcedCoffeeAndTea2: false,
            showBreakfast2: false,
            showStartersAndSharing2: false,
            showLunchAndDinner2: false,
            showBurgers2: false,
            showChips2: false,
            showWings2: false,
            showSandwiches2: false,
            showSalads2: false,
            showArtPizzas2: false,
            showPasta2: false,
            showBakery2: false,
            showCakesAndDesserts2: false,
            showColdPressJuices2: false,
            showSoftDrinks2: false,
            showKidsMenu2: false,
            showPowerSmoothies2: false,
            showWholeCakes2: false,
            showSteaks2: false,
            showSoup2: false,
            showMocktails2: false,
            showHotNBoozy2: false,
            showBeer2: false,
            showWhiteWine2: false,
            showSangria2: false,
            showRedWine2: false,
            showSparkling2: false,
            showRose2: false,
            showArtCocktails2: false,
            showCocktails2: false,
            showSpiritsAndLiquer2: false,
            showMilkshakes2: false,
            showQuiches2: false,
            showSectionLoading3: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showSectionLoading3: false,
                    showAddRewardsPlaceholder: false,
                    showAddRewardBtn: true,
                    showRewardsTable: true
                })
            }, 2500)
        })
    }

    getRewards = () => {
        class Reward {
            constructor(customRewardValue, date, expiryDate, freeItem, id, moneyEquivalentValue, moneyOffValue, percentageOffValue, pointsRewardValue, publicReward, rewardMenuCategory, rewardMenuItem, rewardQuantity, rewardType, selected, status) {
                this.customRewardValue = customRewardValue
                this.date = date
                this.expiryDate = expiryDate
                this.freeItem = freeItem
                this.id = id
                this.moneyEquivalentValue = moneyEquivalentValue
                this.moneyOffValue = moneyOffValue
                this.percentageOffValue = percentageOffValue
                this.pointsRewardValue = pointsRewardValue
                this.publicReward = publicReward
                this.rewardMenuCategory = rewardMenuCategory
                this.rewardMenuItem = rewardMenuItem
                this.rewardQuantity = rewardQuantity
                this.rewardType = rewardType
                this.selected = selected
                this.status = status
            }
            toString () {
                return this.customRewardValue + ', ' +
                this.date + ', ' +
                this.expiryDate + ', ' +
                this.freeItem + ', ' +
                this.id + ', ' +
                this.moneyEquivalentValue + ', ' +
                this.moneyOffValue + ', ' +
                this.percentageOffValue + ', ' +
                this.pointsRewardValue + ', ' +
                this.publicReward + ', ' +
                this.rewardMenuCategory + ', ' +
                this.rewardMenuItem + ', ' +
                this.rewardQuantity + ', ' +
                this.rewardType + ', ' +
                this.selected + ', ' + 
                this.status
            }
        }
        var rewardConverter = {
            toFirestore:function(reward) {
                return {
                    customRewardValue: reward.customRewardValue,
                    date: reward.date,
                    expiryDate: reward.expiryDate,
                    freeItem: reward.freeItem,
                    id: reward.id,
                    moneyEquivalentValue: reward.moneyEquivalentValue,
                    moneyOffValue: reward.moneyOffValue,
                    percentageOffValue: reward.percentageOffValue,
                    pointsRewardValue: reward.pointsRewardValue, 
                    publicReward: reward.publicReward,
                    rewardMenuCategory: reward.rewardMenuCategory,
                    rewardMenuItem: reward.rewardMenuItem,
                    rewardQuantity: reward.rewardQuantity,
                    rewardType: reward.rewardType,
                    selected: reward.selected,
                    status: reward.status
                }
            },
            fromFirestore:function(snapshot, options) {
                const data = snapshot.data(options)
                return new Reward(data.customRewardValue, data.date, data.expiryDate, data.freeItem, data.id, data.moneyEquivalentValue, 
                    data.moneyOffValue, data.percentageOffValue, data.pointsRewardValue, data.publicReward,
                    data.rewardMenuCategory, data.rewardMenuItem, data.rewardQuantity, data.rewardType, data.selected, data.status)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("rewards")
        .doc("rewardsList")
        .collection("list")
        .withConverter(rewardConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const placeholderIndex = data.findIndex(obj => obj.rewardType === "placeholder");
            if (placeholderIndex !== -1) {
              // If the object is found, remove it using splice
              data.splice(placeholderIndex, 1);
            }
            if (this.calculateTotalPages(data) == 1 || this.calculateTotalPages(data) == 0) {
                this.setState({
                    nextBtnTxtRewards: ""
                })
            } else if (this.calculateTotalPages(data) > 1) {
                this.setState({
                    nextBtnTxtRewards: "next"
                })
            }
            this.setState({
                totalRewardsPages: this.calculateTotalPages(data),
                rewards: data
            })
        })    
    }

    renderRewardsTable = () => {
        if (!this.state.rewards.length == 0) {
            const itemsPerPage = 10;  // Adjust this number based on the desired items per page
            const { currentRewardsPage } = this.state;
            const startIndex = (currentRewardsPage - 1) * itemsPerPage;
            const endIndex = startIndex + itemsPerPage;
            const visibleRewards = this.state.rewards.slice(startIndex, endIndex);


            if (visibleRewards.length === 0) {
                return <p>No rewards to display.</p>;
            }
            return(visibleRewards.map(rewards => {
                var {customRewardValue, date, expiryDate, freeItem, id, moneyEquivalentValue,
                    moneyOffValue, percentageOffValue, pointsRewardValue, 
                    publicReward, rewardMenuCategory, rewardMenuItem, 
                    rewardQuantity, rewardType, selected, status} = rewards

                    //* - - REWARD TYPE (LABEL) - - *//

                    let showPercentageOffLabel = false
                    let showAmountOffLabel = false
                    let showFreeItemLabel = false
                    let showCustomRewardLabel = false

                    if (rewardType == "percentage-off") {
                       showPercentageOffLabel = true
                    } else if (rewardType == "amount-off") {
                        showAmountOffLabel = true
                    } else if (rewardType == "free-item") {
                       showFreeItemLabel = true
                    } else if (rewardType == "custom-reward") {
                       showCustomRewardLabel = true
                    }


                    //* - - SELECTED REWARD - - *//
                    
                    let rewardUnselected = true
                    let rewardSelected = false

                    if (selected == true) {
                        rewardUnselected = false
                        rewardSelected = true
                    } else {
                        rewardUnselected = true
                        rewardSelected = false
                    }

                    let EPInactive = true
                    let EPActive = false

                    if (status == true) {
                        EPInactive = false
                        EPActive = true
                    } else {
                        EPActive = false
                        EPInactive = true
                    }

                    //* - - MENU ITEM - - *//

                    let menuItem

                    if (rewardType == "percentage-off") {
                        menuItem = `${rewardQuantity}x ${rewardMenuItem}`
                    } else if (rewardType == "amount-off") {
                        menuItem = `${rewardQuantity}x ${rewardMenuItem}`
                    } else if (rewardType == "free-item") {
                        menuItem = `${rewardQuantity}x ${rewardMenuItem}`
                    } else {
                        menuItem = `${customRewardValue}`
                    }

                    //* - - REWARD PARAMETERS - - *//

                    let rewardParams

                    if (rewardType == "percentage-off") {
                        rewardParams = `↳ ${percentageOffValue}% off item`
                    } else if (rewardType == "amount-off") {
                        rewardParams = `↳ KES ${moneyOffValue} off item`
                    } else if (rewardType == "free-item") {
                        rewardParams = `↳ Free item`
                    } else {
                        rewardParams = `↳ Custom`
                    }

                    console.log(id)
                    console.log(status)
                    
                    return (
                        <div className='rewardCell'>
                            <div className='rewardCellCol1'>
                                <button>
                                    {rewardUnselected && 
                                        <img 
                                        alt=''
                                        onClick={() => this.selectedRewardClicked(id, selected)}
                                        src='/assets/earningPolicyUnchecked.png'/>
                                    }
                                    {rewardSelected && 
                                        <img 
                                        alt=''
                                        onClick={() => this.selectedRewardClicked(id, selected)}
                                        src='/assets/earningPolicyChecked.png'/>
                                    }
                                </button>
                            </div>
                            <div className='rewardCellCol2'>
                                <div className='EPCellCol2Containers'>
                                    {showPercentageOffLabel && <button>Percentage off</button> }
                                    {showAmountOffLabel && <button>Amount off</button>}
                                    {showFreeItemLabel && <button>Free item</button>}
                                    {showCustomRewardLabel && <button>Custom reward</button>}
                                </div>
                            </div>
                            <div className='rewardCellCol3'>
                                <p>{menuItem}</p>
                            </div>
                            <div className='rewardCellCol4'>
                                <h4>{pointsRewardValue}pts (KES {moneyEquivalentValue})</h4>
                                <div className='appliedFilterResult2'>
                                    <p>{rewardParams}</p>
                                </div>
                            </div>
                            <div className='rewardCellCol5'>
                                <p>{date}</p>
                            </div>
                            <div className='rewardCellCol6'>
                                <p>{expiryDate}</p>
                            </div>
                            <div className='rewardCellCol7'>
                                <button>
                                    {EPInactive && 
                                        <img 
                                        alt=''
                                        onClick={() => this.rewardStatusActivitySelected(id, status, moneyEquivalentValue, moneyOffValue, percentageOffValue, pointsRewardValue, rewardMenuCategory, customRewardValue, rewardMenuItem, rewardType, rewardQuantity)}
                                        src='/assets/earning_policy_inactive.png'/>
                                    }
                                    {EPActive && 
                                        <img 
                                        alt=''
                                        onClick={() => this.rewardStatusActivitySelected(id, status, moneyEquivalentValue, moneyOffValue, percentageOffValue, pointsRewardValue, rewardMenuCategory, customRewardValue, rewardMenuItem, rewardType, rewardQuantity)}
                                        src='/assets/earning_policy_active.png'/>
                                    }
                                </button>
                            </div>
                        </div>
                    )
            }))
        } else {
            return (
                <div className='earningPolicyPlaceholder'>
                    <img src='/assets/rewards-placeholder.png'/>
                    <h3>You currently have no rewards</h3>
                </div>
            )
        }
    }

    makeRewardPublic = async (id, moneyEquivalentValue, moneyOffValue, percentageOffValue, pointsRewardValue, rewardMenuCategory, customRewardValue, rewardMenuItem, rewardType, rewardQuantity) => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("rewards")
        .collection("rewardsList")
        .doc(id)
        .set({
            id: id,
            moneyEquivalentValue: moneyEquivalentValue,
            moneyOffValue: moneyOffValue,
            percentageOffValue: percentageOffValue,
            pointsRewardValue: pointsRewardValue,
            rewardMenuCategory: rewardMenuCategory,
            customRewardValue: customRewardValue,
            rewardMenuItem: rewardMenuItem,
            rewardType: rewardType,
            rewardQuantity: rewardQuantity,
            newReward: true,
            dateAdded: this.formatDate(new Date())
        })
            //* - - TRIGGER NOTIFICATION by setting newReward === "true" - - *//
            //! - - Continue from here when you resumse - - !//
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("rewards")
        .set({
            newReward: "true",
            latestReward: this.formatDate(new Date())
        })
    }

    makeRewardPrivate = (id) => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("rewards")
        .collection("rewardsList")
        .doc(id)
        .delete()
    }

    rewardStatusActivitySelected = (id, status, moneyEquivalentValue, moneyOffValue, percentageOffValue, pointsRewardValue, rewardMenuCategory, customRewardValue, rewardMenuItem, rewardType, rewardQuantity) => {
        if (status === false) {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("rewards")
            .doc("rewardsList")
            .collection("list")
            .doc(id)
            .update({
                status: true
            })
            .then(() => {
                this.makeRewardPublic(id, moneyEquivalentValue, moneyOffValue, percentageOffValue, pointsRewardValue, rewardMenuCategory, customRewardValue, rewardMenuItem, rewardType, rewardQuantity)
                this.getRewards()
            })
        } else {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("rewards")
            .doc("rewardsList")
            .collection("list")
            .doc(id)
            .update({
                status: false
            })
            .then(() => {
                this.makeRewardPrivate(id)
                this.getRewards()
            })
            
        }
    }

    checkForRewardsStatusSelectedChange = () => {
        const policyRef = fire.firestore()
        .collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("rewards")
        .doc("rewardsList")
        .collection("list")
        policyRef.onSnapshot((snapshot) => {
            const updatedRewards = this.state.rewards.map(reward => {
            const snapshotPolicy = snapshot.docs.find(doc => doc.id === reward.id);
                if (snapshotPolicy) {
                    return {
                    ...reward,
                    status: snapshotPolicy.data().status
                    };
                }
                return reward;
            });
            this.setState({
                rewards: updatedRewards
            });
        });
    }

    selectedRewardClicked = (id, selected) => {
        const { isPopup2Visible } = this.state;
        if (selected == false) {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("rewards")
            .doc("rewardsList")
            .collection("list")
            .doc(id)
            .update({
                selected: true
            })
            .then(() => {
                if (!isPopup2Visible) {
                    this.togglePopup2();
                }
                this.setState({
                    selectedRewardsCount: this.state.selectedRewardsCount+1
                })
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("rewards")
                .doc("rewardsList")
                .collection("rewardsDeleting")
                .doc(id)
                .set({
                    reward: id
                })
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("rewards")
                .doc("rewardsList")
                .update({
                    selectedRewardsCount: this.state.selectedRewardsCount+1
                })
            });
            setTimeout(() => {
                this.fetchSelectedRewardsIDs()
            }, 900)
        } else {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("rewards")
            .doc("rewardsList")
            .collection("list")
            .doc(id)
            .update({
                selected: false
            })
            .then(() => {

                this.setState({
                    selectedRewardsCount: this.state.selectedRewardsCount !== 0 ? this.state.selectedRewardsCount-1 : 0
                })
                
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("rewards")
                .doc("rewardsList")
                .collection("rewardsDeleting")
                .doc(id)
                .delete()

                this.setState({
                    selectedRewardsIDs: this.state.selectedRewardsIDs.filter(item => item !== id)
                })

                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("rewards")
                .doc("rewardsList")
                .update({
                    selectedRewardsCount: this.state.selectedRewardsCount !== 0 ? this.state.selectedRewardsCount-1 : 0
                })
            })
        }
    }

    selectedMenuItemQuantity = (selectedOption) => {
        this.setState({
            rewardQuantity: selectedOption.value
        })
    }

    selectedMenuItemQuantityRewards = (selectedOption) => {
        this.setState({
            rewardQuantityRewardTable: selectedOption.value
        })
    }

    backToRewardsTable = () => {
        this.setState({
            showAddRewardDisplay: false,
            showSectionLoading3: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showSectionLoading3: false,
                    showAddRewardBtn: true,
                    showRewardsTable: true
                })
            }, 2500)
        })
    }

    renderHomepageRecentActivity = () => {
        return (
            <div>
                <div className='recentActivityCell'>
                    <div className='recentActivityCellImg'>
                        {/* <img src='/assets/customer-support-recent-activity.png'/> */}
                    </div>
                    <div className='recentActivityCellLabel'>
                        <h3><span style={{marginRight:"2.5%"}}>👤</span>New sign up -<label style={{color: "black", marginLeft: "1%"}}>Shiko Munyao</label></h3>
                    </div>
                    <div className='recentActivityCellTimestamp'>
                        <p>5:05pm</p>
                    </div>
                </div>
                <div className='recentActivityCell'>
                    <div className='recentActivityCellImg'>
                        {/* <img src='/assets/customer-support-recent-activity.png'/> */}
                    </div>
                    <div className='recentActivityCellLabel'>
                        <h3><span style={{marginRight:"2.5%"}}>🎉</span>REDEEMED POINTS -<label style={{color: "black", marginLeft: "1%"}}>Cathy Wanjiku</label></h3>
                    </div>
                    <div className='recentActivityCellTimestamp'>
                        <p>4:15pm</p>
                    </div>
                </div>
                <div className='recentActivityCell'>
                    <div className='recentActivityCellImg'>
                        {/* <img src='/assets/customer-support-recent-activity.png'/> */}
                    </div>
                    <div className='recentActivityCellLabel'>
                        <h3><span style={{marginRight:"2.5%"}}>🎉</span>REDEEMED POINTS -<label style={{color: "black", marginLeft: "1%"}}>Norman Buruchara</label></h3>
                    </div>
                    <div className='recentActivityCellTimestamp'>
                        <p>4:14pm</p>
                    </div>
                </div>
                <div className='recentActivityCell'>
                    <div className='recentActivityCellImg'>
                        {/* <img src='/assets/customer-support-recent-activity.png'/> */}
                    </div>
                    <div className='recentActivityCellLabel'>
                        <h3><span style={{marginRight:"2.5%"}}>👤</span>NEW USER SIGN UP -<label style={{color: "black", marginLeft: "1%"}}>Dan Muriuki</label></h3>
                    </div>
                    <div className='recentActivityCellTimestamp'>
                        <p>4:03pm</p>
                    </div>
                </div>
                <div className='recentActivityCell'>
                    <div className='recentActivityCellImg'>
                        {/* <img src='/assets/customer-support-recent-activity.png'/> */}
                    </div>
                    <div className='recentActivityCellLabel'>
                        <h3><span style={{marginRight:"2.5%"}}>👤</span>NEW USER SIGN UP -<label style={{color: "black", marginLeft: "1%"}}>Joyce Kibet</label></h3>
                    </div>
                    <div className='recentActivityCellTimestamp'>
                        <p>3:40pm</p>
                    </div>
                </div>
                <div className='recentActivityCell'>
                    <div className='recentActivityCellImg'>
                        {/* <img src='/assets/customer-support-recent-activity.png'/> */}
                    </div>
                    <div className='recentActivityCellLabel'>
                        <h3><span style={{marginRight:"2.5%"}}>🎉</span>REDEEMED POINTS -<label style={{color: "black", marginLeft: "1%"}}>Karen Smith</label></h3>
                    </div>
                    <div className='recentActivityCellTimestamp'>
                        <p>2:09pm</p>
                    </div>
                </div>
            </div>
        )
    }

    trialModeClicked = () => {
        this.setState({
            trialModeSidepaneColor: "#0930CB",
            showGettingStarted: false,
            showLoadingRightPanel: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showLoadingRightPanel: false,
                    showTrialModeHome: true
                })
            }, 2500)
        })
    }

    rewardsSidepaneClicked = () => {
        this.hideDataLeavingPointsPage()
        this.setState({
            showSearchAnalytics: false,
            showSearchCampaigns: false,
            showSearchMembers: false,

            showHomepageSearchBar: true,
            showMembersSearchBar: false,
            showAnalyticsHome: false,
            showMembersHome: false,
            showCampaignsHome: false,
            campaignsSidepaneColor: "#000",
            membersSidepaneColor: "#000",
            analyticsSidepaneColor: "#000",
            rewardsSidepaneColor: "#0930CB",
            showExplorePlansBtn: false,
            showTopDashboards: false,
            showLoadingRightPanel: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showLoadingRightPanel: false,
                    showAllPlans: true,
                    showRewardsBtns: true
                })
            }, 2500)
        })
    }

    analyticsSidepaneClicked = () => {
        this.hideDataLeavingPointsPage()
        this.setState({
            showSearchRewards: false,
            showSearchCampaigns: false,
            showSearchMembers: false,

            showHomepageSearchBar: true,
            showMembersSearchBar: false,
            showMembersHome: false,
            showCampaignsHome: false,
            showAllPlans: false,
            showPointsComponent: false,
            showPointsComponentOptions: false,
            rewardsSidepaneColor: "#000",
            membersSidepaneColor: "#000",
            campaignsSidepaneColor: "#000",
            analyticsSidepaneColor: "#0930CB",
            showExplorePlansBtn: false,
            showTopDashboards: false,
            showLoadingRightPanel: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showLoadingRightPanel: false,
                    showAnalyticsHome: true
                })
            }, 2500)
        })
    }

    campaignsSidepaneClicked = () => {
        this.hideDataLeavingPointsPage()
        this.setState({
            showSearchAnalytics: false,
            showSearchRewards: false,
            showSearchMembers: false,

            showHomepageSearchBar: true,
            showMembersSearchBar: false,
            showMembersHome: false,
            showAnalyticsHome: false,
            showAllPlans: false,
            showPointsComponent: false,
            showPointsComponentOptions: false,
            rewardsSidepaneColor: "#000",
            membersSidepaneColor: "#000",
            analyticsSidepaneColor: "#000",
            campaignsSidepaneColor: "#0930cb",
            showExplorePlansBtn: false,
            showTopDashboards: false,
            showLoadingRightPanel: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showLoadingRightPanel: false,
                    showCampaignsHome: true
                })
            }, 2500)
        })
    }

    membersSidepaneClicked = () => {
        this.hideDataLeavingPointsPage()
        this.setState({
            showSearchAnalytics: false,
            showSearchCampaigns: false,
            showSearchRewards: false,

            showAnalyticsHome: false,
            showCampaignsHome: false,
            showAllPlans: false,
            showPointsComponent: false,
            showPointsComponentOptions: false,
            rewardsSidepaneColor: "#000",
            analyticsSidepaneColor: "#000",
            campaignsSidepaneColor: "#000",
            membersSidepaneColor: "#0930CB",
            showExplorePlansBtn: false,
            showTopDashboards: false,
            showLoadingRightPanel: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showHomepageSearchBar: false,
                    showMembersSearchBar: true,
                    showLoadingRightPanel: false,
                    showMembersHome: true
                })
            }, 2500)
        })
    }

    customerSupportSidepaneClicked = () => {
        this.setState({
            customerSupportSidepaneColor: "#0930CB",
            showExplorePlansBtn: false,
            showTopDashboards: false,
            showLoadingRightPanel: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showLoadingRightPanel: false,
                    showCustomerSupportHome: true,
                    showAllMessages: true,
                    showMessageStatusUnread: true
                })
            }, 2500)
        })
    }

    handleQuickBtn1MouseEnter = () => {
        this.setState({
            quickBtn1BgColor: "#0930CB",
            quickBtn1TxtColor: "white"
        })
    }

    handleQuickBtn1MouseLeave = () => {
        this.setState({
            quickBtn1BgColor: "white",
            quickBtn1TxtColor: "#0930CB"
        })
    }

    handleQuickBtn2MouseEnter = () => {
        this.setState({
            quickBtn2BgColor: "#0930CB",
            quickBtn2TxtColor: "white"
        })
    }

    handleQuickBtn2MouseLeave = () => {
        this.setState({
            quickBtn2BgColor: "white",
            quickBtn2TxtColor: "#0930CB"
        })
    }

    handleQuickBtn3MouseEnter = () => {
        this.setState({
            quickBtn3BgColor: "#0930CB",
            quickBtn3TxtColor: "white"
        })
    }

    handleQuickBtn3MouseLeave = () => {
        this.setState({
            quickBtn3BgColor: "white",
            quickBtn3TxtColor: "#0930CB"
        })
    }

        //!  - - REWARDS ENHANCEMENTS - - !//

    moreOptionsClicked = () => {
        this.setState({
            showMoreOptionsBtn: false,
            showEditMoreOptionsPoints: true
        })
    }

    customerActionSelected = (selectedOption) => {
        this.setState({
            currentCustomerAction: selectedOption.value
        })
        if (selectedOption.value == "purchase") {
            this.setState({
                showCustomerActionExitBtn: true,
                showCustomerActionLoading: true,
                showEarningValueReferralOptions: false,
                showSettingReferralLimit: false,
                showLimitSelectedFilter: false,
                showUnlimitedSelectedFilter: false,
                referralRegistrationLimitBorderColor: "#000",
                limitedReferralTxt: "Set limit",
                unlimitedReferralTxt: "Unlimited",
                setLimitBtnBgColor: "#0930cb",
                setLimitBtnTxtColor: "white",
                unlimitedBtnBgColor: "#0930cb",
                unlimitedBtnTxtColor: "white",
                showBaselineIntroMessage: false,
                baselineValueMsg: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showCustomerActionLoading: false,
                        showEarningValuePurchaseOptions: true
                    })
                }, 2500)
            })
        } else if (selectedOption.value == "referral") {
            this.setState({
                showCustomerActionExitBtn: true,
                showCustomerActionLoading: true,
                showEarningValuePurchaseOptions: false,
                showSelectedNoneFilter: false,
                showSelectedPriceFilter: false,
                showSelectedMealFilter: false,
                filterOptionBtn1: "None",
                filterOptionBtn2: "Price",
                filterOptionBtn3: "Meal",
                filterOptions1BgColor: "#0930cb",
                filterOptions1TxtColor: "white",
                filterOptions2BgColor: "#0930cb",
                filterOptions2TxtColor: "white",
                filterOptions5BgColor: "#0930cb",
                filterOptions5TxtColor: "white",
                showBaselineIntroMessage: false,
                baselineValueMsg: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showCustomerActionLoading: false,
                        showEarningValueReferralOptions: true,
                        showReferralCodeContinueBtn: true
                    })
                }, 2500)
            })
        }
    }

    closeCustomerActionOptions = () => {
        if (this.state.currentCustomerAction == "purchase") {
            this.setState({
                currentCustomerAction: "",
                showEarningValuePurchaseOptions: false,
                showSelectedNoneFilter: false,
                showSelectedPriceFilter: false,
                showSelectedMealFilter: false,
                filterOptionBtn1: "None",
                filterOptionBtn2: "Price",
                filterOptionBtn3: "Meal",
                filterOptions1BgColor: "#0930cb",
                filterOptions1TxtColor: "white",
                filterOptions2BgColor: "#0930cb",
                filterOptions2TxtColor: "white",
                filterOptions5BgColor: "#0930cb",
                filterOptions5TxtColor: "white",
                showCustomerActionExitBtn: false,
                showBaselineIntroMessage: false,
                baselineValueMsg: "",
                showCustomerActionLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showCustomerActionLoading: false
                    })
                }, 2500)
            })
        } else if (this.state.currentCustomerAction == "referral") {
            this.setState({
                currentCustomerAction: "",
                showEarningValueReferralOptions: false,
                showSettingReferralLimit: false,
                showLimitSelectedFilter: false,
                showUnlimitedSelectedFilter: false,
                referralRegistrationLimitBorderColor: "#000",
                limitedReferralTxt: "Set limit",
                unlimitedReferralTxt: "Unlimited",
                setLimitBtnBgColor: "#0930cb",
                setLimitBtnTxtColor: "white",
                unlimitedBtnBgColor: "#0930cb",
                unlimitedBtnTxtColor: "white",
                showCustomerActionExitBtn: false,
                showBaselineIntroMessage: false,
                baselineValueMsg: "",
                showCustomerActionLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showCustomerActionLoading: false
                    })
                }, 2500)
            })
        }
        
    }

    filterOption1Clicked = () => {
        if (this.state.filterOptions1BgColor == "#0930CB") {
            this.setState({
                filterOptions1BgColor: "white",
                filterOptions1TxtColor: "#0930CB",
                filterOptions2BgColor: "#0930CB",
                filterOptions2TxtColor: "white",
                filterOptions3BgColor: "#0930CB",
                filterOptions3TxtColor: "white",
                filterOptions4BgColor: "#0930CB",
                filterOptions4TxtColor: "white",
                filterOptions5BgColor: "#0930CB",
                filterOptions5TxtColor: "white",
                showSelectedNoneFilter: true,
                showSelectedMealFilter: false,
                showSelectedPriceFilter: false,
                filterOptionBtn1: "Deselect",
                filterOptionBtn2: "Price",
                filterOptionBtn3: "Meal"
            })
        } else {
            this.setState({
                filterOptions1BgColor: "#0930CB",
                filterOptions1TxtColor: "white",
                filterOptionBtn1: "None",
                showSelectedNoneFilter: false,
            })
        } 
    }

    filterOption2Clicked = () => {
        if (this.state.filterOptions2BgColor == "#0930CB") {
            this.setState({
                filterOptions2BgColor: "white",
                filterOptions2TxtColor: "#0930CB",
                filterOptions1BgColor: "#0930CB",
                filterOptions1TxtColor: "white",
                filterOptionBtn2: "Deselect",
                filterOptionBtn1: "None",
                showSelectedPriceFilter: true,
                showSelectedNoneFilter: false,
                priceFilterSelected: true
            })
        } else {
            this.setState({
                priceFilterComparative: "",
                filterOptionPricing: "",
                filterOptions2BgColor: "#0930CB",
                filterOptions2TxtColor: "white",
                filterOptionBtn2: "Price",
                showSelectedPriceFilter: false,
                priceFilterSelected: false,
                showPriceDescriptorDetails: false,
                priceFilterLabel: ""
            })
        }
    }

    filterOption3Clicked = () => {
        if (this.state.filterOptions3BgColor == "#0930CB") {
            this.setState({
                filterOptions3BgColor: "white",
                filterOptions3TxtColor: "#0930CB",
                filterOptions1BgColor: "#0930CB",
                filterOptions1TxtColor: "white",
                
            })
        } else {
            this.setState({
                filterOptions3BgColor: "#0930CB",
                filterOptions3TxtColor: "white",
                
            })
        }
    }

    filterOption4Clicked = () => {
        if (this.state.filterOptions4BgColor == "#0930CB") {
            this.setState({
                filterOptions4BgColor: "white",
                filterOptions4TxtColor: "#0930CB",
                filterOptions1BgColor: "#0930CB",
                filterOptions1TxtColor: "white"
            })
        } else {
            this.setState({
                filterOptions4BgColor: "#0930CB",
                filterOptions4TxtColor: "white"
            })
        }
    }

    filterOption5Clicked = () => {
        if (this.state.filterOptions5BgColor == "#0930CB") {
            this.setState({
                filterOptions5BgColor: "white",
                filterOptions5TxtColor: "#0930CB",
                filterOptions1BgColor: "#0930CB",
                filterOptions1TxtColor: "white",
                showSelectedMealFilter: true,
                filterOptionBtn3: "Deselect",
                filterOptionBtn1: "None",
                showSelectedNoneFilter: false,
                mealFilterSelected: true
            })
        } else {
            this.setState({
                rewardMenuCategory: "",
                rewardQuantity: "",
                rewardMenuItem: "",
                filterOptionTimeValue: "",
                filterOptionCalendarValue: "",
                filterOptions5BgColor: "#0930CB",
                filterOptions5TxtColor: "white",
                filterOptionBtn3: "Meal",
                showSelectedMealFilter: false,
                mealFilterSelected: false,
                showMealOrderDetails: false,
                showMealOrderTimeDetails: false,
                showMealSelectedLabel: "",
                showTimeDurationLabel: ""
            })
        }
    }
    
    loadFilterOptions = () => {
        // this.setState({
        //     showShowAllEarningsHeader: false
        // })
        if (this.state.filterOptions2BgColor == "white") {
            this.state.showFilterOptions2 = true
        } else {
            this.state.showFilterOptions2 = false
        }

        if (this.state.filterOptions2BgColor == "white" && this.state.filterOptions5BgColor != "white") {
            this.state.showPriceOnlyTimeDuration = true
        } else {
            this.state.showPriceOnlyTimeDuration = false
        }

        if (this.state.filterOptions3BgColor == "white") {
            this.state.showFilterOptions3 = true
        } else {
            this.state.showFilterOptions3 = false
        }

        if (this.state.filterOptions4BgColor == "white") {
            this.state.showFilterOptions4 = true
            this.state.showRewardsCategories = true
        } else {
            this.state.showFilterOptions4 = false
        }

        if (this.state.filterOptions5BgColor == "white") {
            this.state.showFilterOptions5 = true
            this.state.showRewardsCategories = true
            this.state.showPriceOnlyTimeDuration = false
        } else {
            this.state.showFilterOptions5 = false
        }
    }

    filterOptionsContinueClicked = () => {
        this.getLatestPurchaseEarningCount()
        if (this.state.filterOptions1BgColor == "white") {
            //* - - ONLY NO CUSTOMIZATION SELECTED - - *//
            this.loadEarningPolicies()
            this.setState({
                showShowAllEarningsHeader: false,
                showEarningValuePurchaseOptions: false,
                showEarningEditHeader: false,
                showEarningValueOptions: false,
                showCustomerActionExitBtn: false,
                showBaselineValueBtn: false,
                showSectionLoading2: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSectionLoading2: false,
                        showBaselineValueBtn: true,
                        showFilterOptionsInProgress: true,
                        showEarningEditHeader: true,
                        showNoCustomizationSpace: true,
                        showEditEarningValue: true,
                        showEditExpirationHeader: true,
                        showEditExpirationLoyalty: true,
                        showEarningEditBtn: true,
                        showBaselineIntroMessage: true,
                        baselineValueMsg: "NOTE: This will change your earning Baseline Value - and subsequently adjust previously saved custom earning policies."
                        // showApplyFilterOptionsBtn: true
                        // showEarningValueOptions: false,
                    })
                    this.loadFilterOptions()
                }, 2500)
            })
        } else if ((this.state.filterOptions2BgColor == "white" && this.state.filterOptions3BgColor == "white") || (this.state.filterOptions2BgColor == "white" || this.state.filterOptions5BgColor == "white")) {
            this.setState({
                showShowAllEarningsHeader: false,
                showEarningValuePurchaseOptions: false,
                showEarningEditHeader: false,
                showEarningValueOptions: false,
                showCustomerActionExitBtn: false,
                showSectionLoading2: true,
                showBaselineValueBtn: false
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSectionLoading2: false,
                        showBaselineValueBtn: true,
                        showFilterOptionsInProgress: true,
                        showEarningEditHeader: true,
                        showApplyFilterOptionsBtn: true
                        // showEarningValueOptions: false,
                    })
                    this.clearMealSelected()
                    this.clearPriceDescriptor()
                    this.clearTimeDuration()
                    this.loadFilterOptions()
                }, 2500)
            })
        } else {
            this.setState({
                showBaselineIntroMessage: true,
                baselineValueMsg: "Please select a customization option below."
            })
        }
    } 
    
    referralCodeContinueBtnClicked = () => {
        if (this.state.setLimitBtnBgColor == "white" || this.state.unlimitedBtnBgColor == "white") {
            if (this.state.unlimitedBtnBgColor == "white" && this.state.setLimitBtnBgColor != "white") {
                this.setState({
                    showShowAllEarningsHeader: false,
                    showEarningValueReferralOptions: false,
                    showEarningEditHeader: false,
                    showEarningValueOptions: false,
                    showCustomerActionExitBtn: false,
                    showSectionLoading2: true,
                    showBaselineValueBtn: false
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            pointsEarnedValue: "",
                            showSectionLoading2: false,
                            showBaselineValueBtn: true,
                            showFilterOptionsInProgress: true,
                            showEarningEditHeader: true,
                            showEditUnlimitedReferralCodeEarning: true
                        })
                    }, 2500)
                })
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .update({
                    referralLimit: false
                })
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("earning")
                .doc("parameters")
                .update({
                    referralLimitCount: 0
                })
            } else if (this.state.unlimitedBtnBgColor != "white" && this.state.setLimitBtnBgColor == "white") {
                if (this.state.referralRegistrationLimitValue == "") {
                    this.handleScrollToElement()
                    this.setState({
                        referralRegistrationLimitBorderColor: "red",
                        showBaselineIntroMessage: true,
                        baselineValueMsg: "Please enter a registration limit."
                    })
                } else {
                    this.setState({
                        showShowAllEarningsHeader: false,
                        showEarningValueReferralOptions: false,
                        showEarningEditHeader: false,
                        showEarningValueOptions: false,
                        showCustomerActionExitBtn: false,
                        showSectionLoading2: true,
                        showBaselineValueBtn: false
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                pointsEarnedValue: "",
                                showSectionLoading2: false,
                                showBaselineValueBtn: true,
                                showFilterOptionsInProgress: true,
                                showEarningEditHeader: true,
                                showSetLimitOfReferralRegistrations: true,
                                showEditUnlimitedReferralCodeEarning: true
                            })
                        }, 2500)
                    })
                    fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("admin")
                    .doc("points")
                    .update({
                        referralLimit: true
                    })
                    fire.firestore().collection("clients")
                    .doc("artcaffe")
                    .collection("admin")
                    .doc("points")
                    .collection("earning")
                    .doc("parameters")
                    .update({
                        referralLimitCount: Number(this.state.referralRegistrationLimitValue)
                    })
                }
            }
        } else {
            this.setState({
                showBaselineIntroMessage: true,
                baselineValueMsg: "Please choose whether you want a 'Set limit' or 'Unlimited' earning capability for referral-based registrations for loyalty members."
            })
        }
    }

    getLatestPurchaseEarningCount = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("earning")
        .doc("parameters")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    purchaseCount: doc.data().purchaseCount
                })
            }
        })
    } 

    backToSelectFilterOptions = () => {
        if (this.state.showAllEarningPoliciesTitle == true) {
            if (this.state.isPopupVisible == true) {
                this.setState({
                    isPopupVisible: false
                })
            }
            this.setState({
                showAllEarningPoliciesTitle: false,
                showAllEarningPolicies: false,
                showBaselineValueBtn: false,
                showFilterOptionsInProgress: false,
                showSectionLoading2: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSectionLoading2: false,
                        showBaselineValueBtn: true,
                        showEarningEditHeader: true,
                        showEarningValueOptions: true,
                        showShowAllEarningsHeader: true,
                    })
                }, 2500)
            })
        } else {
            if (this.state.currentCustomerAction == "purchase") {
                this.setState({
                    filterOptionEndDate: "",
                    showNoCustomizationSpace: false,
                    showEditEarningValue: false,
                    showEarningEditBtn: false,
                    showFilterOptionsInProgress: false,
                    showFilterOptions2: false,
                    showFilterOptions5: false,
                    showApplyFilterOptionsBtn: false,
                    showEditExpirationHeader: false,
                    showEditExpirationLoyalty: false,
                    showEarningEditHeader: false,
                    showSectionLoading2: true,
                    showBaselineValueBtn: false,
                    showBaselineIntroMessage: false,
                    applyFilterErrMessage: "",
                    baselineValueMsg: ""
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSectionLoading2: false,
                            showBaselineValueBtn: true,
                            showEarningValuePurchaseOptions: true,
                            showEarningEditHeader: true,
                            showEarningValueOptions: true,
                            showShowAllEarningsHeader: true,
                            showCustomerActionExitBtn: true
                            // showEarningValueOptions: false,
                        })
                    }, 2500)
                })
            } else if (this.state.currentCustomerAction == "referral") {
                if (this.state.referralRegistrationLimitValue != "") {
                    //* - - IF REFERRAL LIMIT EXISTS - - *//
                    this.setState({
                        pointsEarnedValue: "",
                        showBaselineValueBtn: false,
                        showFilterOptionsInProgress: false,
                        showEarningEditHeader: false,
                        showSetLimitOfReferralRegistrations: false,
                        showEditUnlimitedReferralCodeEarning: false,
                        showSectionLoading2: true,
                        
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                showSectionLoading2: false,
                                showShowAllEarningsHeader: true,
                                showEarningValueReferralOptions: true,
                                showEarningEditHeader: true,
                                showEarningValueOptions: true,
                                showCustomerActionExitBtn: true,
                                showBaselineValueBtn: true,
                                showSettingReferralLimit: true
                            })
                        }, 2500)
                    })
                } else {
                    this.setState({
                        pointsEarnedValue: "",
                        showBaselineValueBtn: false,
                        showFilterOptionsInProgress: false,
                        showEarningEditHeader: false,
                        showSetLimitOfReferralRegistrations: false,
                        showEditUnlimitedReferralCodeEarning: false,
                        showSectionLoading2: true,
                        
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                showSectionLoading2: false,
                                showShowAllEarningsHeader: true,
                                showEarningValueReferralOptions: true,
                                showEarningEditHeader: true,
                                showEarningValueOptions: true,
                                showCustomerActionExitBtn: true,
                                showBaselineValueBtn: true,
                            })
                        }, 2500)
                    })
                }
            }
            
        }
    }

    backToFilterInputOptions = () => {
        if (this.state.priceFilterSelected == true && this.state.mealFilterSelected == false) {
            this.setState({
                showFilterOptionsInProgressFinal: false,
                showBaselineValueBtn: false,
                showEarningValuePurchaseOptions: false,
                showEarningEditHeader: false,
                showEditEarningValue: false,
                showEarningValueOptions: false,
                showEarningWithFilterBtn: false,
                showAppliedFilters: false,
                showEarningPolicyPercentageChange: false,
                showApplyFilterErrMsg2: false,
                showApplyFilterErrMsg3: false,
                applyFilterErrMessage2: "",
                applyFilterErrMessage3: "",
                showMultiplierDurationPeriod: false,
                showSectionLoading2: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSectionLoading2: false,
                        showFilterOptionsInProgress: true,
                        showFilterOptions2: true,
                        showFilterOptions5: false,
                        showApplyFilterOptionsBtn: true,
                        showEarningEditHeader: true,
                        showPriceOnlyTimeDuration: true,
                        showBaselineValueBtn: true
                    })
                }, 2500)
            })
        } else if (this.state.priceFilterSelected == false && this.state.mealFilterSelected == true) {
            this.setState({
                showFilterOptionsInProgressFinal: false,
                showBaselineValueBtn: false,
                showEarningValuePurchaseOptions: false,
                showEarningEditHeader: false,
                showEditEarningValue: false,
                showEarningValueOptions: false,
                showEarningWithFilterBtn: false,
                showAppliedFilters: false,
                showEarningPolicyPercentageChange: false,
                showApplyFilterErrMsg2: false,
                showApplyFilterErrMsg3: false,
                applyFilterErrMessage2: "",
                applyFilterErrMessage3: "",
                showMultiplierDurationPeriod: false,
                showSectionLoading2: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSectionLoading2: false,
                        showFilterOptionsInProgress: true,
                        showFilterOptions2: false,
                        showFilterOptions5: true,
                        showApplyFilterOptionsBtn: true,
                        showEarningEditHeader: true,
                        showBaselineValueBtn: true
                    })
                }, 2500)
            })
        } else if (this.state.priceFilterSelected == true && this.state.mealFilterSelected == true) {
            this.setState({
                showFilterOptionsInProgressFinal: false,
                showBaselineValueBtn: false,
                showEarningValuePurchaseOptions: false,
                showEarningEditHeader: false,
                showEditEarningValue: false,
                showEarningValueOptions: false,
                showEarningWithFilterBtn: false,
                showAppliedFilters: false,
                showEarningPolicyPercentageChange: false,
                showApplyFilterErrMsg2: false,
                showApplyFilterErrMsg3: false,
                showMultiplierDurationPeriod: false,
                applyFilterErrMessage2: "",
                applyFilterErrMessage3: "",
                showSectionLoading2: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSectionLoading2: false,
                        showFilterOptionsInProgress: true,
                        showFilterOptions2: true,
                        showFilterOptions5: true,
                        showApplyFilterOptionsBtn: true,
                        showEarningEditHeader: true,
                        showBaselineValueBtn: true
                    })
                }, 2500)
            })
        }
    }

    setFilterPriceOption = (selectedOption) => {
        this.setState({
            showPriceDescriptorDetails: true,
        })
        this.setState({
            showPriceDescriptorLabel: false,
            showPriceDescriptorLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showPriceDescriptorLoading: false,
                    showPriceDescriptorLabel: true,
                    priceFilterComparative: selectedOption.value,
                    priceFilterLabel: selectedOption.label
                })
            }, 2500)
        })
    }

    setTimeFilter = (selectedOption) => {
        if (this.state.filterOptionTimeValue != "" && this.state.filterOptionCalendarValue != "") {
            let futureInputDate = `${selectedOption.value} ${this.state.filterOptionCalendarValue}` 
            let futureDate = this.formatDate(this.calculateFutureDate(futureInputDate))
            this.setState({
                filterOptionEndDate: futureDate
            })
        }
        if (this.state.priceFilterSelected == true && this.state.mealFilterSelected == true) {
            this.handleScrollToElement()
            this.setState({
                showBaselineIntroMessage: true,
                baselineValueMsg: "Please note that - the time duration selected will be applied for BOTH the PRICE and MEAL filter."
            })
        }
        this.setState({
            showTimeDurationLabel: false,
            showMealOrderTimeDetails: true,
            showTimeDurationLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showTimeDurationLoading: false,
                    showTimeDurationLabel: true,
                    filterOptionTimeValue: selectedOption.value,
                    showFilterCalendarValueAsterisk: true
                })
            }, 3000)
        })
        // this.setState({
        //     showMealOrderTimeDetails: true,
        // })
    }

    formatDate(date) {
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 because months are zero-based
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    }

    calculateFutureDate(input) {
        const units = {
            day: 'days',
            week: 'weeks',
            month: 'months',
        };
    
        const [quantity, unit] = input.split(' ');
    
        if (!quantity || !unit || isNaN(quantity) || !units[unit.toLowerCase()]) {
            throw new Error('Invalid input format. Please use the format "1 day", "2 weeks", etc.');
        }
    
        const currentDate = new Date();
        const futureDate = add(currentDate, { [units[unit.toLowerCase()]]: parseInt(quantity) });
    
        return futureDate;
    }

    setMultiplierTimeFilter = (selectedOption) => {
        this.setState({
            showMealOrderTimeDetails: true,
            showTimeDurationLabel: false,
            showTimeDurationLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showTimeDurationLoading: false,
                    showTimeDurationLabel: true,
                    multiplierTimeValue: selectedOption.value,
                    showFilterCalendarValueAsterisk: true
                })
            }, 2500)
        })
    }

    setDateFilter = (selectedOption) => {
        if (this.state.filterOptionTimeValue != "") {
            let futureInputDate = `${this.state.filterOptionTimeValue} ${selectedOption.value}` 
            let futureDate = this.formatDate(this.calculateFutureDate(futureInputDate))
            this.setState({
                filterOptionCalendarValue: selectedOption.value,
                filterOptionEndDate: futureDate
            })
        } else {
            this.setState({
                filterOptionCalendarValue: selectedOption.value
            })
        }
        this.setState({
            showMealOrderTimeDetails: true,
            showTimeDurationLabel: false,
            showTimeDurationLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showTimeDurationLoading: false,
                    showTimeDurationLabel: true,
                })
            }, 2500)
        })
    }

    setMultiplierDateFilter = (selectedOption) => {
        this.setState({
            multiplierCalendarValue: selectedOption.value
        })
    }

    applyFilterClicked = () => {
        if (this.state.showFilterOptions2 == true) {
            if (this.state.priceFilterComparative == "") {
                this.setState({
                    showBaselineIntroMessage: true,
                    baselineValueMsg: "Please fill in all required fields."
                })
                this.handleScrollToElement()
            }

            if (this.state.filterOptionPricing == "") {
                this.setState({
                    filterOptionPricingBorderColor: "red",
                    showBaselineIntroMessage: true,
                    baselineValueMsg: "Please fill in all required fields."
                })
                this.handleScrollToElement()
            } else {
                this.setState({
                    filterOptionPricingBorderColor: "black"
                })
            }
        }

        if (this.state.showFilterOptions5 == true) {
            if (this.state.rewardMenuCategory == "") {
                this.setState({
                    showBaselineIntroMessage: true,
                    baselineValueMsg: "Please fill in all required fields."
                })
                this.handleScrollToElement()
            }
    
            if (this.state.rewardMenuItem == "") {
                this.setState({
                    showBaselineIntroMessage: true,
                    baselineValueMsg: "Please fill in all required fields."
                })
                this.handleScrollToElement()
            }
    
            if (this.state.rewardQuantity == "") {
                this.setState({
                    showBaselineIntroMessage: true,
                    baselineValueMsg: "Please fill in all required fields."
                })
                this.handleScrollToElement()
            } 

            if (this.state.showFilterCalendarValueAsterisk == true) {

            }
        }
        
            //? - - IF EVERYTHING IS OKAY - - ?//
        if (this.state.showFilterOptions2 == true && this.state.showFilterOptions5 == true) {
            if (this.state.priceFilterComparative != "" && this.state.filterOptionPricing != ""
                && this.state.rewardMenuCategory != "" && this.state.rewardMenuItem != "" 
                && this.state.rewardQuantity != "") {
                //* NAVIGATE TO NEXT SCREEN *//
                this.goToFinalEarningValueScreen()
            }
        } else if (this.state.showFilterOptions2 == true && this.state.showFilterOptions5 == false) {
            if (this.state.priceFilterComparative != "" && this.state.filterOptionPricing != "") {
                //* NAVIGATE TO NEXT SCREEN *//
                this.goToFinalEarningValueScreen()
            }
        } else if (this.state.showFilterOptions2 == false && this.state.showFilterOptions5 == true) {
            if (this.state.rewardMenuCategory != "" && this.state.rewardMenuItem != ""
                && this.state.rewardQuantity != "") {
                //* NAVIGATE TO NEXT SCREEN *//
                this.goToFinalEarningValueScreen()
            }
        }
    }

    goToFinalEarningValueScreen = () => {
        this.handleScrollToElement()
        this.setState({
            showEarningValuePurchaseOptions: false,
            showFilterOptionsInProgress: false,
            showEarningEditHeader: false,
            showFilterOptions2: false,
            showPriceOnlyTimeDuration: false,
            showFilterOptions5: false,
            showApplyFilterOptionsBtn: false,
            showApplyFilterErrMsg: false,
            showSectionLoading2: true,
            showBaselineValueBtn: false,
            showBaselineIntroMessage: false,
            baselineValueMsg: ""
        }, () => {
            setTimeout(() => {
                this.setState({
                    showSectionLoading2: false,
                    showFilterOptionsInProgressFinal: true,
                    showBaselineValueBtn: true,
                    showAppliedFilters: true,
                    showEarningEditHeader: true,
                    showEditEarningValue: true,
                    showEditExpirationHeader: false,
                    showEditExpirationLoyalty: false,
                    showEarningPolicyPercentageChange: true,
                    showMultiplierDurationPeriod: true,
                    showMultiplierCalendarValueAsterisk: true,
                    showEarningWithFilterBtn: true
                })
                if (this.state.filterOptionPricing != "") {
                    this.state.showAppliedPricingFilter = true
                } else {
                    this.state.showAppliedPricingFilter = false
                }
                if (this.state.rewardMenuCategory != "") {
                    this.state.showAppliedSelectedMealFilter = true
                } else {
                    this.state.showAppliedSelectedMealFilter = false
                }
                if (this.state.filterOptionPricing != "" && this.state.rewardMenuCategory != "") {
                    this.state.showAndOrFilterBtns = true
                } else {
                    this.state.showAndOrFilterBtns = false
                }
            }, 2500)
            setTimeout (() => {
                this.handleScrollToElement()
            }, 2900)
        })
    }

    renderPricingFilter = () => {
        if (this.state.filterOptionPricing != "") {
            if(this.state.priceFilterComparative == "equal" && this.state.filterOptionTimeValue == "") {
                return (
                    <div className='appliedFilterResult'>
                        <p>↳ If a customer spends exactly KES {this.state.filterOptionPricing}.</p>
                    </div>
                )
            } else if (this.state.priceFilterComparative == "equal" && this.state.filterOptionTimeValue != "") {
                return (
                    <div className='appliedFilterResult'>
                        <p>↳ If a customer spends exactly KES {this.state.filterOptionPricing} within the next {this.state.filterOptionTimeValue} {this.state.filterOptionCalendarValue}(s).</p>
                    </div>
                )
            } else if (this.state.priceFilterComparative == "greater" && this.state.filterOptionTimeValue == "") {
                return (
                    <div className='appliedFilterResult'>
                        <p>↳ If a customer spends greater than KES {this.state.filterOptionPricing}.</p>
                    </div>
                )
            } else if (this.state.priceFilterComparative == "greater" && this.state.filterOptionTimeValue != "") {
                return (
                    <div className='appliedFilterResult'>
                        <p>↳ If a customer spends greater than KES {this.state.filterOptionPricing} within the next {this.state.filterOptionTimeValue} {this.state.filterOptionCalendarValue}(s).</p>
                    </div>
                )
            } else if (this.state.priceFilterComparative == "equal-greater" && this.state.filterOptionTimeValue == "") {
                return (
                    <div className='appliedFilterResult'>
                        <p>↳ If a customer spends equal to or greater than KES {this.state.filterOptionPricing}.</p>
                    </div>
                )
            } else if (this.state.priceFilterComparative == "equal-greater" && this.state.filterOptionTimeValue != "") {
                return (
                    <div className='appliedFilterResult'>
                        <p>↳ If a customer spends equal to or greater than KES {this.state.filterOptionPricing} within the next {this.state.filterOptionTimeValue} {this.state.filterOptionCalendarValue}(s).</p>
                    </div>
                )
            }
        }
    }

    renderSelectedMealFilter = () => {
        if (this.state.rewardMenuCategory != "" && this.state.filterOptionTimeValue != "") {
            return (
                <div className='appliedFilterResult'>
                    <p>↳ If a customer orders {this.state.rewardQuantity}x {this.state.rewardMenuItem} within the next {this.state.filterOptionTimeValue} {this.state.filterOptionCalendarValue}(s).</p>
                </div>
            )
        } else if (this.state.rewardMenuCategory != "" && this.state.filterOptionTimeValue == "") {
            return (
                <div className='appliedFilterResult'>
                    <p>↳ If a customer orders {this.state.rewardQuantity}x {this.state.rewardMenuItem}.</p>
                </div>
            )
        } 
    }

    earningValueOptionClicked = (selectedOption) => {
        if (selectedOption.value == "direct-conversion") {
            this.setState({
                showEarnPointsDirect: true,
                showEarnPointsPercentage: false
            })
        } else { 
            this.setState({
                showEarnPointsDirect: false,
                showEarnPointsPercentage: true
            })
        }
    }

    andFilterBtnClicked = () => {
        if (this.state.andFilterBtnBgColor == "white") {
            this.setState({
                andFilterBtnBgColor: "#C0CDFF",
                // andFilterBtnBorderColor: "#abbcff",
                orFilterBtnBgColor: "white",
                orFilterBtnTxtColor: "#0930cb",
                orFilterBtnBorderColor: "#0930cb"
            })
        } else {
            this.setState({
                andFilterBtnBgColor: "white",
                andFilterBtnBorderColor: "#0930cb",
            })
        }
    }

    orFilterBtnClicked = () => {
        if (this.state.orFilterBtnBgColor == "white") {
            this.setState({
                orFilterBtnBgColor: "#C0CDFF",
                // orFilterBtnBorderColor: "#abbcff",
                andFilterBtnBgColor: "white",
                andFilterBtnTxtColor: "#0930cb",
                andFilterBtnBorderColor: "#0930cb"
            })
        } else {
            this.setState({
                orFilterBtnBgColor: "white",
                orFilterBtnBorderColor: "#0930cb",
            })
        }
    }

    finishSaveReferralDetails = () => {
        if (this.state.referralRegistrationValue != "" && this.state.pointsEarnedValue != "") {
            this.setState({
                referralRegistrationValueBorderColor: "#000",
                pointsEarnedValueBorderColor: "#000",
                showEditUnlimitedReferralCodeEarning: false,
                showBaselineIntroMessage: false,
                showFilterOptionsInProgress: false,
                baselineValueMsg: "",
                showSectionLoading2: true,
                savedReferralRegistrationPointsValue: this.state.pointsEarnedValue,
                savedReferralRegistrationValue: this.state.referralRegistrationValue,
                savedReferralRegistrationLimitValue: this.state.referralRegistrationLimitValue,
                showEarningEditHeader: false,
                showBaselineValueBtn: false
            }, () => {
                setTimeout(() => {
                        //! - - COMPLETE UI CHANGES ALSO - - !//
                    this.setState({
                        showSectionLoading2: false,
                        showEarningEditHeader: true,
                        showBaselineValueBtn: true,
                        showEarningValueOptions: true,
                        showShowAllEarningsHeader: true,
                        currentCustomerAction: "",
                        showSettingReferralLimit: false,
                        showLimitSelectedFilter: false,
                        showUnlimitedSelectedFilter: false,
                        referralRegistrationLimitBorderColor: "#000",
                        limitedReferralTxt: "Set limit",
                        unlimitedReferralTxt: "Unlimited",
                        setLimitBtnBgColor: "#0930cb",
                        setLimitBtnTxtColor: "white",
                        unlimitedBtnBgColor: "#0930cb",
                        unlimitedBtnTxtColor: "white",
                        pointsEarnedValue: ""
                    })
                }, 2500)
            })
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("earning")
            .doc("parameters")
            .collection("referral")
            .doc("referralData")
            .set({
                referralPointsEarnedValue: this.state.pointsEarnedValue,
                referralRegistrationValue: this.state.referralRegistrationValue
            })
                //* - - UPDATES CUSTOMER FACING POINTS EARNING VALUE - - *//
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("campaigns")
            .collection("leftSidePane")
            .doc("customerInformation")
            .collection("referralInformation")
            .doc("text")
            .update({
                referralPolicyPoints: this.state.pointsEarnedValue,
                referralPolicyReferralCount: this.state.referralRegistrationValue
            })
        } else {
            this.handleScrollToElement()
            if (this.state.referralRegistrationValue == "") {
                this.setState({
                    referralRegistrationValueBorderColor: "red",
                })
            } else {
                this.setState({
                    referralRegistrationValueBorderColor: "#000",
                })
            }
            if (this.state.pointsEarnedValue == "") {
                this.setState({
                    pointsEarnedValueBorderColor: "red"
                })
            } else {
                this.setState({
                    pointsEarnedValueBorderColor: "#000"
                })
            }
            this.setState({
                showBaselineIntroMessage: true,
                baselineValueMsg: "Please fill in all required fields.",
            })
        }
    }
 
    finishEarningFilterClicked = () => {
        if (this.state.pointsEarnedValue.includes('.')) {
            this.setState({
                showApplyFilterErrMsg4: true,
                applyFilterErrMessage3: "Please enter whole numbers"
            })
        } else {
            if (this.state.priceFilterSelected == true && this.state.mealFilterSelected == false) {
                if ((this.state.pointsEarnedValue == this.state.savedPointsValue) && (this.state.pointsMoneyValue == this.state.savedMoneyValue)) {
                    this.setState({
                        showApplyFilterErrMsg2: true,
                        applyFilterErrMessage: "Earning policy is the same as the Baseline Policy"
                    })
                } else if (((this.state.pointsEarnedValue != this.state.savedPointsValue) || (this.state.pointsMoneyValue != this.state.savedMoneyValue)) && (this.state.multiplierTimeValue != "" && this.state.multiplierCalendarValue != "")) {
                    this.pushSingleEarningPolicyToDatabase()
                    this.setState({
                        showFilterOptionsInProgressFinal: false,
                        showBaselineValueBtn: false,
                        showAppliedFilters: false,
                        showEarningEditHeader: false,
                        showEditEarningValue: false,
                        showEarningWithFilterBtn: false,
                        showAppliedPricingFilter: false,
                        showAppliedSelectedMealFilter: false,
                        showAndAndFilterBtns: false,
                        showAndOrFilterBtns: false,
                        showEarningPolicyPercentageChange: false,
                        showApplyFilterErrMsg4: false,
                        applyFilterErrMessage3: "",
                        earningPolicyPercentageValue: 0,
                        showMealSelectedLabel: true,
                        showTimeDurationLabel: true,
                        showPriceDescriptorLabel: true,
                        showMealOrderDetails: false,
                        showMealOrderTimeDetails: false,
                        showPriceDescriptorDetails: false,
                        showSelectedNoneFilter: false,
                        showSelectedPriceFilter: false,
                        showSelectedMealFilter: false,
                        filterOptionBtn1: "None",
                        filterOptionBtn2: "Price",
                        filterOptionBtn3: "Meal",
                        filterOptions1BgColor: "#0930cb",
                        filterOptions1TxtColor: "white",
                        filterOptions2BgColor: "#0930cb",
                        filterOptions2TxtColor: "white",
                        filterOptions5BgColor: "#0930cb",
                        filterOptions5TxtColor: "white",
                        showMultiplierDurationPeriod: false,
                        showSectionLoading2: true
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                showSectionLoading2: false,
                                showEarningEditHeader: true,
                                showEarningValueOptions: true,
                                showBaselineValueBtn: true,
                                showShowAllEarningsHeader: true,
                                showBaselineIntroMessage: true,
                                baselineValueMsg: "Your PRICE earning policy has been saved."
                            })
                        }, 3000)
                    })
                    this.setState({
                        showApplyFilterErrMsg2: false,
                        applyFilterErrMessage: ""
                    })
                } else {
                    this.handleScrollToElement()
                    this.setState({
                        showBaselineIntroMessage: true,
                        baselineValueMsg: "Please fill in all required fields."
                    })
                }
            } else if (this.state.priceFilterSelected == false && this.state.mealFilterSelected == true) {
                if ((this.state.pointsEarnedValue == this.state.savedPointsValue) && (this.state.pointsMoneyValue == this.state.savedMoneyValue)) {
                    this.setState({
                        showApplyFilterErrMsg2: true,
                        applyFilterErrMessage: "Earning policy is the same as the Baseline Policy"
                    })
                } else if ((this.state.pointsEarnedValue != this.state.savedPointsValue) || (this.state.pointsMoneyValue != this.state.savedMoneyValue) && (this.state.multiplierTimeValue != "" && this.state.multiplierCalendarValue != "")) {
                    this.pushSingleEarningPolicyToDatabase()
                    this.setState({
                        showFilterOptionsInProgressFinal: false,
                        showBaselineValueBtn: false,
                        showAppliedFilters: false,
                        showEarningEditHeader: false,
                        showEditEarningValue: false,
                        showEarningWithFilterBtn: false,
                        showAppliedPricingFilter: false,
                        showAppliedSelectedMealFilter: false,
                        showAndAndFilterBtns: false,
                        showAndOrFilterBtns: false,
                        showApplyFilterErrMsg4: false,
                        applyFilterErrMessage3: "",
                        showEarningPolicyPercentageChange: false,
                        showMealSelectedLabel: true,
                        showTimeDurationLabel: true,
                        earningPolicyPercentageValue: 0,
                        showPriceDescriptorLabel: true,
                        showMealOrderDetails: false,
                        showMealOrderTimeDetails: false,
                        showPriceDescriptorDetails: false,
                        showSelectedNoneFilter: false,
                        showSelectedPriceFilter: false,
                        showSelectedMealFilter: false,
                        filterOptionBtn1: "None",
                        filterOptionBtn2: "Price",
                        filterOptionBtn3: "Meal",
                        filterOptions1BgColor: "#0930cb",
                        filterOptions1TxtColor: "white",
                        filterOptions2BgColor: "#0930cb",
                        filterOptions2TxtColor: "white",
                        filterOptions5BgColor: "#0930cb",
                        filterOptions5TxtColor: "white",
                        showMultiplierDurationPeriod: false,
                        showSectionLoading2: true
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                showSectionLoading2: false,
                                showEarningEditHeader: true,
                                showEarningValueOptions: true,
                                showBaselineValueBtn: true,
                                showShowAllEarningsHeader: true,
                                showBaselineIntroMessage: true,
                                baselineValueMsg: "Your MEAL earning policy has been saved."
                            })
                        }, 3000)
                    })
                    this.setState({
                        showApplyFilterErrMsg2: false,
                        applyFilterErrMessage: ""
                    })
                } else {
                    this.handleScrollToElement()
                    this.setState({
                        showBaselineIntroMessage: true,
                        baselineValueMsg: "Please fill in all required fields."
                    })
                }
            } else if (this.state.priceFilterSelected == true && this.state.mealFilterSelected == true) {
                if (this.state.orFilterBtnBgColor == "white" && this.state.andFilterBtnBgColor == "white") {
                    this.setState({
                        showApplyFilterErrMsg3: true,
                        applyFilterErrMessage2: "Select 'AND' or 'OR' to apply filters correctly"
                    })
                } 
                // else {
                //     console.log("A VERY STRANGE SCENARO THAT NEEDS DELETING")
                //     this.pushSingleEarningPolicyToDatabase()
                //     this.setState({
                //         showFilterOptionsInProgressFinal: false,
                //         showBaselineValueBtn: false,
                //         showAppliedFilters: false,
                //         showEarningEditHeader: false,
                //         showEditEarningValue: false,
                //         showEarningWithFilterBtn: false,
                //         showAppliedPricingFilter: false,
                //         showAppliedSelectedMealFilter: false,
                //         showAndAndFilterBtns: false,
                //         showAndOrFilterBtns: false,
                //         showApplyFilterErrMsg4: false,
                //         applyFilterErrMessage3: "",
                //         showMealSelectedLabel: true,
                //         showTimeDurationLabel: true,
                //         showPriceDescriptorLabel: true,
                //         showMealOrderDetails: false,
                //         earningPolicyPercentageValue: 0,
                //         showMealOrderTimeDetails: false,
                //         showPriceDescriptorDetails: false,
                //         showEarningPolicyPercentageChange: false,
                //         showSelectedNoneFilter: false,
                //         showSelectedPriceFilter: false,
                //         showSelectedMealFilter: false,
                //         filterOptionBtn1: "None",
                //         filterOptionBtn2: "Price",
                //         filterOptionBtn3: "Meal",
                //         filterOptions1BgColor: "#0930cb",
                //         filterOptions1TxtColor: "white",
                //         filterOptions2BgColor: "#0930cb",
                //         filterOptions2TxtColor: "white",
                //         filterOptions5BgColor: "#0930cb",
                //         filterOptions5TxtColor: "white",
                //         showSectionLoading2: true
                //     }, () => {
                //         setTimeout(() => {
                //             this.setState({
                //                 showSectionLoading2: false,
                //                 showEarningEditHeader: true,
                //                 showEarningValueOptions: true,
                //                 showBaselineValueBtn: true,
                //                 showShowAllEarningsHeader: true,
                //                 showBaselineIntroMessage: true,
                //                 baselineValueMsg: "Your MEAL earning policy has been saved."
                //             })
                //         }, 2500)
                //     })
                //     this.setState({
                //         showApplyFilterErrMsg3: false,
                //         applyFilterErrMessage2: ""
                //     })
                // }
        
                if ((this.state.pointsEarnedValue == this.state.savedPointsValue) && (this.state.pointsMoneyValue == this.state.savedMoneyValue)) {
                    this.setState({
                        showApplyFilterErrMsg2: true,
                        applyFilterErrMessage: "Earning policy is the same as the Baseline Policy"
                    })
                } else {
                    this.setState({
                        showApplyFilterErrMsg2: false,
                        applyFilterErrMessage: ""
                    })
                }
        
                if ((this.state.orFilterBtnBgColor != "white" || this.state.andFilterBtnBgColor != "white") && (this.state.pointsEarnedValue != this.state.savedPointsValue || this.state.pointsMoneyValue != this.state.savedMoneyValue) && (this.state.multiplierTimeValue != "" && this.state.multiplierCalendarValue != "")) {
                    
                    var andBoolean = false
                    var orBoolean = false
        
                    if (this.state.andFilterBtnBgColor != "white") {
                        andBoolean = true
                    }
        
                    if (this.state.orFilterBtnBgColor != "white") {
                        orBoolean = true
                        
                    }
                    //* IF AND: You know that you have to take the PRICING filter and the MEAL filter (WRAPPED IN ONE)
                    
                    if (this.state.andFilterBtnBgColor !== "white") {
                        this.pushDoubleEarningPolicyToDatabase(andBoolean, orBoolean, false, false)
                        this.setState({
                            showFilterOptionsInProgressFinal: false,
                            showBaselineValueBtn: false,
                            showAppliedFilters: false,
                            showEarningEditHeader: false,
                            showEditEarningValue: false,
                            showEarningWithFilterBtn: false,
                            showAppliedPricingFilter: false,
                            showAppliedSelectedMealFilter: false,
                            showAndAndFilterBtns: false,
                            showAndOrFilterBtns: false,
                            showEarningPolicyPercentageChange: false,
                            showApplyFilterErrMsg4: false,
                            applyFilterErrMessage3: "",
                            showMealSelectedLabel: true,
                            showTimeDurationLabel: true,
                            earningPolicyPercentageValue: 0,
                            showPriceDescriptorLabel: true,
                            showMealOrderDetails: false,
                            showMealOrderTimeDetails: false,
                            showPriceDescriptorDetails: false,
                            showSelectedNoneFilter: false,
                            showSelectedPriceFilter: false,
                            showSelectedMealFilter: false,
                            filterOptionBtn1: "None",
                            filterOptionBtn2: "Price",
                            filterOptionBtn3: "Meal",
                            filterOptions1BgColor: "#0930cb",
                            filterOptions1TxtColor: "white",
                            filterOptions2BgColor: "#0930cb",
                            filterOptions2TxtColor: "white",
                            filterOptions5BgColor: "#0930cb",
                            filterOptions5TxtColor: "white",
                            showMultiplierDurationPeriod: false,
                            showSectionLoading2: true
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    showSectionLoading2: false,
                                    showEarningEditHeader: true,
                                    showEarningValueOptions: true,
                                    showBaselineValueBtn: true,
                                    showShowAllEarningsHeader: true,
                                    showBaselineIntroMessage: true,
                                    baselineValueMsg: "Your combined MEAL & PRICE earning policy has been saved."
                                })
                            }, 3000)
                        })
                    } else if (this.state.orFilterBtnBgColor != "white") {
                        this.setState({
                            showFilterOptionsInProgressFinal: false,
                            showBaselineValueBtn: false,
                            showAppliedFilters: false,
                            showEarningEditHeader: false,
                            showEditEarningValue: false,
                            showEarningWithFilterBtn: false,
                            showAppliedPricingFilter: false,
                            showAppliedSelectedMealFilter: false,
                            showAndAndFilterBtns: false,
                            showAndOrFilterBtns: false,
                            showEarningPolicyPercentageChange: false,
                            showApplyFilterErrMsg4: false,
                            applyFilterErrMessage3: "",
                            showMealSelectedLabel: true,
                            showTimeDurationLabel: true,
                            showPriceDescriptorLabel: true,
                            showMealOrderDetails: false,
                            showMealOrderTimeDetails: false,
                            showPriceDescriptorDetails: false,
                            showSelectedNoneFilter: false,
                            showSelectedPriceFilter: false,
                            showSelectedMealFilter: false,
                            filterOptionBtn1: "None",
                            filterOptionBtn2: "Price",
                            filterOptionBtn3: "Meal",
                            filterOptions1BgColor: "#0930cb",
                            filterOptions1TxtColor: "white",
                            filterOptions2BgColor: "#0930cb",
                            filterOptions2TxtColor: "white",
                            filterOptions5BgColor: "#0930cb",
                            filterOptions5TxtColor: "white",
                            showMultiplierDurationPeriod: false,
                            showSectionLoading2: true
                        }, () => {
                            this.pushDoubleEarningPolicyToDatabase(andBoolean, orBoolean, true, false)
                            setTimeout(() => {
                                this.setState({
                                    showSectionLoading2: false,
                                    showEarningEditHeader: true,
                                    showEarningValueOptions: true,
                                    showBaselineValueBtn: true,
                                    showShowAllEarningsHeader: true,
                                    showBaselineIntroMessage: true,
                                    baselineValueMsg: "Your MEAL earning policy has been saved and your PRICE earning policy has been saved."
                                })
                                this.pushDoubleEarningPolicyToDatabase(andBoolean, orBoolean, false, true)
                            }, 3000)
                            setTimeout (() => {
                                this.setState({
                                    priceFilterComparative: "",
                                    filterOptionPricing: "",
                                    rewardQuantity: "",
                                    rewardMenuCategory: "",
                                    rewardMenuItem: "",
                                    filterOptionTimeValue: "",
                                    filterOptionCalendarValue: "",
                                    multiplierCalendarValue: "",
                                    multiplierTimeValue: "",
                                    pointsEarnedValue: this.state.savedPointsValue,
                                    moneyValue: this.state.savedMoneyValue
                                })
                                this.clearMultiplierTimeDuration()
                            }, 4000)
                        })
                    }
                } else {
                    this.handleScrollToElement()
                    this.setState({
                        showBaselineIntroMessage: true,
                        baselineValueMsg: "Please fill in all required fields."
                    })
                }
            }
        }
    }

    pushSingleEarningPolicyToDatabase = async () => {
        if (this.state.priceFilterSelected == true) {
            await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("earning")
            .doc("parameters")
            .collection("purchase")
            .doc(`earning-${this.state.purchaseCount}`)
            .set({
                id: `earning-${this.state.purchaseCount}`,
                selected: false,
                dateCreated: `${this.formatDateToDDMMYYYY(new Date())}`,
                dateStatusActive: "(not set)",
                priceOnly: this.state.priceFilterSelected,
                mealOnly: false, 
                pointsValue: this.state.pointsEarnedValue,
                moneyValue: this.state.pointsMoneyValue,
                andFilter: false,
                orFilter: false,
                status: false,
                priceFilterComparative: this.state.priceFilterComparative,
                filterOptionPricing: this.state.filterOptionPricing,
                rewardQuantity: this.state.rewardQuantity,
                rewardMenuItem: this.state.rewardMenuItem,
                filterOptionTimeValue: this.state.filterOptionTimeValue,
                filterOptionCalendarValue: this.state.filterOptionCalendarValue,
                filterOptionEndDate: this.state.filterOptionEndDate,
                multiplierTimeValue: this.state.multiplierTimeValue,
                multiplierCalendarValue: this.state.multiplierCalendarValue
            })
            .then(() => {
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("earning")
                .doc("parameters")
                .update({
                    purchaseCount: this.state.purchaseCount-1
                })
                setTimeout(() => {
                    this.getLatestPurchaseEarningCount()
                    this.setState({
                        priceFilterComparative: "",
                        priceFilterSelected: false,
                        mealFilterSelected: false,
                        filterOptionPricing: "",
                        rewardQuantity: "",
                        rewardMenuCategory: "",
                        rewardMenuItem: "",
                        filterOptionTimeValue: "",
                        filterOptionCalendarValue: "",
                        multiplierCalendarValue: "",
                        multiplierTimeValue: "",
                        pointsEarnedValue: this.state.savedPointsValue,
                        moneyValue: this.state.savedMoneyValue
                    })
                    this.clearMultiplierTimeDuration()
                }, 2000);
            })
        } else {
            await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("earning")
            .doc("parameters")
            .collection("purchase")
            .doc(`earning-${this.state.purchaseCount}`)
            .set({
                id: `earning-${this.state.purchaseCount}`,
                selected: false,
                dateCreated: `${this.formatDateToDDMMYYYY(new Date())}`,
                dateStatusActive: "(not set)",
                priceOnly: false,
                mealOnly: true, 
                pointsValue: this.state.pointsEarnedValue,
                moneyValue: this.state.pointsMoneyValue,
                andFilter: false,
                orFilter: false,
                status: false,
                priceFilterComparative: this.state.priceFilterComparative,
                filterOptionPricing: this.state.filterOptionPricing,
                rewardQuantity: this.state.rewardQuantity,
                rewardMenuItem: this.state.rewardMenuItem,
                filterOptionTimeValue: this.state.filterOptionTimeValue,
                filterOptionCalendarValue: this.state.filterOptionCalendarValue,
                filterOptionEndDate: this.state.filterOptionEndDate,
                multiplierTimeValue: this.state.multiplierTimeValue,
                multiplierCalendarValue: this.state.multiplierCalendarValue
            })
            .then(() => {
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("earning")
                .doc("parameters")
                .update({
                    purchaseCount: this.state.purchaseCount-1
                })
                setTimeout(() => {
                    this.getLatestPurchaseEarningCount()
                    this.setState({
                        priceFilterComparative: "",
                        filterOptionPricing: "",
                        rewardQuantity: "",
                        rewardMenuCategory: "",
                        priceFilterSelected: false,
                        mealFilterSelected: false,
                        rewardMenuItem: "",
                        filterOptionTimeValue: "",
                        filterOptionCalendarValue: "",
                        multiplierCalendarValue: "",
                        multiplierTimeValue: "",
                        pointsEarnedValue: this.state.savedPointsValue,
                        moneyValue: this.state.savedMoneyValue
                    })
                    this.clearMultiplierTimeDuration()
                }, 2000);
            })
        }
    }

    pushDoubleEarningPolicyToDatabase = async (andBoolean, orBoolean, priceOnly, mealOnly) => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("earning")
        .doc("parameters")
        .collection("purchase")
        .doc(`earning-${this.state.purchaseCount}`)
        .set({
            id: `earning-${this.state.purchaseCount}`,
            selected: false,
            dateCreated: `${this.formatDateToDDMMYYYY(new Date())}`,
            dateStatusActive: "(not set)",
            priceOnly: priceOnly,
            mealOnly: mealOnly,
            pointsValue: this.state.pointsEarnedValue,
            moneyValue: this.state.pointsMoneyValue,
            andFilter: andBoolean,
            orFilter: orBoolean,
            status: false,
            priceFilterComparative: this.state.priceFilterComparative,
            filterOptionPricing: this.state.filterOptionPricing,
            rewardQuantity: this.state.rewardQuantity,
            rewardMenuItem: this.state.rewardMenuItem,
            filterOptionTimeValue: this.state.filterOptionTimeValue,
            filterOptionCalendarValue: this.state.filterOptionCalendarValue,
            filterOptionEndDate: this.state.filterOptionEndDate,
            multiplierTimeValue: this.state.multiplierTimeValue,
            multiplierCalendarValue: this.state.multiplierCalendarValue
        })
        .then(() =>{
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("earning")
            .doc("parameters")
            .update({
                purchaseCount: this.state.purchaseCount-1
            })
            setTimeout(() => {
                this.getLatestPurchaseEarningCount()
            }, 2000);
        })
    }
 
    closeBaselineNotification = () => {
        this.setState({
            showBaselineIntroMessage: false
        })
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .update({
            baselineNotification: false
        })
    }

    closeRewardsNotification = () => {
        this.setState({
            showRewardsErrorMsg: false
        })
    }

    loadEarningPolicies = () => {
        class EarningPolicy {
            constructor(andFilter, dateCreated, dateStatusActive, filterOptionCalendarValue, filterOptionEndDate, filterOptionPricing, filterOptionTimeValue, id, mealOnly, moneyValue, multiplierCalendarValue, multiplierTimeValue, orFilter, pointsValue, priceFilterComparative, priceOnly, rewardMenuItem, rewardQuantity, selected, status) {
                this.andFilter = andFilter
                this.dateCreated = dateCreated
                this.dateStatusActive = dateStatusActive
                this.filterOptionCalendarValue = filterOptionCalendarValue
                this.filterOptionEndDate = filterOptionEndDate
                this.filterOptionPricing = filterOptionPricing
                this.filterOptionTimeValue = filterOptionTimeValue
                this.id = id
                this.mealOnly = mealOnly
                this.moneyValue = moneyValue
                this.multiplierCalendarValue = multiplierCalendarValue
                this.multiplierTimeValue = multiplierTimeValue
                this.orFilter = orFilter
                this.pointsValue = pointsValue
                this.priceFilterComparative = priceFilterComparative
                this.priceOnly = priceOnly
                this.rewardMenuItem = rewardMenuItem
                this.rewardQuantity = rewardQuantity
                this.selected = selected
                this.status = status
            }
            toString() {
                return this.andFilter + ', ' +
                this.dateCreated + ', ' +
                this.dateStatusActive + ', ' +
                this.filterOptionCalendarValue + ', ' +
                this.filterOptionEndDate + ', ' +
                this.filterOptionPricing + ', ' +
                this.filterOptionTimeValue + ', ' +
                this.id + ', ' +
                this.mealOnly + ', ' +
                this.moneyValue  + ', ' +
                this.multiplierCalendarValue + ', ' +
                this.multiplierTimeValue + ', ' +
                this.orFilter + ', ' +
                this.pointsValue  + ', ' +
                this.priceFilterComparative + ', ' +
                this.priceOnly + ', ' +
                this.rewardMenuItem + ', ' +
                this.rewardQuantity + ', ' +
                this.selected + ', ' +
                this.status
            }
        }
        var earningPolicyConverter = {
            toFirestore : function(policy) {
                return {
                    andFilter: policy.andFilter,
                    dateCreated: policy.dateCreated,
                    dateStatusActive: policy.dateStatusActive,
                    filterOptionCalendarValue: policy.filterOptionCalendarValue,
                    filterOptionEndDate: policy.filterOptionEndDate,
                    filterOptionPricing: policy.filterOptionPricing,
                    filterOptionTimeValue: policy.filterOptionTimeValue,
                    id: policy.id,
                    mealOnly: policy.mealOnly,
                    moneyValue: policy.moneyValue,
                    multiplierCalendarValue: policy.multiplierCalendarValue,
                    multiplierTimeValue: policy.multiplierTimeValue,
                    orFilter: policy.orFilter,
                    pointsValue: policy.pointsValue,
                    priceFilterComparative: policy.priceFilterComparative,
                    priceOnly: policy.priceOnly,
                    rewardMenuItem: policy.rewardMenuItem,
                    rewardQuantity: policy.rewardQuantity,
                    selected: policy.selected,
                    status: policy.status
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new EarningPolicy(data.andFilter, data.dateCreated, data.dateStatusActive, data.filterOptionCalendarValue, data.filterOptionEndDate, data.filterOptionPricing,
                    data.filterOptionTimeValue, data.id, data.mealOnly, data.moneyValue, data.multiplierCalendarValue, data.multiplierTimeValue, data.orFilter,
                    data.pointsValue, data.priceFilterComparative, data.priceOnly, data.rewardMenuItem, data.rewardQuantity, data.selected, data.status)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("earning")
        .doc("parameters")
        .collection("purchase")
        .withConverter(earningPolicyConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            if (this.calculateTotalPages(data) == 1 || this.calculateTotalPages(data) == 0) {
                this.setState({
                    nextBtnTxt: ""
                })
            }
            this.setState({
                totalEarningPolicyPages: this.calculateTotalPages(data),
                listEarningPolicies: data
            })
        })

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("earning")
        .doc("parameters")
        .get().then(doc => {
            if (doc.data().selectedEarningPoliciesCount > 0) {
                this.setState({
                    isPopupVisible: true
                })
            }
            this.setState({
                selectedEarningPoliciesCount: doc.data().selectedEarningPoliciesCount
            })
        })
    }

    renderAllEarningPolicies = () => {
        if (!this.state.listEarningPolicies.length == 0) {
            const itemsPerPage = 10;  // Adjust this number based on the desired items per page
            const { currentPage } = this.state;
            const startIndex = (currentPage - 1) * itemsPerPage;
            const endIndex = startIndex + itemsPerPage;
            const visibleEarningPolicies = this.state.listEarningPolicies.slice(startIndex, endIndex);

            console.log(visibleEarningPolicies)

            if (visibleEarningPolicies.length === 0) {
                return <p>No earning policies to display.</p>;
            }
            return(visibleEarningPolicies.map(policies => {
                var {andFilter, dateCreated, dateStatusActive, filterOptionCalendarValue, filterOptionEndDate, 
                    filterOptionPricing, filterOptionTimeValue, id, mealOnly, moneyValue, multiplierCalendarValue, 
                    multiplierTimeValue, orFilter, pointsValue, priceFilterComparative, priceOnly, 
                    rewardMenuItem, rewardQuantity, selected, status} = policies

                    //* - - PRICE ONLY - MEAL ONLY - - *//

                    let showEPPricingLabel = false
                    let showEPMealLabel = false

                    if (priceOnly == true) {
                        showEPPricingLabel = true
                    }

                    if (mealOnly == true) {
                        showEPMealLabel = true
                    }

                    if (mealOnly == false && priceOnly == false) {
                        showEPMealLabel = true
                        showEPPricingLabel = true
                    }

                    //* - - EARNING POLICY - - *//

                    let pricePolicy = ""
                    let mealPolicy = ""
                    let mealPolicyTimeWindow = ""
                    let priceOnlyEndDate = false
                    let mealPresentEndDate = false

                    if (mealOnly == false && priceOnly == false) {
                        if (priceFilterComparative == "equal") {
                            pricePolicy = `PRICE = KES ${filterOptionPricing} (Eq)`
                        } else if (priceFilterComparative == "greater") {
                            pricePolicy = `PRICE > KES ${filterOptionPricing} (Gr)`
                        } else if (priceFilterComparative == "equal-greater") {
                            pricePolicy = `PRICE >= KES ${filterOptionPricing} (Gr-Eq)`
                        } else {
                            priceFilterComparative = ""
                        }
                        
                        if (rewardMenuItem != "") {
                            mealPolicy = `${rewardQuantity}x ${rewardMenuItem}`
                        }
    
                        if (filterOptionTimeValue != "") {
                            mealPolicyTimeWindow = `↳ ${filterOptionTimeValue} ${filterOptionCalendarValue}(s)`
                        }
                        mealPresentEndDate = true
                    } else if (priceOnly == true && mealOnly == false) {
                        if (priceFilterComparative == "equal") {
                            pricePolicy = `PRICE = KES ${filterOptionPricing} (Eq)`
                        } else if (priceFilterComparative == "greater") {
                            pricePolicy = `PRICE > KES ${filterOptionPricing} (Gr)`
                        } else if (priceFilterComparative == "equal-greater") {
                            pricePolicy = `PRICE >= KES ${filterOptionPricing} (Gr-Eq)`
                        } else {
                            priceFilterComparative = ""
                        }
                        
                            //? - - THIS IS ACTUALLY A TIME POLICY IN THE MEAL POLICY VARIABLE STRICTLY FOR UI REASONS - HAVE NO FEAR - - ?//
                        priceOnlyEndDate = true
                        mealPolicy = `↳ ${filterOptionTimeValue} ${filterOptionCalendarValue}(s) `
                        // mealPolicyTimeWindow = ``

                    } else if (priceOnly == false && mealOnly == true) {
                        if (rewardMenuItem != "") {
                            mealPolicy = `${rewardQuantity}x ${rewardMenuItem}`
                        }
    
                        if (filterOptionTimeValue != "") {
                            mealPolicyTimeWindow = `↳ ${filterOptionTimeValue} ${filterOptionCalendarValue}(s)`
                        }
                        mealPresentEndDate = true
                        pricePolicy = ""
                    }

                    //* - - EARNING VALUE - - *//

                    let oldRatio = this.roundToDecimal(parseFloat(this.state.savedPointsValue), 3) / this.roundToDecimal(parseFloat(this.state.savedMoneyValue), 3)
                    let newRatio = this.roundToDecimal(parseFloat(pointsValue), 3) / this.roundToDecimal(parseFloat(moneyValue), 3)
                    let percentageChange = parseInt(this.calculatePercentageChange(oldRatio, newRatio))


                    //* - - SELECTED EP - - *//
                    
                    let EPUnselected = true
                    let EPSelected = false

                    if (selected == true) {
                        EPUnselected = false
                        EPSelected = true
                    } else {
                        EPUnselected = true
                        EPSelected = false
                    }

                    let EPInactive = true
                    let EPActive = false

                    if (status == true) {
                        EPInactive = false
                        EPActive = true
                    } else {
                        EPActive = false
                        EPInactive = true
                    }

                    //* - - MULTIPLIER VALIDATION PERIOD - - *//

                    let multiplierStatement

                    multiplierStatement = `${multiplierTimeValue} ${multiplierCalendarValue}(s)`
                    
                    return (
                        <div className='earningPolicyCell'>
                            <div className='EPCellCol1'>
                                <button>
                                    {EPUnselected && 
                                        <img 
                                        alt=''
                                        onClick={() => this.selectedEPClicked(id, selected)}
                                        src='/assets/earningPolicyUnchecked.png'/>
                                    }
                                    {EPSelected && 
                                        <img 
                                        alt=''
                                        onClick={() => this.selectedEPClicked(id, selected)}
                                        src='/assets/earningPolicyChecked.png'/>
                                    }
                                </button>
                            </div>
                            <div className='EPCellCol2'>
                                <div className='EPCellCol2Containers'>
                                    {showEPPricingLabel && <button>Pricing</button> }
                                    {showEPMealLabel && <button>Meal</button> }
                                </div>
                            </div>
                            <div className='EPCellCol3'>
                                <p>{pricePolicy} 
                                <p>{mealPolicy} {priceOnlyEndDate ? <span style={{marginLeft:"1.5%", color: "red"}}>[{filterOptionEndDate}]</span> : null}</p> {mealPolicyTimeWindow} {mealPresentEndDate ? <span style={{marginLeft:"1.5%", color: "red"}}>[{filterOptionEndDate}]</span> : null }</p>
                                {/* <p></p> */}
                            </div>
                            <div className='EPCellCol3_5'>
                                <span><p>{multiplierStatement}</p></span>
                            </div>
                            <div className='EPCellCol4'>
                                <div className='appliedFilterResult2'>
                                    <p>↳ {pointsValue}pts → KES{moneyValue}<span>↑ {percentageChange}%</span></p>
                                </div>
                            </div>
                            <div className='EPCellCol5'>
                                <p>{dateStatusActive}</p>
                            </div>
                            <div className='EPCellCol6'>
                                <button>
                                    {EPInactive && 
                                        <img 
                                        alt=''
                                        onClick={() => this.statusActivitySelected(id, status, filterOptionEndDate, pointsValue, moneyValue, percentageChange)}
                                        src='/assets/earning_policy_inactive.png'/>
                                    }
                                    {EPActive && 
                                        <img 
                                        alt=''
                                        onClick={() => this.statusActivitySelected(id, status, filterOptionEndDate, pointsValue, moneyValue, percentageChange)}
                                        src='/assets/earning_policy_active.png'/>
                                    }
                                </button>
                            </div>
                        </div>
                    )
            }))
        } else {
            return (
                <div className='earningPolicyPlaceholder'>
                    <img src='/assets/earningPolicyPlaceholder4.png'/>
                    <h3>You currently have no earning policies</h3>
                </div>
            )
        }
    }

    makeEarningPolicyPublic = async (id, endDate, pointsValue, moneyValue, percentageChange) => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("earning")
        .doc("parameters")
        .collection("purchase")
        .doc(id)
        .update({
            dateStatusActive: this.formatDateToDDMMYYYY(new Date())
        })

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("points")
        .collection("earningPolicies")
        .doc(id)
        .set({
            id: id, 
            endDate: endDate,
            pointsValue: pointsValue,
            moneyValue: moneyValue,
            percentageChange: percentageChange
        })
    }

    makeEarningPolicyPrivate = async (id) => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("earning")
        .doc("parameters")
        .collection("purchase")
        .doc(id)
        .update({
            dateStatusActive: "(not set)"
        })

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("points")
        .collection("earningPolicies")
        .doc(id)
        .delete()
    }

    statusActivitySelected = (id, status, endDate, pointsValue, moneyValue, percentageChange) => {
        if (status == false) {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("earning")
            .doc("parameters")
            .collection("purchase")
            .doc(id)
            .update({
                status: true
            })
            .then(() => {
                this.makeEarningPolicyPublic(id, endDate, pointsValue, moneyValue, percentageChange)
                this.loadEarningPolicies()
            })
        } else {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("earning")
            .doc("parameters")
            .collection("purchase")
            .doc(id)
            .update({
                status: false
            })
            .then(() => {
                this.makeEarningPolicyPrivate(id)
                this.loadEarningPolicies()
            })
            
        }
    }

    selectedEPClicked = (id, selected) => {
        const { isPopupVisible } = this.state;
        if (selected == false) {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("earning")
            .doc("parameters")
            .collection("purchase")
            .doc(id)
            .update({
                selected: true
            })
            .then(() => {
                if (!isPopupVisible) {
                    this.togglePopup();
                }
                this.setState({
                    selectedEarningPoliciesCount: this.state.selectedEarningPoliciesCount+1,
                })
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("earning")
                .doc("parameters")
                .collection("earningPoliciesDeleting")
                .doc(id)
                .set({
                    policy: id
                })
                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("earning")
                .doc("parameters")
                .update({
                    selectedEarningPoliciesCount: this.state.selectedEarningPoliciesCount+1,
                })
            });
            setTimeout(() => {
                this.fetchSelectedEarningPoliciesIDs()
            }, 900)
        } else {
            fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("points")
            .collection("earning")
            .doc("parameters")
            .collection("purchase")
            .doc(id)
            .update({
                selected: false
            })
            .then(() => {
                this.setState({
                    selectedEarningPoliciesCount: this.state.selectedEarningPoliciesCount !== 0 ? this.state.selectedEarningPoliciesCount-1 : 0 
                })

                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("earning")
                .doc("parameters")
                .collection("earningPoliciesDeleting")
                .doc(id)
                .delete()

                this.setState({
                    selectedEarningPolicyIDs: this.state.selectedEarningPolicyIDs.filter(item => item !== id)
                })

                fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("points")
                .collection("earning")
                .doc("parameters")
                .update({
                    selectedEarningPoliciesCount: this.state.selectedEarningPoliciesCount !== 0 ? this.state.selectedEarningPoliciesCount-1 : 0
                })
            })
        }
    }

    fetchSelectedEarningPoliciesIDs = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("earning")
        .doc("parameters")
        .collection("earningPoliciesDeleting")
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data().policy)
            const filteredArr = data.filter(item => item !== 'placeholder');
            console.log(data)
            this.setState({
                selectedEarningPolicyIDs: filteredArr
            })
        })
    }

    fetchSelectedRewardsIDs = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("rewards")
        .doc("rewardsList")
        .collection("rewardsDeleting")
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data().reward)
            const filteredArr = data.filter(item => item !== 'placeholder');
            // console.log(data)
            this.setState({
                selectedRewardsIDs: filteredArr
            })
        })
    }

    checkForStatusSelectedChange = () => {
        const policyRef = fire.firestore()
        .collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("earning")
        .doc("parameters")
        .collection("purchase")
        policyRef.onSnapshot((snapshot) => {
            const updatedPolicies = this.state.listEarningPolicies.map(policy => {
            const snapshotPolicy = snapshot.docs.find(doc => doc.id === policy.id);
                if (snapshotPolicy) {
                    return {
                    ...policy,
                    status: snapshotPolicy.data().status
                    };
                }
                return policy;
            });
            this.setState({
                listEarningPolicies: updatedPolicies
            });
        });
    }

    checkForEPSelectedChange = () => {
        const policyRef = fire.firestore()
        .collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("earning")
        .doc("parameters")
        .collection("purchase")
        policyRef.onSnapshot((snapshot) => {
            const updatedPolicies = this.state.listEarningPolicies.map(policy => {
            const snapshotPolicy = snapshot.docs.find(doc => doc.id === policy.id);
                if (snapshotPolicy) {
                    return {
                    ...policy,
                    selected: snapshotPolicy.data().selected
                    };
                }
                return policy;
            });
            this.setState({
                listEarningPolicies: updatedPolicies
            });
        });
    }

    checkForRewardSelectedChange = () => {
        const policyRef = fire.firestore()
        .collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("rewards")
        .doc("rewardsList")
        .collection("list")
        policyRef.onSnapshot((snapshot) => {
            const updatedRewards = this.state.rewards.map(reward => {
            const snapshotReward = snapshot.docs.find(doc => doc.id === reward.id);
                if (snapshotReward) {
                    return {
                    ...reward,
                    selected: snapshotReward.data().selected
                    };
                }
                return reward;
            });
            this.setState({
                rewards: updatedRewards
            });
        });
    }

    calculatePercentageChange = (oldRatio, newRatio) => {
        if (oldRatio === 0) {
          // Handle the case where the old ratio is zero to avoid division by zero
          return newRatio === 0 ? 0 : Infinity;
        }
        const percentageChange = ((newRatio - oldRatio) / oldRatio) * 100;
        return percentageChange;
    }

    roundToDecimal = (number, decimalPlaces) => {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(number * factor) / factor;
    }

    formatDateToDDMMYYYY = (date) => {
        const parsedDate = new Date(date);
        if (isNaN(parsedDate)) {
            console.error('Invalid date format. Please provide a valid Date object or a valid date string.');
            return null;
    }

        const day = parsedDate.getDate().toString().padStart(2, '0');
        const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
        const year = parsedDate.getFullYear();

        return `${month}-${day}-${year}`;
    }

    goToAllEarningPolicies = () => {
        if (this.state.currentPage == 1) {
            this.setState({
                prevBtnTxt: "",
            })
        }
        this.loadEarningPolicies()
        this.closeCustomerActionOptions()
        this.setState({
            showEarningEditHeader: false,
            showBaselineValueBtn: false,
            showEarningValueOptions: false,
            showShowAllEarningsHeader: false,
            showSectionLoading2: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showSectionLoading2: false,
                    showBaselineValueBtn: true,
                    showAllEarningPolicies: true,
                    showAllEarningPoliciesTitle: true,
                    showFilterOptionsInProgress: true,
                    showRenderAllEarningPolicies: true
                })
            }, 2500)
        })
    }

    handleNextEarningPolicyPage = () => {
        if (this.state.currentPage == this.state.totalEarningPolicyPages-1) {
            this.setState({
                nextBtnTxt: ""
            })
        }
        const { currentPage } = this.state;
        this.setState({
            currentPage: currentPage + 1,
            prevBtnTxt: "prev",
            showRenderAllEarningPolicies: false,
            showEarningPolicyTableLoading: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showEarningPolicyTableLoading: false,
                    showRenderAllEarningPolicies: true
                })
                this.handleScrollToElement()
            }, 2500)
        })
        setTimeout(() => {
            this.handleScrollToElement()
        }, 3000)
    }

    handleNextRewardsPage = () => {
        if (this.state.currentRewardsPage == this.state.totalRewardsPages-1) {
            this.setState({
                nextBtnTxtRewards: ""
            })
        }
        const { currentRewardsPage } = this.state;
        this.setState({
            currentRewardsPage: currentRewardsPage + 1,
            prevBtnTxtRewards: "prev",
            showRenderRewardsTable: false,
            showRewardsTableLoading: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showRewardsTableLoading: false,
                    showRenderRewardsTable: true
                })
                this.handleScrollToRewardsHeader()
            }, 2500)
        })
        setTimeout(() => {
            this.handleScrollToRewardsHeader()
        }, 3000)
    }
    
    handlePrevEarningPolicyPage = () => {
        if (this.state.currentPage == 2) {
            this.setState({
                prevBtnTxt: ""
            })
        }
        const { currentPage } = this.state;
        if (currentPage > 1) {
            this.setState({
                currentPage: currentPage - 1,
                nextBtnTxt: "next",
                showRenderAllEarningPolicies: false,
                showEarningPolicyTableLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showEarningPolicyTableLoading: false,
                        showRenderAllEarningPolicies: true
                    })
                    this.handleScrollToElement()
                }, 2500)
            })
            setTimeout(() => {
                this.handleScrollToElement()
            }, 3000)
        }
    }

    handlePrevRewardsPage = () => {
        if (this.state.currentRewardsPage == 2) {
            this.setState({
                prevBtnTxtRewards: ""
            })
        }
        const { currentRewardsPage } = this.state;
        if ( currentRewardsPage > 1) {
            this.setState({
                currentRewardsPage: currentRewardsPage - 1,
                nextBtnTxtRewards: "next",
                showRenderRewardsTable: false,
                showRewardsTableLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showRewardsTableLoading: false,
                        showRenderRewardsTable: true
                    })
                    this.handleScrollToRewardsHeader()
                }, 2500)
            })
            setTimeout(() => {
                this.handleScrollToRewardsHeader()
            }, 3000)
        }
    }

    calculateTotalPages = (data) => {
        let itemsPerPage = 10
        let listEarningPolicies = data
        return Math.ceil(listEarningPolicies.length / itemsPerPage);
    }

    handleScrollToElement = () => {
        const element = document.getElementById('topOfEarningPolicyTable');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    handleScrollToRewardsHeader = () => {
        const element = document.getElementById('bottomOfRewardsTable');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    clearPriceDescriptor = () => {
        this.setState({
            priceFilterLabel: "",
            priceFilterComparative: "",
            showPriceDescriptorLabel: false,
            showPriceDescriptorLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showPriceDescriptorLoading: false,
                    showPriceDescriptorLabel: true
                })
            }, 2500)
        })
    }

    clearMealSelected = () => {
        this.setState({
            rewardMenuCategory: "",
            rewardMenuItem: "",
            rewardQuantity: "",
            showMealSelectedLabel: false,
            showMealSelectedLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showMealSelectedLoading: false,
                    showMealSelectedLabel: true
                })
            }, 2500)
        })
    } 

    clearTimeDuration = () => {
        this.setState({
            filterOptionTimeValue: "",
            filterOptionCalendarValue: "",
            filterOptionEndDate: "",
            showTimeDurationLabel: false,
            showTimeDurationLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showTimeDurationLoading: false,
                    showTimeDurationLabel: true
                })
            }, 2500)
        })
    }

    clearMultiplierTimeDuration = () => {
        this.setState({
            multiplierTimeValue: "",
            multiplierCalendarValue: "",
            showTimeDurationLabel: false,
            showTimeDurationLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showTimeDurationLoading: false,
                    showTimeDurationLabel: true
                })
            }, 2500)
        })
    }

    togglePopup = () => {
        this.setState((prevState) => ({
            isPopupVisible: !prevState.isPopupVisible,
        }));
    };

    togglePopup2 = () => {
        this.setState((prevState) => ({
            isPopup2Visible: !prevState.isPopup2Visible,
        }));
    };

    fetchEarningPoliciesSelectedCount = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("earning")
        .doc("parameters")
        .get().then(doc => {
            this.setState({
                selectedEarningPoliciesCount: doc.data().selectedEarningPoliciesCount
            })
        })
    }

    handleDeleteEarningPolicy = () => {
        this.loadEarningPolicies()
        this.fetchEarningPoliciesSelectedCount()
        this.fetchSelectedEarningPoliciesIDs()
        this.setState({
            showRenderAllEarningPolicies: false,
            showEarningPolicyTableLoading: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showEarningPolicyTableLoading: false,
                    showRenderAllEarningPolicies: true
                })
                this.handleScrollToElement()
            }, 2500)
            setTimeout(() => {
                this.setState({
                    isPopupVisible: false
                })
            }, 3000)
        })
    }

    fetchRewardsSelectedCount = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("rewards")
        .doc("rewardsList")
        .get().then(doc => {
            this.setState({
                selectedRewardsCount: doc.data().selectedRewardsCount
            })
        })
    }

    fetchRewardsSelectedCountOnPageLoad = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("points")
        .collection("rewards")
        .doc("rewardsList")
        .get().then(doc => {
            if (doc.data().selectedRewardsCount > 0) {
                this.togglePopup2()
            }
            this.setState({
                selectedRewardsCount: doc.data().selectedRewardsCount
            })
        })
    }

    handleDeleteReward = () => {
        this.getRewards()
        this.fetchRewardsSelectedCount()
        this.fetchSelectedRewardsIDs()
        this.handleScrollToRewardsHeader()
        this.setState({
            showRenderRewardsTable: false,
            showRewardsTableLoading: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showRewardsTableLoading: false,
                    showAddRewardBtn: true,
                    showRenderRewardsTable: true
                })
            }, 2500)
            setTimeout(() => {
                this.setState({
                    isPopup2Visible: false
                })
            }, 3000)
        })
    }

    setLimitReferralBtnClicked = () => {
        if (this.state.setLimitBtnBgColor == "#0930cb") {
            this.setState({
                setLimitBtnBgColor: "white",
                setLimitBtnTxtColor: "#0930cb",
                unlimitedBtnBgColor: "#0930cb",
                unlimitedBtnTxtColor: "white",
                limitedReferralTxt: "Selected",
                unlimitedReferralTxt: "Unlimited",
                showLimitSelectedFilter: true,
                showUnlimitedSelectedFilter: false,
                showSettingReferralLimit: true
            })
        } else {
            this.setState({
                setLimitBtnBgColor: "#0930cb",
                setLimitBtnTxtColor: "white",
                limitedReferralTxt: "Set limit",
                showLimitSelectedFilter: false,
                showSettingReferralLimit: false
            })
        }
    }

    unlimitedReferralBtnClicked = () => {
        if (this.state.unlimitedBtnBgColor == "#0930cb") {
            this.setState({
                unlimitedBtnBgColor: "white",
                unlimitedBtnTxtColor: "#0930cb",
                setLimitBtnBgColor: "#0930cb",
                setLimitBtnTxtColor: "white",
                unlimitedReferralTxt: "Selected",
                limitedReferralTxt: "Set limit",
                showUnlimitedSelectedFilter: true,
                showLimitSelectedFilter: false,
                showSettingReferralLimit: false,
                referralRegistrationLimitValue: ""
            })
        } else {
            this.setState({
                unlimitedBtnBgColor: "#0930cb",
                unlimitedBtnTxtColor: "white",
                unlimitedReferralTxt: "Unlimited",
                showUnlimitedSelectedFilter: false
            })
        }
    }

    removeLastXCharacters = (inputString, x) => {
        return inputString.slice(0, -x);
    }

    extractNumberFromString = (inputString) => {
        const matches = inputString.match(/\d+/);
        if (matches) {
          return parseInt(matches[0], 10); 
        }
        return null;
    }

    hideDataLeavingPointsPage = () => {
        this.setState({
            showPointsComponent: false,
            showPointsComponentOptions: false,

            showLoyaltyHeader: false,
            showLoyaltyPoints: false,
            showEarnPointsDirect: false,
            showPointsDisplayBtn: false,

            showShowAllEarningsHeader: false,
            showEarningValueOptions: false,

            showEarningEditHeader: false,
            showEarningValueFirstScreen: false,
            showBaselineValueBtn: false,
            showEditEarningValue: false, 
            showEarningEditBtn: false,
            // showPointsBtn2Selected: true,
            showEditExpirationHeader: false,
            showEditExpirationLoyalty: false,

            showRewardsHeader: false,
            showAddRewardBtn: false,
            showRewardsTable: false,
            showRenderRewardsTable: false,
        })
    }

    backToHomepageRewards = () => {
        if (this.state.showRewardsBtns === true) {
            this.setState({
                showLoadingRightPanel: true,
                showAllPlans: false,
                showRewardsBtns: false,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        rewardsSidepaneColor: "#000",
                        showExplorePlansBtn: true,
                        showTopDashboards: true,
                        showLoadingRightPanel: false
                    })
                }, 2500)
            })
        } else {
            this.setState({
                showPointsComponent: false,
                showPointsComponentOptions: false,

                showLoyaltyHeader: false,
                showLoyaltyPoints: false,
                showEarnPointsDirect: false,
                showPointsDisplayBtn: false,

                showShowAllEarningsHeader: false,
                showEarningValueOptions: false,

                showEarningEditHeader: false,
                showEarningValueFirstScreen: false,
                showBaselineValueBtn: false,
                showEditEarningValue: false, 
                showEarningEditBtn: false,
                // showPointsBtn2Selected: true,
                showEditExpirationHeader: false,
                showEditExpirationLoyalty: false,

                showRewardsHeader: false,
                showAddRewardBtn: false,
                showRewardsTable: false,
                showRenderRewardsTable: false,

                showLoadingRightPanel: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showLoadingRightPanel: false,
                        showAllPlans: true,
                        showRewardsBtns: true,
                    })
                }, 2500)
            })
        }
        
    }

    backToHomepageAnalytics = () => {
        this.setState({
            showLoadingRightPanel: true,
            showAnalyticsHome: false,
        }, () => {
            setTimeout(() => {
                this.setState({
                    analyticsSidepaneColor: "#000",
                    showExplorePlansBtn: true,
                    showTopDashboards: true,
                    showLoadingRightPanel: false
                })
            }, 2500)
        })
    }

    backToHomepageCampaigns = () => {
        if (this.state.campaignsSecondLevel !== true) {
            this.setState({
                showLoadingRightPanel: true,
                showCampaignsHome: false,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        campaignsSidepaneColor: "#000",
                        showExplorePlansBtn: true,
                        showTopDashboards: true,
                        showLoadingRightPanel: false
                    })
                }, 2500)
            })
        } else {
            this.moveBackInChildComponent()
        }
    }

    backToHomepageMembers = () => {
        this.setState({
            showLoadingRightPanel: true,
            showMembersHome: false,
        }, () => {
            setTimeout(() => {
                this.setState({
                    membersSidepaneColor: "#000",
                    showExplorePlansBtn: true,
                    showTopDashboards: true,
                    showLoadingRightPanel: false
                })
            }, 2500)
        })
    }

    campaignsChildChange = (childValue) => {
        this.state.campaignsSecondLevel = childValue
        this.setState({
            campaignsSecondLevel: childValue
        })
        console.log(this.state.campaignsSecondLevel)
    }

    moveBackInChildComponent = () => {
        if (this.childCampaignRef.current) {
            this.childCampaignRef.current.moveBackToHome();
        }
    }

    logout = async () => {
        await fire.auth().signOut()
        window.location.href = '/'
    }

    render () {
        const { value, suggestions } = this.state;

        // Autosuggest will pass through all these props to the input.
        const inputProps = {
            placeholder: 'Search',
            value,
            onChange: this.onChange
        };

        const options = [
            { value: '1-day', label: 'Today' },
            // { value: '3-days', label: 'Last 3 days' },
            // { value: '5-days', label: 'Last 5 days' },
            { value: '7-days', label: 'Last 7 days' },
            { value: '30-days', label: 'This month' }
        ]

        const options2 = [
            { value: '1-day', label: 'Today' },
            { value: '7-days', label: 'Last 7 days' },
            { value: '1-month', label: 'This month' },
            { value: '3-months', label: 'Last 3 mo.' },
            { value: '6-months', label: 'Last 6 mo.' },
            { value: '1-year', label: 'This year' }
        ]

        const options3 = [
            {value : '1-month', label: '1 month'},
            {value : '2-month', label: '2 months'},
            {value : '3-month', label: '3 months'},
            {value : '4-month', label: '4 months'},
            {value : '5-month', label: '5 months'},
            {value : '6-month', label: '6 months'},
            {value : '7-month', label: '7 months'},
            {value : '8-month', label: '8 months'},
            {value : '9-month', label: '9 months'},
            {value : '10-month', label: '10 months'},
            {value : '11-month', label: '11 months'},
            {value : '12-month', label: '12 months'},
        ]

        const priceFilterOptions = [
            {value: 'greater', label: 'greater than'},
            {value: 'equal', label: 'equal to'},
            {value: 'equal-greater', label: 'equal to OR greater than'},
        ]

        const timeFilterOptions = [
            {value :'1', label: '1'},
            {value :'2', label: '2'},
            {value :'3', label: '3'},
            {value :'4', label: '4'},
            {value :'5', label: '5'},
            {value :'6', label: '6'},
            {value :'7', label: '7'},
            {value :'8', label: '8'},
            {value :'9', label: '9'},
            {value :'10', label: '10'},
            {value :'11', label: '11'},
            {value :'12', label: '12'},
            {value :'13', label: '13'},
            {value :'14', label: '14'},
            {value :'15', label: '15'},
            {value :'16', label: '16'},
            {value :'17', label: '17'},
            {value :'18', label: '18'},
            {value :'19', label: '19'},
            {value :'20', label: '20'},
            {value :'21', label: '21'},
            {value :'22', label: '22'},
            {value :'23', label: '23'},
            {value :'24', label: '24'},
            {value :'25', label: '25'},
            {value :'26', label: '26'},
            {value :'27', label: '27'},
            {value :'28', label: '28'},
            {value :'29', label: '29'},
            {value :'30', label: '30'},
            {value :'31', label: '31'},
        ]

        const dateFilterOptions = [
            {value: 'day', label: 'day(s)'},
            {value: 'week', label: 'week(s)'},
            {value: 'month', label: 'month(s)'},
            // {value: 'year', label: 'year(s)'},
        ]

        const earningValueOptions = [
            {value: 'direct-conversion', label: 'Direct conversion'},
            {value: 'percentage-conversion', label: 'Percentage conversion'},
            // {value: '', label: ''},
        ]

        const defaultValueEarningValueOptions = earningValueOptions

        const options4 = [
            {value: 'percentage-off', label: '(%) Percentage off item'},
            {value: 'amount-off', label: '(KES) Specific amount off item'},
            {value: 'free-item', label: 'Free item'},
            {value: 'custom-reward', label: 'Custom reward'},
        ]

        const options5 = [
            {value: '1', label: '1'},
            {value: '2', label: '2'},
            {value: '3', label: '3'},
            {value: '4', label: '4'},
            {value: '5', label: '5'},
            {value: '6', label: '6'},
            {value: '7', label: '7'},
            {value: '8', label: '8'},
            {value: '9', label: '9'},
            {value: '10', label: '10'},
        ]

        const recentActivityOptions = [
            {value: 'new-members', label: 'New members'},
            {value: 'member-activity', label: 'Member Activity'},
            {value: 'points-redeemed', label: 'Points redeemed'},
            // {value: '', label: ''},
        ]

        const defaultValue = options[0]
        const defaultValue2 = options2[0]
        const defaultValue3 = options3[11]
        const defaultValue4 = options4[0]
        

        const customerActions = [
            {value: 'purchase', label: 'Customer Purchase'},
            {value: 'referral', label: 'Referral Code Sharing'},
            // {value: 'segment', label: 'Customer Segments'},
            // {value: 'calendar', label: 'Calendar Event'},
        ]

            //? - - CUSTOMER SUPPORT - - //

        const filterMessagesMenu = [
            {value: 'tickets', label: 'Tickets'},
            {value: 'date', label: 'Date'},
            {value: 'name', label: 'Name'},
            
        ]

            //? - - MANAGE POINTS - - ?//

        
        
        let pointsExpirationValue 
        if (this.extractNumberFromString(this.state.pointsExpirationValue) > 1) {
            pointsExpirationValue = `Exp: ${this.removeLastXCharacters(this.state.pointsExpirationValue,4)}`
        } else {
            pointsExpirationValue = `Exp: ${this.removeLastXCharacters(this.state.pointsExpirationValue,3)}`
        }

        let pointsSingleInput = {
            border: `2px solid ${this.state.pointsSinglLabelBorderColor}`,
        }

        let pointsSingleInputLabel = {
            fontWeight: "bold",
            color: this.state.pointsSingleLabelColor
        }

        let pointsSingleLabel = {
            fontWeight: "bold",
            color: "#0920CB"
        }

        let pointsPluralInput = {
            border: `2px solid ${this.state.pointsPluralLabelBorderColor}`
        }

        let pointsPluralInputDisplay = {
            backgroundColor: "white",
            // boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.25), 0 6px 20px 0 rgba(0, 0, 0, 0.25)",
            border: "2px solid #0930CB"
        }

        let pointsPluralInputLabel = {
            fontWeight: "bold",
            color: this.state.pointsPluralLabelColor
        }

            // - - POINTS EARNED UI - - //

        let filterOptions1Style = {
            backgroundColor: this.state.filterOptions1BgColor,
            color: this.state.filterOptions1TxtColor,
            border: `2px solid ${this.state.filterOptions1TxtColor}`
        }

        let filterOptions2Style = { 
            backgroundColor: this.state.filterOptions2BgColor,
            color: this.state.filterOptions2TxtColor,
            border: `2px solid ${this.state.filterOptions2TxtColor}`
        }

        let filterOptions3Style = {
            backgroundColor: this.state.filterOptions3BgColor,
            color: this.state.filterOptions3TxtColor,
            border: `2px solid ${this.state.filterOptions3TxtColor}`
        }

        let filterOptions4Style = {
            backgroundColor: this.state.filterOptions4BgColor,
            color: this.state.filterOptions4TxtColor,
            border: `2px solid ${this.state.filterOptions4TxtColor}`
        }

        let filterOptions5Style = {
            backgroundColor: this.state.filterOptions5BgColor,
            color: this.state.filterOptions5TxtColor,
            border: `2px solid ${this.state.filterOptions5TxtColor}`
        }

        let setLimitBtnStyle = {
            backgroundColor: this.state.setLimitBtnBgColor,
            color: this.state.setLimitBtnTxtColor,
            border: `2px solid ${this.state.setLimitBtnTxtColor}`
        }

        let unlimitedBtnStyle = {
            backgroundColor: this.state.unlimitedBtnBgColor,
            color: this.state.unlimitedBtnTxtColor,
            border: `2px solid ${this.state.unlimitedBtnTxtColor}`
        }

        let referralRegistrationInput = {
            border: `2px solid ${this.state.referralRegistrationValueBorderColor}`
        }

        let referralRegistrationLabel = {
            fontWeight: "bold",
            color: this.state.referralRegistrationValueLabelColor
        }

        let referralRegistrationLimitInput = {
            border: `2px solid ${this.state.referralRegistrationLimitBorderColor}`
        }

        let referralRegistrationLimitLabel = {
            fontWeight: "bold",
            color: this.state.referralRegistrationLimitLabelColor
        }

        let pointsEarnedValueInput = {
            border: `2px solid ${this.state.pointsEarnedValueBorderColor}`
        }

        let pointsEarnedPercentageValueInput = {
            border: `2px solid ${this.state.pointsEarnedPercentageValueBorderColor}`
        }

        let pointsEarnedValueLabel = {
            fontWeight: "bold",
            color: this.state.pointsEarnedValueLabelColor
        }

        let pointsEarnedPercentageValueLabel = {
            fontWeight: "bold",
            color: this.state.pointsEarnedPercentageValueLabelColor
        }

        let pointsMoneyValueInput = {
            border: `2px solid ${this.state.pointsMoneyValueBorderColor}`
        }

        let pointsMoneyValueInput2 = {
            border: `2px solid black`,
            marginTop: "2.5%"
        }

        let pointsMoneyValueLabel = {
            fontWeight: "bold",
            color: this.state.pointsMoneyValueLabelColor
        }

        let pointsMoneyValueLabel2 = {
            fontWeight: "bold",
            color: "#0930CB"
        }
    
        let pointsExpirationDropdown = {
            boxShadow: `0 4px 8px 0 rgba(${this.state.pointsExpirationBoxShadowColor}), 0 6px 20px 0 rgba(${this.state.pointsExpirationBoxShadowColor})`,
            borderRadius: "7px" 
        }

        let filterOptionPricingInput = {
            paddingTop: "1.25%",
            border: `2px solid ${this.state.filterOptionPricingBorderColor}`
        }

        let andFilterBtnStyle = {
            backgroundColor: this.state.andFilterBtnBgColor,
            color: this.state.andFilterBtnTxtColor,
            border: `2px solid ${this.state.andFilterBtnBorderColor}`
        }

        let orFilterBtnStyle = {
            backgroundColor: this.state.orFilterBtnBgColor,
            color: this.state.orFilterBtnTxtColor,
            border: `2px solid ${this.state.orFilterBtnBorderColor}`
        }

        let filterOptionFrequencyInput = {
            border: `2px solid ${this.state.filterOptionFrequencyBorderColor}`
        }

        let priceFilterDropdown = {
            boxShadow: `0 4px 8px 0 rgba(${this.state.priceFilterBoxShadowColor}), 0 6px 20px 0 rgba(${this.state.priceFilterBoxShadowColor})`,
            borderRadius: "7px"
        }

        let mealCategoryDropdown = {
            boxShadow: `0 4px 8px 0 rgba(${this.state.mealCategoryBoxShadowColor}), 0 6px 20px 0 rgba(${this.state.mealCategoryBoxShadowColor})`,
            borderRadius: "7px"
        }

        let mealSelectedDropdown = {
            boxShadow: `0 4px 8px 0 rgba(${this.state.mealSelectedFilterBoxShadowColor}), 0 6px 20px 0 rgba(${this.state.mealSelectedBoxShadowColor})`,
            borderRadius: "7px"
        }

        let mealQuantityDropdown = {
            boxShadow: `0 4px 8px 0 rgba(${this.state.mealQuantityBoxShadowColor}), 0 6px 20px 0 rgba(${this.state.mealQuantityBoxShadowColor})`,
            borderRadius: "7px"
        }

            //! - - END OF REWARDS EARNING FILTER OPTIONS - - !//

            //? - - START OF REWARDS - - ?//

        let redeemPointsCategories = {
            border: `2px solid transparent`
        }

        let pointsRewardValueInput = {
            border: `2px solid ${this.state.pointsRewardValueBorderColor}`
        }

        let pointsRewardValueLabel = {
            fontWeight: "bold",
            color: this.state.pointsRewardValueLabelColor
        }

        let percentageOffValueInput = {
            border: `2px solid ${this.state.percentageOffValueBorderColor}`
        }

        let percentageOffValueLabel = {
            fontWeight: "bold",
            color: this.state.percentageOffValueLabelColor
        }

        let moneyOffValueInput = {
            border: `2px solid ${this.state.moneyOffValueBorderColor}`
        }

        let moneyOffValueLabel = {
            fontWeight: "bold",
            color: this.state.moneyOffValueLabelColor
        }

        let customRewardInput = {
            border: `2px solid ${this.state.customRewardBorderColor}`
        }

        let pointsValueDisplay = {
            color: "#000"
        }

        let rewardExpirationDateInput = {
            border: `2px solid ${this.state.rewardExpirationValueBorderColor}`
        }

        let rewardExpirationValueLabel = {
            fontWeight: "bold",
            color: this.state.rewardExpirationValueLabelColor
        }

        let pointsEditSaveBtn = {

        }

        let finishAppliedFilterBtn = {
            marginTop: "5.5%",
            border: "2px solid #0930cb"
        }

        let backFilterOptionsBtn2 = {
            marginTop: "0.5%",
            backgroundColor: "white",
            color: "#0930cb",
            border: "2px solid #0930cb",
            marginBottom: "2%",
            padding: "0.75%",
            width: "5%"
        }

        let backFilterOptionsBtn = {
            marginTop: "1.5%",
            border: "2px solid #0930cb",
        }

        let pointsDisplaySaveBtn = {
            backgroundColor: "white",
            border: "2px solid #0930CB",
            color: "#0930CB"
        }

        let h4StyleFiller = {
            color: "transparent"
        }

            //* - - SIDEPANE - - *//

        let trialModeSidepane = {
            color: this.state.trialModeSidepaneColor
        }

        let rewardsSidepane = {
            color: this.state.rewardsSidepaneColor
        }

        let analyticsSidepane = {
            color: this.state.analyticsSidepaneColor
        }

        let campaignsSidepane = {
            color: this.state.campaignsSidepaneColor
        }

        let membersSidepane = {
            color: this.state.membersSidepaneColor
        }

        let customerSupportSidepane = {
            color: this.state.customerSupportSidepaneColor
        }

            //* - - QUICK BUTTONS - - *//

        let quickBtn1Style = {
            backgroundColor: this.state.quickBtn1BgColor,
            color: this.state.quickBtn1TxtColor
        }

        let quickBtn2Style = {
            backgroundColor: this.state.quickBtn2BgColor,
            color: this.state.quickBtn2TxtColor
        }

        let quickBtn3Style = {
            backgroundColor: this.state.quickBtn3BgColor,
            color: this.state.quickBtn3TxtColor
        }

            //* - - POINTS OPTIONS BUTTONS - - //

        let pointsOptionsBtn1UnselectedStyle = {
            backgroundColor: this.state.pointsBtn1UnselectedBgColor,
            color: this.state.pointsBtn1UnselectedTxtColor,
            border: `2px solid ${this.state.pointsBtn1UnselectedBorderColor}`,
            cursor: "pointer"
        }

        let pointsOptionsBtn1SelectedStyle = {
            backgroundColor: this.state.pointsBtn1SelectedBgColor,
            color: this.state.pointsBtn1SelectedTxtColor,
            border: `2px solid ${this.state.pointsBtn1SelectedBorderColor}`,
            cursor: "pointer"
        }

        let pointsOptionsBtn2UnselectedStyle = {
            backgroundColor: this.state.pointsBtn2UnselectedBgColor,
            color: this.state.pointsBtn2UnselectedTxtColor,
            border: `2px solid ${this.state.pointsBtn2UnselectedBorderColor}`,
            cursor: "pointer"
        }

        let pointsOptionsBtn2SelectedStyle = {
            backgroundColor: this.state.pointsBtn2SelectedBgColor,
            color: this.state.pointsBtn2SelectedTxtColor,
            border: `2px solid ${this.state.pointsBtn2SelectedBorderColor}`,
            cursor: "pointer"
        }

        let pointsOptionsBtn3UnselectedStyle = {
            backgroundColor: this.state.pointsBtn3UnselectedBgColor,
            color: this.state.pointsBtn3SelectedTxtColor,
            border: `2px solid ${this.state.pointsBtn3UnselectedBorderColor}`,
            cursor: "pointer"
        }

        let pointsOptionsBtn3SelectedStyle = {
            backgroundColor: this.state.pointsBtn3SelectedBgColor,
            color: this.state.pointsBtn3SelectedTxtColor,
            border: `2px solid ${this.state.pointsBtn3SelectedBorderColor}`,
            cursor: "pointer"
        }

        return (
            <Styles>
                <div className='header'>
                    <div className='headerCol1'>
                        <div className='sideBarCategories'>
                            <div className='sidebarInvisibleContainer'>
                                {/* <h1>hey</h1> */}
                            </div>
                            {/* <div className='sideBarLogo'>
                                <img src='./assets/testing2-icon-sidepane.png'/>
                            </div>
                            <div className='sideBarLabel'>
                                <h3 style={trialModeSidepane}>Testing</h3>
                            </div> */}
                            <div className='sideBarLogo'>
                                <img src='./assets/gift-icon-sidepane2.png'/>
                            </div>
                            <div onClick={this.rewardsSidepaneClicked} className='sideBarLabel'>
                                <h3 style={rewardsSidepane}>Rewards</h3>
                            </div>
                            <div className='sideBarLogo'>
                                <img src='./assets/analytics-icon-sidepane2.png'/>
                            </div>
                            <div onClick={this.analyticsSidepaneClicked} className='sideBarLabel'>
                                <h3 style={analyticsSidepane}>Analytics</h3>
                            </div>
                            <div className='sideBarLogo'>
                                <img src='./assets/dashboard2-icon-sidepane.png'/>
                            </div>
                            <div onClick={this.campaignsSidepaneClicked} className='sideBarLabel'>
                                <h3 style={campaignsSidepane} >Campaigns</h3>
                            </div>
                            <div className='sideBarLogo'>
                                <img src='./assets/member2-icon-sidepane.png'/>
                            </div>
                            <div onClick={this.membersSidepaneClicked} className='sideBarLabel'>
                                <h3 style={membersSidepane}>Members</h3>
                            </div>
                            {/* <div className='sideBarLogo'>
                                <img src='./assets/support5-icon-sidepane.png'/>
                            </div>
                            <div onClick={this.customerSupportSidepaneClicked} className='sideBarLabel'>
                                <h3 style={customerSupportSidepane}>Support </h3>
                            </div> */}
                        </div>
                        <div className='sidepaneFooter'>
                            <div>
                                <button
                                onClick={this.logout}
                                >Logoout</button>
                            </div>
                            <p>© kifaa</p>
                        </div>
                    </div>
                    <div className='headerCol2'>
                        <div className='topBanner'>
                            <div className='topLeftCol'>
                                {this.state.showHomepageSearchBar && 
                                    <div>
                                        <Autosuggest
                                        suggestions={suggestions}
                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                        onSuggestionSelected={this.suggestionSelected}
                                        getSuggestionValue={getSuggestionValue}
                                        renderSuggestion={renderSuggestion}
                                        inputProps={inputProps}
                                        />
                                        <div className='searchBarOptions' style={{display: "flex", flexDirection: "row"}}>
                                            <p style={{marginLeft: "0.5%", fontFamily: "sora", color: "#0930cb", marginTop: "1.25%", marginBottom: "0px", fontSize: "87.5%", fontWeight: "bold"}}>↳ Searching: </p>
                                            {this.state.showSearchRewards && 
                                                <button
                                                >Rewards</button>
                                            }
                                            {this.state.showSearchAnalytics && 
                                                <button
                                                >Analytics</button>
                                            }
                                            {this.state.showSearchCampaigns && 
                                                <button
                                                >Campaigns</button>
                                            }
                                            {this.state.showSearchMembers && 
                                                <button
                                                >Members</button>
                                            }
                                        </div>
                                    </div>
                                }
                                {this.state.showMembersSearchBar && 
                                    <div style={{marginTop: "3.25%", width: "90%", height: "auto", border: ""}}>
                                        <SearchBox
                                        placeholder='Search'
                                
                                        />
                                    </div>
                                }
                            </div>
                            <div className='topRightCol'>
                                <button
                                style={{marginLeft: "5%"}}
                                >Search</button>
                            </div>
                        </div>
                        {this.state.showLoader && 
                            <div className='spinner'>
                                <LoadingProgress
                                useSpinner
                                active={true}
                                total={this.state.total}
                                current={this.state.current}
                                visualOnly={true}
                                />
                            </div>
                        }
                        {this.state.isPopupVisible && <Popup onChildDelete={this.handleDeleteEarningPolicy} selectedPoliciesDeleting={this.state.selectedEarningPolicyIDs} selectedPolicyCount={this.state.selectedEarningPoliciesCount} togglePopup={this.togglePopup} />}
                        {this.state.isPopup2Visible && <PopupRewards onChildDelete={this.handleDeleteReward} selectedRewardsDeleting={this.state.selectedRewardsIDs} selectedRewardsCount={this.state.selectedRewardsCount} togglePopup={this.togglePopup2} />}
                        <div className='contentContainer'>
                            {this.state.showTopDashboards && 
                                <div className='allPostsContainer'>
                                    <h1>Karibu!</h1>
                                    <div className='topDashboard'>
                                        <div className='topDashCol'>
                                            <div className='topDashCard'>
                                                <div className='dashImg'>
                                                    <div className='imgContainer'>
                                                        <img src='/assets/member2.png'/>
                                                    </div>
                                                </div>
                                                <div className='dashLabel'>
                                                    <h2>Total Members</h2>
                                                </div>
                                                <div className='dashboardFigure'>
                                                    <h1>{this.state.totalMembers}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='topDashCol'>
                                            <div className='topDashCard'>
                                                <div className='dashImg'>
                                                    <div className='imgContainer'>
                                                        <img src='/assets/plans.png'/>
                                                    </div>
                                                </div>
                                                <div className='dashLabel'>
                                                    <h2 className='activeMemberStyle' style={{marginBottom: "1.5%"}}>Active Members</h2>
                                                    <Select 
                                                    defaultValue={defaultValue}
                                                    onChange={this.handleActiveMembersChanged}
                                                    className='selectMenu2' 
                                                    options={options}/>
                                                </div>
                                                {this.state.showActiveMembersFigure && 
                                                    <div className='dashboardFigure'>
                                                    <h1>{this.state.activeMembers}</h1>
                                                </div>
                                                }
                                                {this.state.showActiveMembersFigureLoading && 
                                                    <div style={{paddingTop: "20.5%", marginTop: "2.75%"}}>
                                                        <ClipLoader
                                                        color="#0930cb"
                                                        loading={true}
                                                        // cssOverride={override}
                                                        size={20}
                                                        aria-label="Loading Spinner"
                                                        data-testid="loader"
                                                        />
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className='topDashCol'>
                                            <div className='topDashCard'>
                                                <div className='dashImg'>
                                                    <div className='imgContainer'>
                                                        <img src='/assets/revenue.png'/>
                                                    </div>
                                                </div>
                                                <div className='dashLabel'>
                                                    <h2 className='activeMemberStyle' style={{marginBottom: "1.5%"}}>Total Revenue</h2>
                                                    <Select 
                                                    defaultValue={defaultValue2}
                                                    onChange={this.handleTotalRevenueChanged}
                                                    className='selectMenu2' 
                                                    options={options2}/>
                                                </div>
                                                {this.state.showTotalRevenueFigure && 
                                                    <div className='dashboardFigure'>
                                                        <h1>KES {this.state.totalRevenue}</h1>
                                                    </div>
                                                }
                                                {this.state.showTotalRevenueFigureLoading && 
                                                    <div style={{paddingTop: "20.5%", marginTop: "2.75%"}}>
                                                        <ClipLoader
                                                        color="#0930cb"
                                                        loading={true}
                                                        // cssOverride={override}
                                                        size={20}
                                                        aria-label="Loading Spinner"
                                                        data-testid="loader"
                                                        />
                                                    </div>
                                                }
                                                
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div style={{borderBottom: "1px solid #0930cb", width: "97.5%", paddingBottom: "2.5%", marginBottom: "1.5%", paddingTop: "1%"}}></div> */}
                                    <div className='moreDataPoints'>
                                        <p style={{fontFamily: "sora", fontWeight: "bold"}}><label
                                        onClick={this.analyticsSidepaneClicked}
                                        >view more data points</label></p>
                                    </div>
                                    {this.state.showExplorePlansBtn && 
                                        <div>
                                            <div className='middleHomepage'>
                                                <div className='middleHomepageLeft'>
                                                    <div className='explorePlansBtn'>
                                                        <button
                                                        onClick={this.membersSidepaneClicked}
                                                        >Search Members</button>
                                                    </div>
                                                    <div className='explorePlansBtn'>
                                                        <button
                                                        onClick={this.rewardsSidepaneClicked}
                                                        >Explore Rewards Plans</button>
                                                    </div>
                                                    <div className='homeQuickBtnsContainer'>
                                                        <div className='homeQuickBtn'>
                                                            <div 
                                                            onClick={this.analyticsSidepaneClicked}
                                                            onMouseEnter={this.handleQuickBtn1MouseEnter}
                                                            onMouseLeave={this.handleQuickBtn1MouseLeave}
                                                            style={quickBtn1Style} className='quickBtn'>
                                                                <h1>📊</h1>
                                                                <h3>Analytics</h3>
                                                            </div>
                                                        </div>
                                                        <div className='homeQuickBtn'>
                                                            <div
                                                            onClick={this.campaignsSidepaneClicked}
                                                            onMouseEnter={this.handleQuickBtn2MouseEnter}
                                                            onMouseLeave={this.handleQuickBtn2MouseLeave}
                                                            style={quickBtn2Style} className='quickBtn'>
                                                                <h1>🎨</h1>
                                                                <h3>Campaigns</h3>
                                                            </div>
                                                        </div>
                                                        <div className='homeQuickBtn'>
                                                            <div 
                                                            onClick={this.rewardsSidepaneClicked}
                                                            onMouseEnter={this.handleQuickBtn3MouseEnter}
                                                            onMouseLeave={this.handleQuickBtn3MouseLeave}
                                                            style={quickBtn3Style} className='quickBtn'>
                                                                <h1>🎉</h1>
                                                                <h3>Rewards</h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='middleHomepageRight'>
                                                    <div className='recentActivityHomepage'>
                                                        <div className='recentActivityHomepageContainer'>
                                                            <div className='recentActivityHeading'>
                                                                <h2 style={{marginLeft: "2%", color: "white"}}>Notifications (2)</h2>
                                                            </div>
                                                            <div className='recentActivityOptions'>
                                                            {/* <Select 
                                                            placeholder="Select"
                                                            // defaultValue={defaultValue}
                                                            className='selectMenu3' 
                                                            options={recentActivityOptions}/> */}
                                                            </div>
                                                        </div>
                                                        <div className='recentActivityData'>
                                                            <div className='newNotificationsLabel'>New Notifications</div>
                                                            {this.renderHomepageRecentActivity()}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {/* <div className='postContainer'>
                                        <div className='postContainerTopBanner'>
                                            <p>Anonymous</p>
                                        </div>
                                        <div className='postContainerContentArea'>
                                            <textarea/>
                                        </div>
                                    </div> */}
                                </div>
                            }
                            {this.state.showAllPlans && 
                                <div className='rewardsBtnContainer'>
                                    <div className='rewardsHeader' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <h1 style={{marginTop: "0.5%", marginBottom: "0px"}}>Rewards Plans</h1>
                                        <button 
                                        onClick={this.backToHomepageRewards}
                                        style={{marginRight: "3%", marginTop: "0px", marginBottom: "1%"}}
                                        ><strong>⬅︎</strong></button>
                                    </div>
                                    {this.state.showRewardsBtns && 
                                        <div className='rewardsInnerContainer'>
                                            <div className='rewardsBtn'>
                                                <button
                                                onClick={this.pointsClicked}
                                                >Points</button>
                                            </div>
                                            <div className='rewardsBtn'>
                                                <button>Tiers <label className='rewardsBtnInnerTag'>(coming soon)</label></button>
                                            </div>
                                            <div className='rewardsBtn'>
                                                <button>Vouchers <label className='rewardsBtnInnerTag'>(coming soon)</label></button>
                                            </div>
                                        </div>
                                    }
                                    
                                </div>
                            }
                            {this.state.showLoadingRightPanel && 
                                <div className='loadingScreenRightPanel'>
                                    <ClipLoader
                                    color="#0930CB"
                                    loading={true}
                                    // cssOverride={override}
                                    size={30}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                    />
                                </div>
                            }
                            {this.state.showPointsComponent && 
                                <div className='pointsContainer'>
                                    <div className='pointsHeader'>
                                        {/* <div className='pointsHeaderCol1'>
                                            <img src='/assets/rewardsSubArrow.png'/>
                                        </div> */}
                                        <div className='pointsHeaderCol2'>
                                            <label>↳ Points</label>
                                        </div>
                                    </div>
                                    {this.state.showPointsComponentOptions &&
                                        <div className='pointsComponentOptions'>
                                            {this.state.showPointsBtn1Unselected && 
                                                <div className='pointsComponentOptionsBtn'>
                                                    <div style={pointsOptionsBtn1UnselectedStyle} className='pointsComponentBtnContainer'>
                                                        <div className='pointsComponentBtnImg'>
                                                            <img src='/assets/points-options2.png'/>
                                                        </div>
                                                        <div className='pointsComponentBtnLabel'>
                                                            <p>Earning</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.showPointsBtn1Selected && 
                                                <div className='pointsComponentOptionsBtn'>
                                                    <div style={pointsOptionsBtn1SelectedStyle} className='pointsComponentBtnContainer'>
                                                        <div className='pointsComponentBtnImg'>
                                                            <img src='/assets/points-options2.png'/>
                                                        </div>
                                                        <div className='pointsComponentBtnLabel'>
                                                            <p>Earning</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.showPointsBtn2Unselected && 
                                                <div className='pointsComponentOptionsBtn'>
                                                    <div style={pointsOptionsBtn2UnselectedStyle} className='pointsComponentBtnContainer'>
                                                        <div className='pointsComponentBtnImg'>
                                                            <img src='/assets/settings-options3.png'/>
                                                        </div>
                                                        <div className='pointsComponentBtnLabel'>
                                                            <p>Settings</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {this.state.showPointsBtn2Selected && 
                                                <div className='pointsComponentOptionsBtn'>
                                                    <div style={pointsOptionsBtn2SelectedStyle} className='pointsComponentBtnContainer'>
                                                        <div className='pointsComponentBtnImg'>
                                                            <img src='/assets/settings-options-selected.png'/>
                                                        </div>
                                                        <div className='pointsComponentBtnLabel'>
                                                            <p>Settings</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {/* {this.state.showPointsBtn3Unselected && 
                                                <div className='pointsComponentOptionsBtn'>
                                                    <div style={pointsOptionsBtn3UnselectedStyle} className='pointsComponentBtnContainer'>
                                                        <div className='pointsComponentBtnImg'>
                                                            <img src='/assets/rewards-options3.png'/>
                                                        </div>
                                                        <div className='pointsComponentBtnLabel'>
                                                            <p>Rewards</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            } */}
                                            {/* {this.state.showPointsBtn3Selected && 
                                                <div className='pointsComponentOptionsBtn'>
                                                    <div style={pointsOptionsBtn3SelectedStyle} className='pointsComponentBtnContainer'>
                                                        <div className='pointsComponentBtnImg'>
                                                            <img src='/assets/rewards-options3.png'/>
                                                        </div>
                                                        <div className='pointsComponentBtnLabel'>
                                                            <p>Rewards</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            } */}
                                        </div>
                                    }
                                    <div className='pointsContent'>
                                        {this.state.showSectionLoading && 
                                            <div className='pointsSectionLoading'>
                                                <ClipLoader
                                                    color="#0930CB"
                                                    loading={true}
                                                    // cssOverride={override}
                                                    size={30}
                                                    aria-label="Loading Spinner"
                                                    data-testid="loader"
                                                />
                                            </div>
                                        }
                                        {this.state.showLoyaltyEditHeader && 
                                            <div>
                                                <h2 style={{fontFamily: "rubik", fontWeight: "bold", fontSize: "29px", marginBottom: "0px", paddingTop: "2.5%", marginLeft: "2.5%"}}>Brand Loyalty Points</h2>
                                                <h3 style={{marginTop: "1%", paddingTop: "0px"}}>Define your brand's personalized loyalty points</h3>
                                            </div>
                                            
                                        }
                                        {this.state.showLoyaltyHeader && 
                                            <div>
                                                <h2 style={{fontFamily: "rubik", fontWeight: "bold", fontSize: "29px", marginBottom: "0px", paddingTop: "2.5%", marginLeft: "2.5%"}}>Brand Loyalty Points</h2>
                                                <h3 style={{marginTop: "1%", paddingTop: "0px"}}><label className='editHeader'>Your brand's loyalty points</label></h3>
                                            </div>
                                            
                                        }
                                        {this.state.showEditLoyaltyPoints && 
                                            <div className='pointsSystem'>
                                                <div className='pointsSystemCol'>
                                                    <h4>Give your loyalty points a custom name that suits your brand</h4>
                                                    <div onClick={this.handleSinglePointsClicked} style={pointsSingleInput} className='pointsInput'>
                                                        <p style={pointsSingleInputLabel}>Singular (e.g. Point, Credit, Star, Aloha)</p>
                                                        <input
                                                        id='pointsSingleValue'
                                                        placeholder='Point'
                                                        value={this.state.pointsSingleValue}
                                                        onChange={this.handleChange}
                                                        onClick={this.handleSinglePointsClicked}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='pointsSystemCol'>
                                                    <h4 style={h4StyleFiller}> v</h4>
                                                    <div onClick={this.handlePluralPointsClicked} style={pointsPluralInput} className='pointsInput'>
                                                        <p style={pointsPluralInputLabel}>Plural (e.g. Points, Credits, Stars, Alohas)</p>
                                                        <input
                                                        id='pointsPluralValue'
                                                        placeholder='Points'
                                                        value={this.state.pointsPluralValue}
                                                        onChange={this.handleChange}
                                                        onClick={this.handlePluralPointsClicked}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showLoyaltyPoints && 
                                            <div className='pointsSystem'>
                                                <div className='pointsSystemCol'>
                                                    <div style={pointsPluralInputDisplay} className='pointsInput'>
                                                        <p style={pointsSingleLabel}>Singular (e.g. Point, Credit, Star, Aloha)</p>
                                                        <h3 style={pointsValueDisplay}>{this.state.pointsSingleValue}</h3>
                                                    </div>
                                                </div>
                                                <div className='pointsSystemCol'>
                                                    <div style={pointsPluralInputDisplay} className='pointsInput'>
                                                        <p style={pointsSingleLabel}>Plural (e.g. Points, Credits, Stars, Alohas)</p>
                                                        <h3 style={pointsValueDisplay}>{this.state.pointsPluralValue}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showPointsEditBtn && 
                                            <div className='pointsSaveBtn'>
                                                <button
                                                onClick={this.saveLoyaltyPoints}
                                                style={pointsEditSaveBtn}
                                                >Save</button>
                                            </div>
                                        }
                                        {this.state.showPointsDisplayBtn && 
                                            <div className='pointsSaveBtn'>
                                                <button
                                                onClick={this.editLoyaltyPoints}
                                                style={pointsDisplaySaveBtn}
                                                >Edit</button>
                                            </div>
                                        }
                                        <div className='pointsFormSeparator'></div>
                                        {this.state.showSectionLoading2 && 
                                            <div className='pointsSectionLoading2'>
                                                <ClipLoader
                                                    color="#0930CB"
                                                    loading={true}
                                                    // cssOverride={override}
                                                    size={30}
                                                    aria-label="Loading Spinner"
                                                    data-testid="loader"
                                                />
                                            </div>
                                        }
                                        {this.state.showEarningEditHeader &&  
                                            <div>
                                                <h2 style={{fontFamily: "rubik", fontWeight: "bold", fontSize: "29px", marginBottom: "0px", marginTop: "1%", paddingTop: "1.5%", marginLeft: "2.5%"}}>Points Earning Value</h2>
                                                <h3 style={{marginTop: "1%", paddingTop: "0px"}} id='topOfEarningPolicyTable' >Define how your customers earn points</h3>
                                            </div>
                                        }
                                        {this.state.showAllEarningPoliciesTitle && 
                                            <div>
                                                <h2 style={{fontFamily: "rubik", fontWeight: "bold", fontSize: "29px", marginBottom: "0px", marginTop: "1%", paddingTop: "1.5%", marginLeft: "2.5%"}}>Points Earning Value</h2>
                                                <h3 style={{marginTop: "1%", paddingTop: "0px"}} id='topOfEarningPolicyTable' >Your Earning Policies</h3>
                                            </div>
                                       }
                                        {this.state.showFilterOptionsInProgress && 
                                            <div className='pointsSystem'>
                                                {/* <h3>Conditions</h3> */}
                                                <div className='pointsSaveBtn'>
                                                    <button
                                                    onClick={this.backToSelectFilterOptions}
                                                    style={backFilterOptionsBtn2}
                                                    >⬅︎</button>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showFilterOptionsInProgressFinal && 
                                            <div className='pointsSystem'>
                                                {/* <h3>Conditions</h3> */}
                                                <div className='pointsSaveBtn'>
                                                    <button
                                                    onClick={this.backToFilterInputOptions}
                                                    style={backFilterOptionsBtn2}
                                                    >⬅︎</button>
                                                </div>
                                            </div>
                                        }
                                        {/* {this.state.showEarningValueFirstScreen && 
                                            <div className='earningValueFirstScreen'>
                                                <h2>Start with a baseline earning value - you can add more customization later on </h2>
                                                <div>
                                                    
                                                </div>
                                            </div>
                                        } */}
                                        {this.state.showBaselineValueBtn && 
                                            <div className='earningValueFirstScreen'>
                                                {this.state.showBaselineIntroMessage && 
                                                    <div>
                                                        <div className='baselineValueAlert'>
                                                            <div className='baselineValueMsg'>
                                                                <p>{this.state.baselineValueMsg}</p>
                                                            </div>
                                                            <div className='baselineValueClose'>
                                                                <button
                                                                onClick={this.closeBaselineNotification}
                                                                ><img src='assets/exit-baseline-alert.png'/></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.state.showEarningErrorMsgRewardsConflict && 
                                                    <div className='rewardsErrorMsg'>
                                                        <div className='baselineValueAlert'>
                                                            <div className='baselineValueMsg'>
                                                                <p>{this.state.baselineValueMsg2}</p>
                                                            </div>
                                                            <div className='baselineValueClose'>
                                                                <button
                                                                onClick={this.closeEarningPolicyWarning}
                                                                ><img src='assets/exit-baseline-alert.png'/></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='customerBaselineValues'>
                                                    <div className='baselineValueCol1'>
                                                        <button
                                                        // onClick={this.goToEditBaselineValue}
                                                        >Baseline Value</button>
                                                        <div className='appliedFilterResult'>
                                                            <p>↳ {this.state.savedPointsValue}pts → KES{this.state.savedMoneyValue}<label>[{pointsExpirationValue}]</label></p>
                                                            {/* <p>↳ Exp. </p> */}
                                                        </div>
                                                    </div>
                                                    <div className='baselineValueCol2'>
                                                        <button
                                                        // onClick={this.goToEditBaselineValue}
                                                        >Referral Value</button>
                                                        <div className='appliedFilterResult'>
                                                            <p>↳ {this.state.savedReferralRegistrationValue} R(s) → {this.state.savedReferralRegistrationPointsValue}pts <label>[Limit: {this.state.savedReferralRegistrationLimitValue}]</label></p>
                                                            {/* <p>↳ Exp. </p> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showEarningValueOptions && 
                                            <div className='pointsSystem'>
                                                <div className='pointsSystemCol'>
                                                    <h4>Select an earning criteria:</h4>
                                                    <Select 
                                                    placeholder='Select action'
                                                    className='selectMenu4' 
                                                    options={customerActions}
                                                    onChange={this.customerActionSelected}
                                                    />
                                                    {this.state.showCustomerActionExitBtn && 
                                                        <div className='exitCustomerActionBtn'>
                                                            <button>
                                                                <img 
                                                                alt=''
                                                                onClick={this.closeCustomerActionOptions}
                                                                src='assets/exit-baseline-alert.png'/>
                                                            </button>
                                                        </div>
                                                    }
                                                    {this.state.showCustomerActionLoading && 
                                                        <div className='pointsSectionLoading5'>
                                                            <ClipLoader
                                                                color="#0930CB"
                                                                loading={true}
                                                                // cssOverride={override}
                                                                size={25}
                                                                aria-label="Loading Spinner"
                                                                data-testid="loader"
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                                <div className='pointsSystemCol2'>

                                                </div>
                                            </div>
                                        }
                                        
                                        {this.state.showEarningHeader && 
                                            <h3>Your loyalty points earning value</h3>
                                        }
                                        {this.state.showEarningValuePurchaseOptions && 
                                            <div className='pointsSystem'>
                                                <div className='pointsSystemCol'>
                                                    <h4>Customize by</h4>
                                                    <div></div>
                                                    {this.state.showSelectedNoneFilter && 
                                                        <span className='filter1SelectedDisplay'>
                                                            <button
                                                            >None <label>✅</label></button>
                                                        </span>
                                                    }
                                                    {this.state.showSelectedPriceFilter && 
                                                        <span className='filter2SelectedDisplay'>
                                                            <button
                                                            >Price<label>✅</label></button>
                                                        </span>
                                                    }
                                                    {this.state.showSelectedMealFilter && 
                                                        <span className='filter3SelectedDisplay'>
                                                            <button
                                                            >Meal <label>✅</label></button>
                                                        </span>
                                                    }
                                                    <div className='filterOptions'>
                                                        <div className='filterOptionsCol1'>
                                                            <button
                                                            onClick={this.filterOption1Clicked}
                                                            style={filterOptions1Style}
                                                            >{this.state.filterOptionBtn1}</button>
                                                        </div>
                                                        <div className='filterOptionsCol2'>
                                                            <button
                                                            onClick={this.filterOption2Clicked}
                                                            style={filterOptions2Style}
                                                            >{this.state.filterOptionBtn2}</button>
                                                        </div>
                                                        {/* <div>
                                                            <button
                                                            onClick={this.filterOption3Clicked}
                                                            style={filterOptions3Style}
                                                            >Frequency</button>
                                                        </div> */}
                                                        {/* <div>
                                                            <button
                                                            onClick={this.filterOption4Clicked}
                                                            style={filterOptions4Style}
                                                            >Meal Category</button>
                                                        </div> */}
                                                        <div className='filterOptionsCol3'>
                                                            <button
                                                            onClick={this.filterOption5Clicked}
                                                            style={filterOptions5Style}
                                                            >{this.state.filterOptionBtn3}</button>
                                                        </div>
                                                        <div className='filterOptionsContinueBtn'>
                                                            <button
                                                            onClick={this.filterOptionsContinueClicked}
                                                            >Continue</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className='pointsSystemCol2'>

                                                </div> */}
                                            </div>
                                        }
                                        {this.state.showEarningValueReferralOptions && 
                                            <div className='pointsSystem'>
                                                <div className='pointsSystemCol'>
                                                    <h4>Set a MAXIMUM number of referral-based registrations that a loyatly customer can use to earn points.</h4>
                                                    {this.state.showLimitSelectedFilter && 
                                                        <span className='filter1SelectedDisplay'>
                                                            <button
                                                            >Limited <label>✅</label></button>
                                                        </span>
                                                    }
                                                    {this.state.showUnlimitedSelectedFilter && 
                                                        <span className='filter2SelectedDisplay'>
                                                            <button
                                                            >Unlimited <label>✅</label></button>
                                                        </span>
                                                    }
                                                    <div className='filterOptions'>
                                                        <div className='filterOptionsCol1'>
                                                            <button
                                                            onClick={this.setLimitReferralBtnClicked}
                                                            style={setLimitBtnStyle}
                                                            >{this.state.limitedReferralTxt}</button>
                                                            <h5>(Recommended)</h5>
                                                        </div>
                                                        <div className='filterOptionsCol1'>
                                                            <button
                                                            onClick={this.unlimitedReferralBtnClicked}
                                                            style={unlimitedBtnStyle}
                                                            >{this.state.unlimitedReferralTxt}</button>
                                                        </div>
                                                    </div>
                                                    {this.state.showReferralCodeContinueBtn && 
                                                    <div>
                                                        {this.state.showSettingReferralLimit && 
                                                            <div className='referralLimitSystemCol'>
                                                                <h4>Set your referral-based registration (earning) limit</h4>
                                                                <div onClick={this.handleReferralRegistrationLimitValueClicked} style={referralRegistrationLimitInput} className='pointsInput'>
                                                                    <p style={referralRegistrationLimitLabel}>Maximum no. of regristrations (enter a number)</p>
                                                                    <input
                                                                    id='referralRegistrationLimitValue'
                                                                    placeholder='100'
                                                                    value={this.state.referralRegistrationLimitValue}
                                                                    onChange={this.handleChange}
                                                                    onClick={this.handleReferralRegistrationLimitValueClicked}
                                                                    />
                                                                </div>
                                                            </div>
                                                        } <br></br>
                                                        <div className='filterOptionsContinueBtn2'>
                                                            <button
                                                            onClick={this.referralCodeContinueBtnClicked}
                                                            >Continue</button>
                                                        </div>
                                                    </div>
                                                    }
                                                </div> 
                                            </div>
                                        }
                                        {this.state.showFilterOptions2 && 
                                            <div>
                                                <div className='pointsSystem'>
                                                    <h3>Price of order</h3>
                                                    <div className='pointsSystemCol2'>
                                                        <h4>If a customer spends ____________________ </h4>
                                                        {this.state.showPriceDescriptorDetails && 
                                                            <div className='mealOrderDetails'>
                                                                {this.state.showPriceDescriptorLabel && 
                                                                    <div className='mealOrderDetailsCol1'>
                                                                        <h5>{this.state.priceFilterLabel}<span></span></h5>
                                                                    </div>
                                                                }
                                                                {this.state.showPriceDescriptorLoading && 
                                                                    <div className='pointsSectionLoading4'>
                                                                        <ClipLoader
                                                                            color="#0930CB"
                                                                            loading={true}
                                                                            // cssOverride={override}
                                                                            size={15}
                                                                            aria-label="Loading Spinner"
                                                                            data-testid="loader"
                                                                        />
                                                                    </div>
                                                                }
                                                                <div className='mealOrderDetailsCol2'>
                                                                    <button
                                                                    onClick={this.clearPriceDescriptor}
                                                                    >Clear</button>
                                                                </div>
                                                            </div>
                                                        }
                                                        <div style={redeemPointsCategories} className='pointsInput'>
                                                            <div style={priceFilterDropdown}>
                                                            <h5>Price descriptor <label>*</label></h5>
                                                            <Select 
                                                            placeholder="Select"
                                                            className='selectMenu' 
                                                            options={priceFilterOptions}
                                                            onChange={this.setFilterPriceOption}
                                                            />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='pointsSystemCol'>
                                                        <h4>KES ______ .</h4>
                                                        <div onClick={this.handleFilterOptionPricingClicked} style={filterOptionPricingInput} className='pointsInput'>
                                                            <p style={pointsMoneyValueLabel}>Money value (enter a number)</p>
                                                            <input
                                                            id='filterOptionPricing'
                                                            placeholder='100'
                                                            value={this.state.filterOptionPricing}
                                                            onChange={this.handleChange}
                                                            onClick={this.handleFilterOptionPricingClicked}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.state.showPriceOnlyTimeDuration && <div className='pointsSystem4'>
                                                    <h3>Time duration</h3>
                                                    <div className='pointsSystemCol2'>
                                                        <h4> (optional) within the next ____________ .</h4>
                                                        {this.state.showMealOrderTimeDetails && 
                                                            <div className='mealOrderDetails'>
                                                                {this.state.showTimeDurationLabel && 
                                                                    <div className='mealOrderDetailsCol1'>
                                                                        <h5>{this.state.filterOptionTimeValue} <span>{this.state.filterOptionCalendarValue}(s) <span style={{marginLeft: "2%", color: "red"}}>[END DATE: {this.state.filterOptionEndDate}]</span></span></h5>
                                                                    </div>
                                                                }
                                                                {this.state.showTimeDurationLoading && 
                                                                    <div className='pointsSectionLoading4'>
                                                                        <ClipLoader
                                                                            color="#0930CB"
                                                                            loading={true}
                                                                            // cssOverride={override}
                                                                            size={15}
                                                                            aria-label="Loading Spinner"
                                                                            data-testid="loader"
                                                                        />
                                                                    </div>
                                                                }
                                                                <div className='mealOrderDetailsCol2'>
                                                                    <button
                                                                    onClick={this.clearTimeDuration}
                                                                    >Clear</button>
                                                                </div>
                                                            </div>
                                                        }
                                                        <div style={redeemPointsCategories} className='pointsInput'>
                                                            <div className='rewardCategories' style={pointsExpirationDropdown}>
                                                                <h5>Length of time </h5>
                                                                <Select 
                                                                placeholder="Select "
                                                                className='selectMenu' 
                                                                options={timeFilterOptions}
                                                                onChange={this.setTimeFilter}
                                                                />
                                                            </div>
                                                            <div className='rewardCategories' style={pointsExpirationDropdown}>
                                                                <h5>Days / Weeks / Months / Years {this.state.showFilterCalendarValueAsterisk && <label>*</label>}</h5>
                                                                <Select 
                                                                placeholder="Select "
                                                                className='selectMenu' 
                                                                options={dateFilterOptions}
                                                                onChange={this.setDateFilter}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                            </div>
                                        }
                                        {/* {this.state.showFilterOptions3 && 
                                            
                                        } */}
                                        {this.state.showFilterOptions4 && 
                                            <div className='pointsSystem2'>
                                                <h3>Frequency of order</h3>
                                                <div className='pointsSystemCol'>
                                                    <h4>If a customer purchases (at minimum) ____ units of </h4>
                                                    <div onClick={this.handleFilterOptionPricingClicked} style={filterOptionPricingInput} className='pointsInput'>
                                                        <p style={pointsMoneyValueLabel}>No. of orders (enter a number)</p>
                                                        <input
                                                        id='filterOptionPricing'
                                                        placeholder='100'
                                                        value={this.state.filterOptionPricing}
                                                        onChange={this.handleChange}
                                                        onClick={this.handleFilterOptionPricingClicked}
                                                        />
                                                    </div>
                                                    <div className='pointsSystemCol'>

                                                    </div>
                                                </div>
                                                <div className='pointsSystemCol2'>
                                                    <h4>____________ from the menu.</h4>
                                                    <div style={redeemPointsCategories} className='pointsInput'>
                                                        {this.state.showRewardsCategories && 
                                                            <div className='rewardCategories'>
                                                                <h5>Menu Category</h5>
                                                                <Select
                                                                className='selectMenu'
                                                                // components={animatedComponents}
                                                                placeholder="Select a menu category"
                                                                // isMulti
                                                                options={this.state.menuCategories}
                                                                onChange={this.handleMenuCategoryClicked}
                                                                />
                                                            </div>
                                                        }
                                                        {this.state.showCoffeeAndTea &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Coffee & Tea</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showIcedCoffeeAndTea &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Iced Teas & Coffee</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showBreakfast &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Breakfast</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showStartersAndSharing &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Starters & Sharing</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showLunchAndDinner &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Lunch & Dinner</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showBurgers &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Burgers</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showChips &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Chips</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showWings &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Wings</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showSandwiches &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Sandwiches</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showSalads &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Salads</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showArtPizzas &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Art Pizza (Italian Style)</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showPasta &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Pasta</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showBakery &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Bakery</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showCakesAndDesserts &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Cakes & Desserts</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showColdPressJuices &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Cold-Press Juices</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showSoftDrinks &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Soft Drinks</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showKidsMenu &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Kids Menu</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showWholeCakes &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Whole Cakes</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity</h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showPowerSmoothies &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Power Smoothies <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showFilterOptions5 && 
                                            <div className='pointsSystem2'>
                                                <h3>Specific meal order</h3>
                                                <div className='pointsSystemCol2'>
                                                    <h4>If a customer orders ____________________________ </h4>
                                                    {this.state.showMealOrderDetails && 
                                                        <div className='mealOrderDetails'>
                                                            {this.state.showMealSelectedLabel && 
                                                                <div className='mealOrderDetailsCol1'>
                                                                    <h5>{this.state.rewardMenuItem} <span>x{this.state.rewardQuantity}</span></h5>
                                                                </div>
                                                            }
                                                            {this.state.showMealSelectedLoading && 
                                                                <div className='pointsSectionLoading4'>
                                                                    <ClipLoader
                                                                        color="#0930CB"
                                                                        loading={true}
                                                                        // cssOverride={override}
                                                                        size={15}
                                                                        aria-label="Loading Spinner"
                                                                        data-testid="loader"
                                                                    />
                                                                </div>
                                                            }
                                                            <div className='mealOrderDetailsCol2'>
                                                                <button
                                                                onClick={this.clearMealSelected}
                                                                >Clear</button>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div style={redeemPointsCategories} className='pointsInput'>
                                                        {this.state.showRewardsCategories && 
                                                            <div className='rewardCategories'>
                                                                <h5>Menu Category <label>*</label></h5>
                                                                <Select
                                                                className='selectMenu'
                                                                // components={animatedComponents}
                                                                placeholder="Select a menu category"
                                                                // isMulti
                                                                options={this.state.menuCategories}
                                                                onChange={this.handleMenuCategoryClicked}
                                                                />
                                                            </div>
                                                        }
                                                        {this.state.showCoffeeAndTea &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Coffee & Tea <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showIcedCoffeeAndTea &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Iced Teas & Coffee <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showBreakfast &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Breakfast <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showStartersAndSharing &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Starters & Sharing <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showLunchAndDinner &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Lunch & Dinner <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showBurgers &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Burgers <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showChips &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Chips <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showWings &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Wings <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showSandwiches &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Sandwiches <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showSalads &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Salads <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showArtPizzas &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Art Pizza (Italian Style) <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    options={this.state.selectedMenuCategory}/>
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showPasta &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Pasta <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showBakery &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Bakery <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showCakesAndDesserts &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Cakes & Desserts <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showColdPressJuices &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Cold-Press Juices <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showSoftDrinks &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Soft Drinks <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showKidsMenu &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Kids Menu <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showWholeCakes &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Whole Cakes <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showPowerSmoothies &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Power Smoothies <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showSteaks &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Steaks <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showSoup &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Soup <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showMocktails &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Mocktails <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showHotNBoozy &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Hot N Boozy <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showBeer &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Beer <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showWhiteWine &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>White Wine <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showSangria &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Sangria <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showRedWine &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Red Wine <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showSparkling &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Sparkling <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showRose &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Rosé <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showArtCocktails &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Art Cocktails <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showCocktails &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Classic Cocktails <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showSpiritsAndLiquer &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Spirits and Liquer <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showMilkshakes &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Milkshakes <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showQuiches &&
                                                            <div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quiches <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an item"
                                                                    options={this.state.selectedMenuCategory}
                                                                    onChange={this.rewardMenuItemSelected}
                                                                    />
                                                                </div>
                                                                <div className='rewardCategories'>
                                                                    <h5>Quantity <label>*</label></h5>
                                                                    <Select 
                                                                    className='selectMenu' 
                                                                    placeholder="Select an quantity"
                                                                    onChange={this.selectedMenuItemQuantity}
                                                                    options={options5}/>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='pointsSystemCol2'>
                                                    <h4> (optional) within the next ____________ .</h4>
                                                    {this.state.showMealOrderTimeDetails && 
                                                        <div className='mealOrderDetails'>
                                                            {this.state.showTimeDurationLabel && 
                                                                <div className='mealOrderDetailsCol1'>
                                                                    <h5>{this.state.filterOptionTimeValue} <span>{this.state.filterOptionCalendarValue}(s) <span style={{marginLeft: "2%", color: "red"}}>[END DATE: {this.state.filterOptionEndDate}]</span></span></h5>
                                                                </div>
                                                            }
                                                            {this.state.showTimeDurationLoading && 
                                                                <div className='pointsSectionLoading4'>
                                                                    <ClipLoader
                                                                        color="#0930CB"
                                                                        loading={true}
                                                                        // cssOverride={override}
                                                                        size={15}
                                                                        aria-label="Loading Spinner"
                                                                        data-testid="loader"
                                                                    />
                                                                </div>
                                                            }
                                                            <div className='mealOrderDetailsCol2'>
                                                                <button
                                                                onClick={this.clearTimeDuration}
                                                                >Clear</button>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div style={redeemPointsCategories} className='pointsInput'>
                                                        <div className='rewardCategories' style={pointsExpirationDropdown}>
                                                            <h5>Length of time </h5>
                                                            <Select 
                                                            placeholder="Select "
                                                            className='selectMenu' 
                                                            options={timeFilterOptions}
                                                            onChange={this.setTimeFilter}
                                                            />
                                                        </div>
                                                        <div className='rewardCategories' style={pointsExpirationDropdown}>
                                                            <h5>Days / Weeks / Months / Years {this.state.showFilterCalendarValueAsterisk && <label>*</label>}</h5>
                                                            <Select 
                                                            placeholder="Select "
                                                            className='selectMenu' 
                                                            options={dateFilterOptions}
                                                            onChange={this.setDateFilter}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showApplyFilterErrMsg && 
                                            <div className='applyFilterErrMsg'>
                                                <h4>{this.state.applyFilterErrMessage}</h4>
                                            </div>
                                        }
                                        {this.state.showApplyFilterOptionsBtn &&
                                            <div className='applyFilterOptionsBtn'>
                                                <div className='pointsSaveBtn'>
                                                    <button
                                                    onClick={this.applyFilterClicked}
                                                    style={backFilterOptionsBtn}
                                                    >Apply Filter(s)</button>
                                                </div>
                                                <h5></h5>
                                            </div>
                                        }
                                        {this.state.showAppliedFilters && 
                                            <div className='appliedFilterMsg'>
                                                <h4>Applied Filters</h4>
                                                {this.state.showAppliedPricingFilter && 
                                                    <div className='appliedFilterSpan'>
                                                        <div>
                                                            <span><label>Pricing</label></span>
                                                        </div>
                                                        <div>
                                                            {this.renderPricingFilter()}
                                                        </div>
                                                    </div>
                                                }
                                                {this.state.showAndOrFilterBtns && 
                                                    <div className='andOrFilterBtns'>
                                                        <button
                                                        style={andFilterBtnStyle}
                                                        onClick={this.andFilterBtnClicked}
                                                        >AND</button>
                                                        <button
                                                        style={orFilterBtnStyle}
                                                        onClick={this.orFilterBtnClicked}
                                                        >OR</button>
                                                    </div>
                                                }
                                                {this.state.showAppliedSelectedMealFilter && 
                                                    <div className='appliedFilterSpan'>
                                                        <span><label>Selected Order</label></span>
                                                        <div>
                                                            {this.renderSelectedMealFilter()}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {this.state.showEditUnlimitedReferralCodeEarning && 
                                            <div className='pointsSystem2'>
                                                {this.state.showSetLimitOfReferralRegistrations && 
                                                    <div className='referralRegistrationLimitDisplay'>
                                                        <h2>Maxiumum Registration Limit: <label>{this.state.referralRegistrationLimitValue}</label></h2>
                                                    </div>
                                                }
                                                <h3>Referral Code Registration(s)</h3>
                                                <div className='pointsSystemCol'>
                                                    <h4>For every _____ referral-based registration(s)..</h4>
                                                    <div onClick={this.handleReferralRegistrationsValueClicked} style={referralRegistrationInput} className='pointsInput'>
                                                        <p style={referralRegistrationLabel}>No. of referral-based registrations (enter a number)</p>
                                                        <input
                                                        id='referralRegistrationValue'
                                                        placeholder='1'
                                                        value={this.state.referralRegistrationValue}
                                                        onChange={this.handleChange}
                                                        onClick={this.handleReferralRegistrationsValueClicked}
                                                        />
                                                    </div>
                                                    <div className='referralSaveFinalBtn'>
                                                    {/* <div className='pointsSaveBtn'> */}
                                                        <button
                                                        onClick={this.finishSaveReferralDetails}
                                                        >Save Referral Information</button>
                                                    {/* </div> */}
                                                    </div>
                                                </div>
                                                <div className='pointsSystemCol2'>
                                                    <h4>.. the loyalty customer earns ______ points.</h4>
                                                    <div onClick={this.handleEarnedValueClicked} style={pointsEarnedValueInput} className='pointsInput'>
                                                        <p style={pointsEarnedValueLabel}>Point(s) value (enter a number)</p>
                                                        <input
                                                        id='pointsEarnedValue'
                                                        placeholder='10'
                                                        value={this.state.pointsEarnedValue}
                                                        onChange={this.handleChangePointsValue}
                                                        onClick={this.handleEarnedValueClicked}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showEditLimitedReferralCodeEarning && 
                                            <div className='pointsSystem2'>
                                                <h3></h3>
                                                <div className='pointsSystemCol'>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showNoCustomizationSpace && 
                                            <div className='noCustomizationBlankSpace'>

                                            </div>
                                        }
                                        {this.state.showEditEarningValue && 
                                            <div className='pointsSystem'>
                                                {this.state.showEarnPointsDirect && 
                                                    <div className='pointsSystemCol'>
                                                        <h4>Your customer earns ____ point(s)..</h4>
                                                        <div onClick={this.handleEarnedValueClicked} style={pointsEarnedValueInput} className='pointsInput'>
                                                            <p style={pointsEarnedValueLabel}>Point(s) value (enter a number)</p>
                                                            <input
                                                            id='pointsEarnedValue'
                                                            placeholder='1'
                                                            value={this.state.pointsEarnedValue}
                                                            onChange={this.handleChangePointsValue}
                                                            onClick={this.handleEarnedValueClicked}
                                                            />
                                                        </div>
                                                        {this.state.showEarningPolicyPercentageChange && 
                                                            <div className='earningPolicyPercentage'>
                                                                <div className='earningPolicyPercentageContainer'>
                                                                    <h3>↑ {this.state.earningPolicyPercentageValue}%</h3>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                <div className='pointsSystemCol'>
                                                    <h4>..for every KES ____ spent</h4>
                                                    <div onClick={this.handleMoneyValueClicked} style={pointsMoneyValueInput} className='pointsInput'>
                                                        <p style={pointsMoneyValueLabel}>Money value (enter a number)</p>
                                                        <input
                                                        id='pointsMoneyValue'
                                                        placeholder='100'
                                                        value={this.state.pointsMoneyValue}
                                                        onChange={this.handleChangeMoneyValue}
                                                        onClick={this.handleMoneyValueClicked}
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className='pointsSystemCol2'>
                                                    <div className='rewardCategories3'>
                                                        <h5>Points conversion (direct or %)</h5>
                                                        <Select 
                                                        defaultValue={defaultValueEarningValueOptions}
                                                        className='selectMenu5' 
                                                        placeholder="Select"
                                                        onChange={this.earningValueOptionClicked}
                                                        options={earningValueOptions}/>
                                                    </div>
                                                </div> */}
                                            </div>
                                        }
                                        {this.state.showMultiplierDurationPeriod && 
                                            <div className='pointsSystem3'>
                                                <h3>Earning multiplier validity period</h3>
                                                <div className='pointsSystemCol2'>
                                                    <h4>The points multiplier is in effect for the next _________ .</h4>
                                                    {this.state.showMealOrderTimeDetails && 
                                                        <div className='mealOrderDetails'>
                                                            {this.state.showTimeDurationLabel && 
                                                                <div className='mealOrderDetailsCol1'>
                                                                    <h5>{this.state.multiplierTimeValue} <span>{this.state.multiplierCalendarValue}(s)</span></h5>
                                                                </div>
                                                            }
                                                            {this.state.showTimeDurationLoading && 
                                                                <div className='pointsSectionLoading4'>
                                                                    <ClipLoader
                                                                        color="#0930CB"
                                                                        loading={true}
                                                                        // cssOverride={override}
                                                                        size={15}
                                                                        aria-label="Loading Spinner"
                                                                        data-testid="loader"
                                                                    />
                                                                </div>
                                                            }
                                                            <div className='mealOrderDetailsCol2'>
                                                                <button
                                                                onClick={this.clearMultiplierTimeDuration}
                                                                >Clear</button>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div style={redeemPointsCategories} className='pointsInput'>
                                                        <div className='rewardCategories' style={pointsExpirationDropdown}>
                                                            <h5>Length of time {this.state.showMultiplierCalendarValueAsterisk && <label>*</label>}</h5>
                                                            <Select 
                                                            placeholder="Select "
                                                            className='selectMenu' 
                                                            options={timeFilterOptions}
                                                            onChange={this.setMultiplierTimeFilter}
                                                            />
                                                        </div>
                                                        <div className='rewardCategories' style={pointsExpirationDropdown}>
                                                            <h5>Days / Weeks / Months / Years {this.state.showMultiplierCalendarValueAsterisk && <label>*</label>}</h5>
                                                            <Select 
                                                            placeholder="Select "
                                                            className='selectMenu' 
                                                            options={dateFilterOptions}
                                                            onChange={this.setMultiplierDateFilter}
                                                            />
                                                        </div>
                                                        {this.state.showApplyFilterErrMsg2 && 
                                                            <div className='applyFilterErrMsg'>
                                                                <h4><label>⚠️</label>{this.state.applyFilterErrMessage}</h4>
                                                            </div>
                                                        }
                                                        {this.state.showApplyFilterErrMsg3 && 
                                                            <div className='applyFilterErrMsg'>
                                                                <h4><label>⚠️</label>{this.state.applyFilterErrMessage2}</h4>
                                                            </div>
                                                        }
                                                        {this.state.showEarningWithFilterBtn && 
                                                            <div className='pointsSaveBtn2'>
                                                                <button
                                                                onClick={this.finishEarningFilterClicked}
                                                                style={finishAppliedFilterBtn}
                                                                >Finish</button>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        }
                                        {this.state.showEarningValue && 
                                            <div className='pointsSystem'>
                                                <div className='pointsSystemCol'>
                                                    <div style={pointsPluralInputDisplay} className='pointsInput'>
                                                        <p style={pointsSingleLabel}>Point(s)</p>
                                                        <h3 style={pointsValueDisplay}>{this.state.pointsEarnedValue}</h3>
                                                    </div>
                                                </div>
                                                <div className='pointsSystemCol'>
                                                    <div style={pointsPluralInputDisplay} className='pointsInput'>
                                                        <p style={pointsSingleLabel}>Equivalent money value</p>
                                                        <h3 style={pointsValueDisplay}>KES {this.state.pointsMoneyValue}</h3>
                                                    </div>
                                                </div>
                                        </div>
                                        }
                                        {this.state.showEditExpirationHeader && 
                                            <h3>Define your loyalty points expiration period</h3>
                                        }
                                        {this.state.showExpirationHeader && 
                                            <h3>Your loyalty points expiration period</h3>
                                        }
                                        {this.state.showEditExpirationLoyalty && 
                                            <div className='pointsSystem'>
                                                <div className='pointsSystemCol2'>
                                                    <h4>Unused points expire after:</h4>
                                                    <div style={redeemPointsCategories} className='pointsInput'>
                                                        <div style={pointsExpirationDropdown}>
                                                        <Select 
                                                        placeholder="Select a duration"
                                                        className='selectMenu' 
                                                        options={options3}
                                                        onChange={this.setExpirationPoints}
                                                        />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='pointsSystemCol2'>
                                                    {/* <h4>Dormant points expire after:</h4> */}
                                                    <div style={redeemPointsCategories} className='pointsInput'>
                                                        
                                                    </div>
                                                </div>
                                                {/* {this.state.showMoreOptionsBtn && 
                                                    <div className='moreOptionsPointsSystem'>
                                                        <p onClick={this.moreOptionsClicked}>More options</p>
                                                    </div>
                                                } */}
                                            </div>
                                        }
                                        {this.state.showExpirationLoyalty && 
                                            <div className='pointsSystem'>
                                                <div className='pointsSystemCol'>
                                                    <div style={pointsPluralInputDisplay} className='pointsInput'>
                                                        <p style={pointsSingleLabel}>Expiration period (for unused points)</p>
                                                        <h3 style={pointsValueDisplay}>{this.state.pointsExpirationValue}</h3>
                                                    </div>
                                                </div>
                                                <div className='pointsSystemCol'>
                                                    {/* <h4>Dormant points expire after:</h4> */}
                                                    <div style={redeemPointsCategories} className='pointsInput'>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showEditMoreOptionsPoints && 
                                            <div className='moreOptionsPointsEdit'>
                                                <h3>Custom Options</h3>
                                                <h4>Add customized earning values for different customers</h4>
                                                <div>
                                                    <button
                                                    ></button>
                                                </div>
                                                <div>
                                                    <button
                                                    ></button>
                                                </div>
                                                <div>
                                                    <button
                                                    ></button>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showEarningEditBtn && 
                                            <div className='pointsSaveBtn'>
                                                <button
                                                onClick={this.saveEarningValue}
                                                style={pointsEditSaveBtn}
                                                >Save</button>
                                            </div>
                                        }
                                        {this.state.showEarningDisplayBtn && 
                                            <div className='pointsSaveBtn'>
                                                <button
                                                onClick={this.editEarningValue}
                                                style={pointsDisplaySaveBtn}
                                                >Edit</button>
                                            </div>
                                        }
                                        {this.state.showApplyFilterErrMsg4 && 
                                            <div className='applyFilterErrMsg'>
                                                <h4><label>⚠️</label>{this.state.applyFilterErrMessage3}</h4>
                                            </div>
                                        }
                                        {this.state.showShowAllEarningsHeader && 
                                            <div className='allEarningsBtn'>
                                                <p
                                                onClick={this.goToAllEarningPolicies}
                                                ><label>See all earning policies</label></p>
                                            </div>
                                        }
                                        {this.state.showAllEarningPolicies && 
                                            <div className='allEarningPolicies'>
                                                <h2>Please note</h2>
                                                <div className='allEarningPoliciesNotice'>
                                                    <div className='earningPolicyNoticeCol1'>
                                                        <img src='/assets/earning_policy_active.png'/>
                                                    </div>
                                                    <div className='earningPolicyNoticeCol2'>
                                                        <p>policy is active and available to customers</p>
                                                    </div>
                                                </div>
                                                <div className='allEarningPoliciesNotice'>
                                                    <div className='earningPolicyNoticeCol1'>
                                                        <img src='/assets/earning_policy_inactive.png'/>
                                                    </div>
                                                    <div className='earningPolicyNoticeCol2'>
                                                        <p>policy is inactive and unavailable to customers</p>
                                                    </div>
                                                </div>
                                                <div className='moreEarningPolicyNotes'>
                                                    <p>Earning policies take effect from the 'Date active' until the date specified under 'Earning policy' (highlighted in red).</p>
                                                    {/* <p>Meal earning policies take effect from the START of the month in the 'Date created' to the END of the month in the end date (highlighted in red).</p> */}
                                                    <p>Multiplier values ('Earning value') apply to customer points for (ALL ORDERS) for the duration specified under 'Valid for'.</p>
                                                </div>
                                                <div className='earningPolicyHeader'>
                                                    <div className='EPHeaderCol1'>
                                                        <button>
                                                            <img src='assets/earningPolicyChecked.png'/>
                                                        </button>
                                                    </div>
                                                    <div className='EPHeaderCol2'>
                                                        <h4>Filter</h4>
                                                    </div>
                                                    <div className='EPHeaderCol3'>
                                                        <h4>Earning policy</h4>
                                                    </div>
                                                    <div className='EPHeaderCol3_5'>
                                                        <h4>Valid for</h4>
                                                    </div>
                                                    <div className='EPHeaderCol4'>
                                                        <h4>Earning value</h4>
                                                    </div>
                                                    <div className='EPHeaderCol5'>
                                                        <h4>Date active</h4>
                                                    </div>
                                                    <div className='EPHeaderCol6'>
                                                        <h4>Status</h4>
                                                    </div>
                                                </div>
                                                {this.state.showRenderAllEarningPolicies && 
                                                    <div>
                                                        {this.renderAllEarningPolicies()}
                                                    </div>
                                                }
                                                {this.state.showEarningPolicyTableLoading && 
                                                    <div className='pointsSectionLoading3'>
                                                        <ClipLoader
                                                            color="#0930CB"
                                                            loading={true}
                                                            // cssOverride={override}
                                                            size={50}
                                                            aria-label="Loading Spinner"
                                                            data-testid="loader"
                                                        />
                                                    </div>
                                                }
                                                <div className='allEarningPoliciesFooter'>
                                                    {this.state.showEarningTablePrevBtn &&
                                                        <div className='EPFooterCol1'>
                                                            <p><label
                                                            onClick={this.handlePrevEarningPolicyPage}
                                                            >{this.state.prevBtnTxt}</label></p>
                                                        </div>
                                                    }
                                                    <div className='EPFooterCol2'>
                                                        <div className='pageJumper'>
                                                            <div className='pageJumperCol1'>
                                                                <input
                                                                id='currentPage'
                                                                value={this.state.currentPage}
                                                                />
                                                            </div>
                                                            <div className='pageJumperCol2'>
                                                                <p>of</p>
                                                            </div>
                                                            <div className='pageJumperCol3'>
                                                                <p>{this.state.totalEarningPolicyPages}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {this.state.showEarningTableNextBtn && 
                                                        <div className='EPFooterCol3'>
                                                            <p><label
                                                            onClick={this.handleNextEarningPolicyPage}
                                                            >{this.state.nextBtnTxt}</label></p>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        <div className='pointsFormSeparator'></div>
                                        {this.state.showRewardsHeader && 
                                            <div>
                                                <h2 style={{fontFamily: "rubik", fontWeight: "bold", fontSize: "29px", marginBottom: "0px", marginTop: "1%", paddingTop: "1.5%", marginLeft: "2.5%"}}>Customer Rewards</h2>
                                                <h3 style={{marginTop: "1%", paddingTop: "0px"}}>Define rewards for your customers</h3>
                                            </div>
                                        }
                                        {this.state.showRewardsErrorMsg && 
                                            <div className='rewardsErrorMsg'>
                                                <div className='baselineValueAlert'>
                                                    <div className='baselineValueMsg'>
                                                        <p>Set an earning <label>Baseline Policy</label> (above) before you create your first reward.</p>
                                                    </div>
                                                    <div className='baselineValueClose'>
                                                        <button
                                                        onClick={this.closeRewardsNotification}
                                                        ><img src='assets/exit-baseline-alert.png'/></button>
                                                    </div>
                                                </div>
                                            </div>
                                        } 
                                        {this.state.showRewardsErrorMsgEarningConflict && 
                                            <div className='rewardsErrorMsg'>
                                                <div className='baselineValueAlert'>
                                                    <div className='baselineValueMsg'>
                                                        <p style={{marginTop: "0px"}}>Please complete OR cancel your earning definition above before creating your next reward.</p>
                                                    </div>
                                                    <div className='baselineValueClose'>
                                                        <button
                                                        onClick={this.closeRewardsNotification}
                                                        ><img src='assets/exit-baseline-alert.png'/></button>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {this.state.showAddRewardBtn && 
                                            <div className='showRewardPlaceholder'>   
                                                <div className='addRewardBtn'>
                                                    <button
                                                    onClick={this.addNewRewardClicked}
                                                    >+ Add reward</button>
                                                </div>
                                                {this.state.showAddRewardsPlaceholder && 
                                                    <div className='addRewardPlaceholderImg'>
                                                        <h1>Add rewards</h1>
                                                        <img src='/assets/rewardsBadge.png'/>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {this.state.showSectionLoading3 && 
                                            <div className='pointsSectionLoading2'>
                                                <ClipLoader
                                                    color="#0930CB"
                                                    loading={true}
                                                    // cssOverride={override}
                                                    size={30}
                                                    aria-label="Loading Spinner"
                                                    data-testid="loader"
                                                />
                                            </div>
                                        }
                                        {this.state.showRewardsTable && 
                                            <div className='renderRewardsTable'>
                                                <div className='rewardsTableHeader'>
                                                    <div className='rewardsHeaderCol1'>
                                                        <button>
                                                            <img src='assets/earningPolicyChecked.png'/>
                                                        </button>
                                                    </div>
                                                    <div className='rewardsHeaderCol2'>
                                                        <h4>Reward type</h4>
                                                    </div>
                                                    <div className='rewardsHeaderCol3'>
                                                        <h4>Reward</h4>
                                                    </div>
                                                    <div className='rewardsHeaderCol4'>
                                                        <h4>Reward details</h4>
                                                    </div>
                                                    <div className='rewardsHeaderCol5'>
                                                        <h4 style={{paddingTop: "1.5%"}}>Date created</h4>
                                                    </div>
                                                    <div className='rewardsHeaderCol6'>
                                                        <h4 style={{paddingTop: "1.5%"}}>Expiry date</h4>
                                                    </div>
                                                    <div className='rewardsHeaderCol7'>
                                                        <h4 style={{paddingTop: "1.5%"}}>Status</h4>
                                                    </div>
                                                </div>
                                                {this.state.showRenderRewardsTable && 
                                                    <div>
                                                        {this.renderRewardsTable()}
                                                    </div>
                                                }
                                                {this.state.showRewardsTableLoading && 
                                                    <div className='pointsSectionLoading3'>
                                                        <ClipLoader
                                                            color="#0930CB"
                                                            loading={true}
                                                            // cssOverride={override}
                                                            size={50}
                                                            aria-label="Loading Spinner"
                                                            data-testid="loader"
                                                        />
                                                    </div>
                                                }
                                                <div id="bottomOfRewardsTable" className='allEarningPoliciesFooter'>
                                                    {this.state.showRewardsTablePrevBtn &&
                                                        <div className='EPFooterCol1'>
                                                            <p><label
                                                            onClick={this.handlePrevRewardsPage}
                                                            >{this.state.prevBtnTxtRewards}</label></p>
                                                        </div>
                                                    }
                                                    <div className='EPFooterCol2'>
                                                        <div className='pageJumper'>
                                                            <div className='pageJumperCol1'>
                                                                <input
                                                                id='currentPage'
                                                                value={this.state.currentRewardsPage}
                                                                />
                                                            </div>
                                                            <div className='pageJumperCol2'>
                                                                <p>of</p>
                                                            </div>
                                                            <div className='pageJumperCol3'>
                                                                <p>{this.state.totalRewardsPages}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {this.state.showRewardsTableNextBtn && 
                                                        <div className='EPFooterCol3'>
                                                            <p><label
                                                            onClick={this.handleNextRewardsPage}
                                                            >{this.state.nextBtnTxtRewards}</label></p>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {this.state.showAddRewardDisplay && 
                                            <div className='addRewardDisplay'>
                                                <div className='pointsSystem'>
                                                    <div className='pointsSystemCol'>
                                                        <h4>Points earned</h4>
                                                        <div onClick={this.handleRewardsValueClicked} style={pointsRewardValueInput} className='pointsInput'>
                                                            <p style={pointsRewardValueLabel}>Points earned (enter a number)</p>
                                                            <input
                                                            id='pointsRewardValue'
                                                            placeholder='50'
                                                            value={this.state.pointsRewardValue}
                                                            onChange={this.handleChange2}
                                                            onClick={this.handleRewardsValueClicked}
                                                            />
                                                        </div>
                                                        <div onClick={this.handleEarnedValueClicked} style={pointsMoneyValueInput2} className='pointsInput'>
                                                            <p style={pointsMoneyValueLabel2}>Equivalent money value (based on above Baseline Value)</p>
                                                            <h3>KES {this.state.moneyEquivalent}</h3>
                                                        </div>
                                                        {this.state.showPercentageOffReward && 
                                                            <div className='percentageOffReward'>
                                                                <h4>Percentage off item (%)</h4>
                                                                <div onClick={this.handlePercentageOffValueClicked} style={percentageOffValueInput} className='pointsInput'>
                                                                    <p style={percentageOffValueLabel}>Percentage off item (enter a number)</p>
                                                                    <input
                                                                    id='percentageOffValue'
                                                                    placeholder='10'
                                                                    value={this.state.percentageOffValue}
                                                                    onChange={this.handleChange}
                                                                    onClick={this.handlePercentageOffValueClicked}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showMoneyOffReward && 
                                                            <div className='percentageOffReward'>
                                                                <h4>Money (amount) off item (KES)</h4>
                                                                <div onClick={this.handleMoneyOffValueClicked} style={moneyOffValueInput} className='pointsInput'>
                                                                    <p style={moneyOffValueLabel}>Money off item (enter a number)</p>
                                                                    <input
                                                                    id='moneyOffValue'
                                                                    placeholder='100'
                                                                    value={this.state.moneyOffValue}
                                                                    onChange={this.handleChange}
                                                                    onClick={this.handleMoneyOffValueClicked}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showCustomReward && 
                                                            <div className='customRewardInput'>
                                                                <h4>Custom reward</h4>
                                                                <textarea
                                                                id="customRewardValue"
                                                                style={customRewardInput}
                                                                placeholder='E.g. free spa treatment @ Ashleys'
                                                                value={this.state.customRewardValue}
                                                                onChange={this.handleChange}
                                                                />
                                                            </div>
                                                        }
                                                        {this.state.showExpirationRewardDate && 
                                                            <div className='percentageOffReward'>
                                                                <h4>Set reward expiration date</h4>
                                                                <div onClick={this.handleRewardExpirationValueClicked} style={rewardExpirationDateInput} className='pointsInput'>
                                                                    <p style={rewardExpirationValueLabel}>Reward expiry date (mm/dd/yy)</p>
                                                                    <input
                                                                    id='rewardExpirationValue'
                                                                    placeholder='10/03/24'
                                                                    value={this.state.rewardExpirationValue}
                                                                    onChange={this.handleChange}
                                                                    onClick={this.handleRewardExpirationValueClicked}
                                                                    />
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.showSaveRewardBtn && 
                                                            <div className='addNewRewardBtn'>
                                                                <button
                                                                onClick={this.saveReward}
                                                                >Save Reward</button>
                                                            </div>
                                                        }
                                                        {this.state.showSaveRewardBtnLoading && 
                                                            <div className='addNewRewardBtn'>
                                                                <button
                                                                // onClick={this.saveReward}
                                                                >
                                                                    <ClipLoader
                                                                    color="#fff"
                                                                    loading={true}
                                                                    // cssOverride={override}
                                                                    size={10}
                                                                    aria-label="Loading Spinner"
                                                                    data-testid="loader"
                                                                    />
                                                                </button>
                                                            </div>
                                                        }
                                                        <div className='cancelNewRewardBtn'>
                                                            <button
                                                            onClick={this.backToRewardsTable}
                                                            >Cancel</button>
                                                        </div>
                                                    </div>
                                                    <div className='pointsSystemCol2'>
                                                        <h4> Customer reward</h4>
                                                        <div style={redeemPointsCategories} className='pointsInput'>
                                                            <div className=''>
                                                                {/* <h5>Reward</h5> */}
                                                                <Select 
                                                                placeholder="Select a reward type"
                                                                className='selectMenu' 
                                                                options={options4}
                                                                onChange={this.handleRewardClicked}
                                                                />
                                                            </div>
                                                            {this.state.showRewardsCategories2 && 
                                                                <div className='rewardCategories'>
                                                                    <h5>Menu Category</h5>
                                                                    <Select
                                                                    className='selectMenu'
                                                                    // components={animatedComponents}
                                                                    placeholder="Select a menu category"
                                                                    // isMulti
                                                                    options={this.state.menuCategories}
                                                                    onChange={this.handleMenuCategoryClickedRewards}
                                                                    />
                                                                </div>
                                                            }
                                                            {this.state.showCoffeeAndTea2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Coffee & Tea</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        options={this.state.selectedMenuCategory}/>
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showIcedCoffeeAndTea2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Iced Teas & Coffee</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        options={this.state.selectedMenuCategory}/>
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showBreakfast2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Breakfast</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        options={this.state.selectedMenuCategory}/>
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showStartersAndSharing2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Starters & Sharing</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        options={this.state.selectedMenuCategory}/>
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showLunchAndDinner2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Lunch & Dinner</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        options={this.state.selectedMenuCategory}/>
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showBurgers2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Burgers</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        options={this.state.selectedMenuCategory}/>
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showChips2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Chips</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        options={this.state.selectedMenuCategory}/>
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showWings2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Wings</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        options={this.state.selectedMenuCategory}/>
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showSandwiches2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Sandwiches</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        options={this.state.selectedMenuCategory}/>
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showSalads2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Salads</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        options={this.state.selectedMenuCategory}/>
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showArtPizzas2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Art Pizza (Italian Style)</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        options={this.state.selectedMenuCategory}/>
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showPasta2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Pasta</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showBakery2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Bakery</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showCakesAndDesserts2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Cakes & Desserts</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showColdPressJuices2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Cold-Press Juices</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showSoftDrinks2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Soft Drinks</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showKidsMenu2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Kids Menu</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showWholeCakes2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Whole Cakes</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showPowerSmoothies2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Power Smoothies</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showSteaks2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Steaks</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showSoup2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Soup</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showMocktails2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Mocktails</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showHotNBoozy2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Hot N Boozy</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showBeer &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Beer</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showWhiteWine2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>White Wine</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showSangria2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Sangria</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showRedWine2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Red Wine</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showSparkling2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Sparkling</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showArtCocktails2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Art Cocktails</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showCocktails2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Classic Cocktails</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showSpiritsAndLiquer2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Spirits & Liquer</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showMilkshakes2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Milkshakes</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.state.showQuiches2 &&
                                                                <div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quiches</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an item"
                                                                        options={this.state.selectedMenuCategory}
                                                                        onChange={this.rewardMenuItemSelectedRewards}
                                                                        />
                                                                    </div>
                                                                    <div className='rewardCategories'>
                                                                        <h5>Quantity</h5>
                                                                        <Select 
                                                                        className='selectMenu' 
                                                                        placeholder="Select an quantity"
                                                                        onChange={this.selectedMenuItemQuantityRewards}
                                                                        options={options5}/>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            {this.state.showGettingStarted && 
                                <div className='allPostsContainer'>
                                    <h1>Let's Get You All Setup!</h1>
                                    <div className='gettingStartedInfo'>
                                        <p>In order to track whether any loyalty program (software) is working for you, it's important to compare your customer average order value before and after you start using the loyalty program. Effective loyalty programs should increase your customer average order value over time.</p>
                                        <p>To enable you do to this we created 'Trial Mode' - a feature which enables you to upload your pre-existing customer data (via CSV files) which you can start analyzing to see if your loyalty program is working effectively. If you don't have your data in order, you could start monitoring customer insights on our platform via Trial Mode.</p>
                                        <button
                                        onClick={this.trialModeClicked}
                                        >Trial Mode</button>
                                    </div>
                                </div>
                            }
                            {this.state.showTrialModeHome && 
                                <div className='allPostsContainer'>
                                    <h1>Trial Mode</h1>
                                </div>
                            }
                            {this.state.showAnalyticsHome && 
                                <div className='allPostsContainer'>
                                    <div className='rewardsHeader' style={{display: "flex", justifyContent: "space-between"}}>
                                        <h1>Analytics</h1>
                                        <button 
                                        onClick={this.backToHomepageAnalytics}
                                        style={{marginRight: "6.5%"}}
                                        ><strong>⬅︎</strong></button>
                                    </div>
                                    <div>
                                        <Analytics/>
                                    </div>    
                                </div>
                            }
                            {this.state.showCampaignsHome && 
                                <div className='allPostsContainer'>
                                    <div className='rewardsHeader' style={{display: "flex", justifyContent: "space-between"}}>
                                        <h1>Campaigns</h1>
                                        <button 
                                        onClick={this.backToHomepageCampaigns}
                                        style={{marginRight: "7.5%", marginTop: "0.5%"}}
                                        ><strong>⬅︎</strong></button>
                                    </div>
                                    <div>
                                        <Campaigns ref={this.childCampaignRef} onChildChange={this.campaignsChildChange}/>
                                    </div>
                                </div>
                            }
                            {this.state.showMembersHome && 
                                <div className='allPostsContainer'>
                                    <div className='rewardsHeader' style={{display: "flex", justifyContent: "space-between"}}>
                                        <h1>Members</h1>
                                        <button 
                                        onClick={this.backToHomepageMembers}
                                        style={{marginRight: "6.5%", marginTop: "2.5%"}}
                                        ><strong>⬅︎</strong></button>
                                    </div>
                                    <div>
                                        <Members savedPointsValue={this.state.savedPointsValue} savedMoneyValue={this.state.savedMoneyValue}/>
                                    </div>
                                </div>
                            }
                            {this.state.showCustomerSupportHome && 
                                <div className='allPostsContainer'>
                                    <h1>Customer Support</h1>
                                    <div className='customerSupportView'>
                                        <div className='customerSupportCol1'>
                                            <div className='customerSupportAllMessagesView'>
                                                <div className='allMessagesTopView'>
                                                    <div className='allMessagesTopViewCol1'>
                                                        <h2>Messages</h2>
                                                    </div>
                                                    <div className='allMessagesTopViewCol2'>
                                                        <button>+ New</button>
                                                    </div>
                                                </div>
                                                {this.state.showAllMessagesSelectMenu && 
                                                    <div className='allMessagesSelectView'>
                                                        <Select 
                                                        className='allMessagesSelectMenu' 
                                                        placeholder="Filter messages"
                                                        onChange={this.selectedMenuItemQuantity}
                                                        options={filterMessagesMenu}/>
                                                    </div>
                                                }
                                                <div className='allMessagesSelectPopups'>
                                                    {/* {this.state.show} */}
                                                </div>
                                                {this.state.showAllMessages && 
                                                    <div className='allMessagesMessageCell'>
                                                        <div className='messageCellTopView'>
                                                            <div className='messageCellTopViewCol1'>
                                                                {this.state.showMessageStatusUnread &&
                                                                    <div className='messageCellStatusUnread'>
                                                                        <img src='/assets/messageCellStatusUnread.png'/>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className='messageCellTopViewCol2'>
                                                                <h4>General Inquiry</h4>
                                                                <p>Norman Buruchara</p>
                                                                <span><label>In-App</label></span>
                                                                <span className='unresolvedIssue'><label>Unresolved</label></span>
                                                            </div>
                                                            <div className='messageCellTopViewCol3'>
                                                                <p>4:05pm</p>
                                                            </div>
                                                        </div>
                                                        <div className='messageCellTopView'>
                                                            <div className='messageCellTopViewCol1'>
                                                                {this.state.showMessageStatusUnread &&
                                                                    <div className='messageCellStatusUnread'>
                                                                        <img src='/assets/messageCellStatusUnread.png'/>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className='messageCellTopViewCol2'>
                                                                <h4>General Inquiry</h4>
                                                                <p>Norman Buruchara</p>
                                                                <span><label>In-App</label></span>
                                                                <span className='unresolvedIssue'><label>Unresolved</label></span>
                                                            </div>
                                                            <div className='messageCellTopViewCol3'>
                                                                <p>10 weeks ago</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className='customerSupportCol2'>
                                            <div className='chatWindowView'>
                                                <div className='chatWindowViewTopDetails'>
                                                    <h1>General Inquiry</h1>
                                                    <div className='chatWindowViewFrom'>
                                                        <span><label>Norman Buruchara</label></span>
                                                    </div>
                                                </div>
                                                <div className='chatWindowResolvedStatus'>
                                                    <button
                                                    >Mark as resolved </button>
                                                </div>
                                                <div className='chatWindowTextView'>
                                                    <div className='textView'>
                                                        <textarea/>
                                                    </div>
                                                    <div className='textView2'>
                                                        <textarea/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='chatTextEditorView'>
                                                <div className='chatTextEditorCol1'>
                                                    <textarea
                                                    />
                                                </div>
                                                <div className='chatTextEditorCol2'>
                                                    <button
                                                    ><strong>Send</strong></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Styles>
        )
    }
}